<template>
    <div style="position: relative" :style="{width: windowInnerWidth, height: windowInnerHeight}">

        <video style="display: none" id="video" webkit-playsinline playsinline loop>
            <source :src="publicPath + 'caption.mp4'">
        </video>

        <div style="text-align: center" id="three">

        </div>

        <div class="shopopee-chat-view" :class="shopopeeChatStatus === 'hide' ? 'shopopee-chat-view-retract' : 'shopopee-chat-view-extend'" v-show="shopopeeChatVisible === true">
            <div style="position: relative; width: 100%; height: calc(100% - 50px);margin-top: 50px;">
                <phoneDemo ref="shopopeePhone" @exec-command-complete="phoneCommandCallback" @login-complete="loginCallback" @goShopPosition="goShopPosition" @goThreeGuide="goThreeGuide"  @clickAudio="clickAudio" @returnShopopee="clickReturnShopopee" :class="shopopeeChatStatus === 'hide' ? 'hide-phone' : 'show-phone'"/>

                <div class="close-div" :class="shopopeeChatStatus === 'hide' ? 'close-div-hide' : 'close-div-show'" @click="hideShopopeeChatBox">
                    <font-awesome-icon icon="fa-solid fa-xmark" />
                </div>
            </div>
        </div>

        <!--    加载页面    -->
        <LoadingWithCar
            v-if="loadingCarViewVisible === true"
            :usePercent="usePercent"
            :useCarImg="false"
            :percent="loadingPercent"
        />

        <!--    下方的操作栏    -->
        <BottomInteraction
            :bottomUIObj="bottomUIObj"
            @clickIcon="clickInteractionCallback"
            v-show="bottomInteractionUiVisible === true"
        />

        <!--    询问框    -->
        <ConfirmComponent
            v-show="confirmVisible === true"
            :confirmText="confirmText"
            @clickSure="sureConfirm"
            @clickCancel="closeConfirm"
        />

        <!--    名片框    -->
        <CardBox
            :imgSrc="currCardSrc"
            @clickImg="goCardHref"
            @clickRequest="goCardRequest"
            @clickClose="closeCardBox"
            v-show="cardVisible === true"
        />

        <!--    聊天框    -->
        <MsgBox
            :chatPersonName="chatPersonName"
            :chatMsgText="chatMsgText"
            @clickMsgBox="clickPersonChat"
            v-show="chatVisible === true"
        />

        <!--    右上角的操作欄    -->
        <div class="interaction-ui-upperRight" v-show="upperRightUiVisible === true">

            <!--            <div class="icon-part" @click="langSelectVisible = true">-->
            <!--                <div class="icon-text">-->
            <!--                    <font-awesome-icon icon="fa-solid fa-language" />-->
            <!--                </div>-->
            <!--                <span class="icon-span" tkey="語言">{{i18n.tkey("lang_lang")}}</span>-->
            <!--            </div>-->

            <div class="icon-part" @click="goJoinMall" v-show="userInfoRef.memberStatus === -1 && hallType == '1'">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-rectangle-list" />
                </div>
                <span class="icon-span" tkey="申請入駐">{{i18n.tkey("lang_application_to")}}</span>
            </div>
<!--              聊天按鈕
            <div class="icon-part" @click="goChatView" v-show="userInfoRef.memberStatus === -1">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-comments" />
                </div>
                <span class="icon-span" tkey="聊天">{{i18n.tkey("lang_chat_text")}}</span>
            </div>-->

            <div class="icon-part" @click="goLogin" v-show="userInfoRef.memberStatus === 0">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-mobile-screen-button" />
                </div>
                <span class="icon-span" tkey="登錄">{{i18n.tkey("lang_login")}}</span>
            </div>

            <div class="icon-part" @click="goAccountView" v-show="userInfoRef.memberStatus === -1">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-mobile-screen-button" />
                </div>
                <span class="icon-span" tkey="我的手機">{{i18n.tkey("lang_my_phone")}}</span>
            </div>

            <div class="icon-part" @click="toggleScene" v-show="hid === '1'">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-left-right" />
                </div>
                <span class="icon-span" tkey="切換">{{i18n.tkey("lang_toggle")}}</span>
            </div>
        </div>

        <div class="interaction-searchInput-upperRight" v-show="upperRightUiVisible === true">
<!--
            <SearchStyleButton
                @click="clickSearchInput"
            />
-->
          <el-button type="danger" style ="padding: 0px;width: 42px;height: 42px;margin-top: -53px;background-color: #ff0000;text-shadow: 2px 2px 4px #000000;border: 2px solid #b93939;" @click="clickHallSearch" >
            <span style="text-shadow: 1px 1px 2px #000000;font-size: large;font-weight: bold;">2D</span>
          </el-button>

            <SearchStyleButton
                @click="clickSearchInput"
            />
        </div>

        <!--    左上角的操作欄    -->
        <div class="interaction-ui-upperRight interaction-ui-upperLeft" v-show="upperRightUiVisible === true">
            <!--            <div class="icon-part" @click="confirmOpenShop">-->
            <!--                <div class="icon-text">-->
            <!--                    <font-awesome-icon icon="fa-solid fa-store" />-->
            <!--                </div>-->
            <!--                <span style="pointer-events: none;">開通店鋪</span>-->
            <!--            </div>-->

            <div class="icon-part" @click="langSelectVisible = true">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-language" />
                </div>
                <span class="icon-span" tkey="語言">{{i18n.tkey("lang_lang")}}</span>
            </div>

            <div class="icon-part" v-show="!userInfoRef.vp && mallOptionVisible" @click="userInfoRef.vp = true">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-user-slash" />
                </div>
                <span class="icon-span" tkey="開啟"></span>
            </div>

            <div class="icon-part" v-show="userInfoRef.vp && mallOptionVisible" @click="userInfoRef.vp = false">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-user-astronaut" />
                </div>
                <span class="icon-span" tkey="關閉"></span>
            </div>

            <div class="icon-part" @click="clickReturnIcon">
                <div class="icon-text">
                    <font-awesome-icon icon="fa-solid fa-arrow-right-from-bracket" />
                </div>
                <span class="icon-span" tkey="返回">{{i18n.tkey("lang_return")}}</span>
            </div>

        </div>

        <div ref="operationNipple" v-show="nippleViewVisible" style="display: inline-block; width: 80px; height: 80px; position: absolute; left: 10%; bottom: 165px; opacity: 0">

        </div>

        <!--    上方的產品展示欄    -->
        <div class="show-material-ui-upper" v-if="productDisplayViewVisible">
            <threeShopMaterialGroup @clickMaterialBtn="goShopMaterialList" :materialList="showMaterialList" :titleText="showMaterialTitle"/>

            <div class="close-material-box-btn" @click="productDisplayViewVisible = false">
                <font-awesome-icon icon="fa-solid fa-xmark" />
            </div>
        </div>

        <!--        樓層選擇框         -->
        <div class="select-area-box" v-show="selectFloorVisible === true">
            <div class="select-area-div" :style="{background: `url(${publicPath}static/images/ev123.jpg)`}">
                <div class="close-material-box-btn"  @click="closeSelectFloor">
                    <font-awesome-icon icon="fa-solid fa-xmark" />
                </div>

                <ul class="select-ul">
                    <li style="margin-bottom: 20px">
                        <el-button type="info" size="large" round @click="clickReturn3DCityBtn" style="box-shadow: 0px 0px 15px 2px black;">{{i18n.tkey("lang_return_3d_city")}}</el-button>
                    </li>
                  <li style="margin-bottom: 20px" v-show="floorType === '1'">
                    <el-button type="info" size="large" round @click="clickgoMall" style="box-shadow: 0px 0px 15px 2px black;">{{i18n.tkey("lang_hall_1")}}</el-button>
                  </li>
                    <li class="title-part" style="color: #fefefe">

                        <!--                        <span style="float: right" @click="closeSelectFloor">×</span>-->
                        {{i18n.tkey("lang_select_floor_num_pls")}}
                    </li>

                    <li class="content-part">
                        <el-scrollbar>
                            <ul class="select-input-part">
                                <li>
                                    <div class="select-floor-btn-group-box">
                                        <!--                                    <div class="select-floor-btn-group" v-for="n in (Math.ceil(lastPageNum / 5))" :key="n + 'a'">-->
                                        <!--                                        <div v-for="m in lastPageNum" :key="m" :label="m" :value="m">-->
                                        <!--                                            <elevatorFloorBtn class="select-floor-btn" @click="goSelectFloor(m)" :selectTag="m == regionMap.currPage" v-if="m > (n - 1) * 5 && m <= n * 5">-->
                                        <!--                                                <span>{{m}}</span>-->
                                        <!--                                            </elevatorFloorBtn>-->
                                        <!--                                        </div>-->
                                        <!--                                    </div>-->

                                        <div v-for="n in (Math.ceil(lastPageNum / 10))" :key="n + 'a'" style="width: 110px">
                                            <div v-for="m in lastPageNum" :key="m" :label="m" :value="m">
                                                <elevatorFloorBtn class="select-floor-btn" @click="goSelectFloor(m)" :selectTag="m == regionMap.currPage" v-if="m > (n - 1) * 10 && m <= n * 10">
                                                    <span>{{m}}</span>
                                                </elevatorFloorBtn>
                                            </div>
                                        </div>


                                    </div>

                                </li>
                            </ul>
                        </el-scrollbar>

                    </li>

                    <!--                    <li class="btns-part">-->
                    <!--                        <div class="operation-box">-->
                    <!--                            <confirmButton type="success" @click="goSelectFloor">-->
                    <!--                                {{i18n.tkey("lang_sure")}}-->
                    <!--                            </confirmButton>-->

                    <!--                            <confirmButton type="danger" @click="closeSelectFloor">-->
                    <!--                                {{i18n.tkey("lang_cancel")}}-->
                    <!--                            </confirmButton>-->
                    <!--                        </div>-->
                    <!--                    </li>-->
                </ul>
            </div>
        </div>

      <el-dialog
          v-model="hallSearchVisible"
          :width="'100%'"
          align-center
          destroy-on-close
          :close-on-click-modal="false"
          :close-on-press-escape="false"
      >
        <HallSearChPage
            :hid = "props.hid"
        :materialList = "materialList"
        />
      </el-dialog>
        <el-dialog
                v-model="hallSelectorVisible"
                :title="i18n.tkey('lang_select_goto_hall')"
                :width="isMobile == true?'95%':'50%'"
                align-center
                destroy-on-close
                :before-close="goIndex"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <hallSelector @clickGo="clickGetHallData" />
        </el-dialog>


        <el-dialog
                v-model="hallShopListVisible"
                :title="i18n.tkey('lang_business_directory')"
                :width="isMobile == true?'95%':'50%'"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <HallShopList @go-shop="clickGoHall" />
        </el-dialog>

        <el-dialog
            v-model="joinMallVisible"
            :title="i18n.tkey('lang_join_mall')"
            :width="isMobile == true?'95%':'50%'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="pageInfoRef.inviteHallId = null"
        >
            <JoinMallComponents
                :mallId="pageInfoRef.inviteHallId"
                @save-complete="pageInfoRef.inviteHallId = null"
            />
        </el-dialog>

        <imgFullScreen v-if="null != previewImgUrl" :imgUrl="previewImgUrl" :titleText="previewImgTitle" :buttonText="previewBtnText" @clickClose="closeViewImg" @clickBtn="clickImgBtn" />

        <languageSelect v-if="langSelectVisible == true" :confirmFlag="true" @save-complete="langSelectVisible = false" />

        <div v-for="(value, key) in imgGenerateMap" :key="key">
            <htmlCodeImgGenerator :obj="value" @success-complete="screenShotCallback" />
        </div>

        <el-dialog
            v-model="shareUrlVisible"
            :title="i18n.tkey('lang_share')"
            :width="isMobile ? '90%' : '800px'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="shareUrl = null"
        >
            <Share3DUrl
                :url="shareUrl"
                :type="shareType"
                :linkType="shareType"
                :companycode="shareCompanycode"
            />
        </el-dialog>

        <el-dialog
            v-model="chatSelectorVisible"
            :width="isMobile ? '95%' : '60%'"
            align-center
            destroy-on-close
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="i18n.tkey('lang_select_chat_method')"
            @closed="chatCardId = null"
        >
            <ChatMethodSelector
                :cardId="chatCardId"
                @goShopopeeChat="goChatCallback"
            />
        </el-dialog>
          <el-dialog
              v-model="companySelectorVisible"
              :width="isMobile ? '95%' : '60%'"
              align-center
              destroy-on-close
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :title="i18n.tkey('lang_select_status_method')"
              @closed="seleteStor = null"
          >
            <storeWebsiteMethodSelector
                :seleteStor="seleteStor"
                @goShopopeeWebsite="gostoreWebsiteCallBack"
            />
          </el-dialog>
        <div
            class="person-editor-box"
            v-if="null != personCardObj"
        >
            <PersonEditor
                :obj="personCardObj"
                @clickClose="closePersonCardCallback"
                @goChat="personCardGoChatCallback"
                @goLogin="personCardGoLoginCallback"
                @goMaterialChat="personCardGoMaterialChatCallback"
            />
        </div>


      <div class="shopopee-chat-view" :class=" 'shopopee-chat-view-extend'" v-show="hallAIChat === true">
        <div style="position: relative; width: 100%; height: calc(100% - 50px);margin-top: 50px;
    background-color: white;">
          <div style="width:100%; padding:16px;">
          <el-text><span role="heading" aria-level="2" class="el-dialog__title">AIChat</span>
            </el-text>
            </div>
          <iframe
              v-if="myUtil.isNotEmpty(AIChatSrc)"
              width="100%"
              height="100%;"
              :src="AIChatSrc"
          ></iframe>
          <div class="close-div" :class="'close-div-show'" @click="offHallAIChat">
            <font-awesome-icon icon="fa-solid fa-xmark" />
          </div>
        </div>
      </div>

    </div>

</template>

<script setup>
    import {
        getCurrentInstance,
        onBeforeUnmount,
        onMounted,
        onBeforeMount,
        ref,
        toRef,
        provide,
        inject,
        watch,
        computed
    } from 'vue'
    import nipplejs from "nipplejs"
    import { useUserinfo } from '@/stores/userinfo'
    import { usePageinfo } from "@/stores/pageinfo";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faCommentDots, faExclamation,faComments, faChevronRight, faAddressCard, faStore, faXmark, faDollarSign, faCircleH, faMobileScreenButton, faHelicopter, faCircleInfo, faArrowRightFromBracket, faMagnifyingGlass, faVolumeHigh, faVolumeXmark, faBroom, faUserAstronaut, faElevator, faRectangleList, faLanguage, faFileInvoiceDollar, faLeftRight, faArrowUpRightFromSquare, faUserSlash } from '@fortawesome/free-solid-svg-icons'
    import { clone } from 'three/examples/jsm/utils/SkeletonUtils';
    import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader';
    import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
    import {FBXLoader} from 'three/examples/jsm/loaders/FBXLoader';
    // import Stats from "three/examples/jsm/libs/stats.module";
    import {GUI} from 'dat.gui';
    import * as TWEEN from "@tweenjs/tween.js";
    import companyApi from "@/request/companyApi";
    import hallSelector from "@/components/shopopee/hall/hallSelector"
    import phoneDemo from '@/views/phoneDemo.vue'
    import threeShopMaterialGroup from '@/components/threeShopMaterialGroup.vue'
    import {Search} from '@element-plus/icons-vue';
    import confirmButton from "@/components/Shopopee3D/ui/confirmButton"
    import HallShopList from "@/components/phone/hall/HallShopList"
    import elevatorFloorBtn from "@/components/elevatorFloorBtn"
    import imgFullScreen from "@/components/shopopee/common/imgFullScreen"
    import languageSelect from "@/components/Shopopee3D/ui/languageSelect"
    import htmlCodeImgGenerator from "@/components/Shopopee3D/generator/htmlCodeImgGenerator"
    import ConfirmComponent from "@/plugins/projectA/ui/confirmComponent.vue";
    import record12Api from "@/request/record12Api";
    import myUtil from "@/util/util";
    import {DoubleSide} from "three";
    import IslandSelect from "@/components/Shopopee3D/ui/islandSelect.vue";
    import JoinMallComponents from "@/components/shopopee/mall/joinMallComponents.vue";
    import LoadingWithCar from "@/plugins/projectA/ui/loadingWithCar.vue";
    import copy from "clipboard-copy";
    import MsgBox from "@/plugins/projectA/ui/msgBox.vue";
    import CardBox from "@/plugins/projectA/ui/cardBox.vue";
    import SearchStyleButton from "@/plugins/projectA/ui/searchStyleButton.vue";
    import BottomInteraction from "@/plugins/projectA/ui/bottomInteraction.vue";
    import Share3DUrl from "@/components/shopopee/share/share3DUrl.vue";
    import MeshReflectorMaterial from "@/plugins/projectA/resources/MeshReflectorMaterial";
    import ChatMethodSelector from "@/plugins/projectA/ui/chatMethodSelector.vue";
    import cardApi from "@/request/api";
    import PersonEditor from "@/components/person/personEditor.vue";
    import {getCountryObj} from "@/util/countrycode";
    import StoreWebsiteMethodSelector from "@/plugins/projectA/ui/storeWebsiteMethodSelector.vue";
    import HallSearChPage from "@/views/hallSearchPage.vue";
    import baseUrl from "@/request/base";

    //导入图标
    library.add(faCommentDots,faExclamation, faComments, faChevronRight, faAddressCard, faStore, faXmark, faDollarSign, faCircleH, faMobileScreenButton, faHelicopter, faCircleInfo, faArrowRightFromBracket, faMagnifyingGlass, faVolumeHigh, faVolumeXmark, faBroom, faUserAstronaut, faElevator, faRectangleList, faLanguage, faFileInvoiceDollar, faLeftRight, faArrowUpRightFromSquare, faUserSlash)

    const props = defineProps(["hid", "fid", "did"])

    const reload = inject("reload")
    const i18n = inject("i18n")

    watch(() => props.hid, (newValue, oldValue) => {
        location.reload()
    });

    //创建stats对象
    // const stats = new Stats();
    // stats.domElement:web页面上输出计算结果,一个div元素，
    // document.body.appendChild(stats.domElement);

    let { proxy } = getCurrentInstance();
    let THREE = proxy.$THREE;

    const publicPath = process.env.BASE_URL

    const userinfo = useUserinfo()
    const userInfoRef = toRef(userinfo)
    const pageInfoRef = toRef(usePageinfo())

    //是否是從個人展館返回
    let fromPEFlag = false

    //是否顯示語言選擇框
    const langSelectVisible = ref(false)
    //是否显示市场选择框
    const hallSelectorVisible = ref(false)
    //需要全屏查看的圖片
    const previewImgUrl = ref(null)
    //全屏查看圖片的title
    const previewImgTitle = ref(null)
    //全屏查看圖片button的text
    const previewBtnText = ref(null)
    //全屏查看的圖片展位號
    let previewImgDoor = null

    //全屏查看圖片button的text
    const hallAIChat = ref(false)
    const AIChatSrc = ref("")

    const floorType = ref(0)

    //是否在移動
    let moveFlag = false
    //移動方向
    const moveVector3 = new THREE.Vector3()
    moveVector3.normalize()
    //方向增量
    const numVector3 = new THREE.Vector3()
    //操作列表
    const operationObj = {
        "w": false,
        "d": false,
        "s": false,
        "a": false,
    }

    //Y轴向量
    const yAxis = new THREE.Vector3(0,1,0)

    //模型朝向
    const faceVector3 = new THREE.Vector3()

    //移动速度上限 (秒)
    let MAXSPEED = process.env.NODE_ENV === 'production' ? userInfoRef.value.speed : userInfoRef.value.speed;
    //当前移动速度
    let speed = 0
    //移動速度增量 (秒)
    const speedAddSize = 0.6
    //移動速度減量 (秒)
    const speedMinusSize = 1.2
    //移动射线
    // const moveRaycaster = new THREE.Raycaster()
    //移動計時
    let moveTimeStamp = 0
    //鼠标按下计时
    let mouseDownTimeStamp = 0

    //全局环境贴图
    let sceneEnvironmentMap
    let sceneEnvironmentMap3
    let testEnvMap

    let testBox

    //rotation角度
    let rotationNum = Math.PI / -2
    //rotation角度 上下
    let rotationNumY = 0

    const width = window.innerWidth
    const height = window.innerHeight
    const windowInnerWidth = ref((window.innerWidth) + "px")
    const windowInnerHeight = ref((window.innerHeight) + "px")

    //加载百分比
    let loadingPercent = ref(0)
    //是否顯示百分比
    const usePercent = ref(true)

    let animationFrameId

    // 3D场景对象Scene
    let scene
    //渲染器
    let render
    //摄像机
    let camera
    //天空盒攝像機
    let cubeCamera

    const clock = new THREE.Clock();
    const FPS = 30; // 指的是 30帧每秒的情况
    const singleFrameTime = (1/FPS);
    let timeStamp = 0
    // let currTimeStamp = 0
    let mixerUpdateDelta;

    //每次渲染要執行的邏輯方法列表
    let funcListObj = {}
    //重新加载时需要删除的模型
    let clearMeshList = []
    //重新加载时需要删除的数据
    let clearDataList = []
    //重新加載時需要刪除的材質
    let clearMaterialList = []
    //要關閉AI的對象
    let clearAIList = []

    //觸發區域對象
    const triggerAreaMap = {

    }

    //當前執行的動作
    let activeAction;
    //上一個執行的動作
    let previousAction;

    //岛列表
    const islandList = []
    //地面
    let groundMesh = null

    //店铺Group map
    let shopPointMap = {}
    //当前展馆信息
    let hallObjInfo = {}
    //當前展館類型
    const hallType = ref("0")
    //楼层和门牌号映射的map
    let regionMap = {
        currPage: 1,
        lastPage: 1,
        selectShopIndex: null,
        shopMap: {},
    }
    let logoDataList = {}
    //所有動作
    let allActions ;

    //纹理贴图加载器TextureLoader
    const texLoader = new THREE.TextureLoader();

    const gltfLoader = new GLTFLoader();
    const fbxLoader = new FBXLoader();
    const dracoLoader = new DRACOLoader();

    const isMobile = ('ontouchstart' in document.documentElement)
    let mousedownFlag = false
    let touchPoint = null
    //是否按下搖桿
    let nippleFlag = false
    //是否开始渲染
    let renderFlag = true

    //是否可操作
    let controlFlag = false
    //操作模式
    let operateMode = "normal"

    //搖桿對象
    let nippleObj = null

    //可交互对象列表
    let interactionList = []
    //可交互對象映射對象
    const interactionObj = {
        // "UUID": [{
        //     mesh: null,
        //     callback: null
        // }]
    }

    //拥有ai的对象
    const WithAIObjSet = {

    }

    //动作列表
    const mixerObj = {

    }

    let MAX_POSITION_X = 29
    let MIN_POSITION_X = -29
    let MAX_POSITION_Z = 33.8
    let MIN_POSITION_Z = -43.8

	// MAX_POSITION_X = 27
	// MIN_POSITION_X = -27
	// MAX_POSITION_Z = 13.8
	// MIN_POSITION_Z = -73.5

    //动画对象
    const animationObjGroup = {}

    //人对象组
    const meshGroup = new THREE.Group()
    const headGroup = new THREE.Group()

    const cameraOptionObj = {
        //默认的第一人稱镜头距离
        defaultFirstCameraDistance: 0.1,
        //默认的第三人稱镜头距离
        defaultThirdCameraDistance: 3,
        //默认的镜头距离
        defaultCameraDistance: 0.1,
        //当前的镜头距离
        currCameraDistance: 0.1,
        //是否改变了镜头距离
        changeCameraDistance: false,
        //默认的镜头高度
        defalutCameraPositionY: 1.6,
        //当前的镜头高度
        currCameraPositionY: 1.6,
        //是否改变了镜头高度
        changeCameraPostionY: false,
        //默認鏡頭視點高度
        defaultLookAtPosition: 1.6,
        //默認鏡頭視點高度
        currLookAtPosition: 1.6,
    }

    //加载过的物件
    const loadObj = {}
    //是否正在加载fbx模型
    let fbxLoadFlag = false
    //fbx模型的加载队列
    const fbxLoadQueue = []
    //是否正在加载glb模型
    let glbLoadFlag = false
    //glb模型的加载队列
    const glbLoadQueue = []

    //主角模型
    let model

    //空氣墻列表
    const airWallList = {

    }

    //是否显示标题界面
    const titleViewVisible = ref(true)

    //环境光
    let ambient = new THREE.AmbientLight(0xffffff, 1.5);

    // const router = useRouter()
    // const route = useRoute()

    //是否显示下方的操作栏
    const bottomInteractionUiVisible = ref(false)
    //是否顯示右上角的操作欄
    const upperRightUiVisible = ref(false)
    //是否顯示搖桿
    const nippleViewVisible = ref(true)
    //下方的互动选项
    const bottomUIObj = ref({})

    //是否顯示上方的產品展示欄
    const productDisplayViewVisible = ref(false)
    //產品展示欄展示的產品列表
    const showMaterialList = ref([])
    //產品展示欄的標題
    const showMaterialTitle = ref(i18n.tkey("lang_shop_item_1"))
    //展示店鋪的數據對象
    const showMaterialShopdata = ref(null)

    //提示文字
    let confirmText = ref("")
    //是否提示可见
    let confirmVisible = ref(false)
    //確定按鈕綁定的方法
    let confirmFunc
    //取消按鈕綁定的方法
    let cancelFunc

    //当前显示的对话文字
    let chatMsgText = ref("")
    //当前对话对方的名字
    let chatPersonName = ref("")
    //对话框点击方法
    let chatClickFunc
    //是否对话框可见
    let chatVisible = ref(false)
    //对话列表
    let chatMsgList
    //当前对话序号
    let chatMsgIndex

    //是否显示聊天窗口
    let shopopeeChatVisible = ref(false)
    let shopopeeChatStatus = ref("hide")


    //直升機加載切換頁
    const loadingCarViewVisible = ref(true)

    //是否顯示新手教程
    const guideViewVisible = ref(false)

    //名片图片链接
    const currCardSrc = ref("")
    //是否显示名片框
    const cardVisible = ref(false)
    //名片跳转链接
    let cardHref
    //名片id
    let cardId

    //对话之前的镜头位置
    let beforeCameraPosition
    //对话之前的镜头旋转
    let beforeCameraRotation
    //对话之前镜头焦点
    let beforeCameraUp
    //触发对话的对象
    let chatTargetObject

    let hallFloorPadMesh = null

    //是否顯示選擇區域頁面
    const selectFloorVisible = ref(false)
    //最後一個區的區號
    const lastPageNum = ref(1)
    //選擇的區號
    const selectFloorNum = ref(1)
    //是否顯示企業名錄彈窗
    const hallShopListVisible = ref(false)

    //條幅mesh列表
    let shopAdMeshList = []
    //需要生成圖片的對象
    const imgGenerateMap = ref({})

    //展位門口的廣告牌
    let hallDoorAdvList = []

    let shop_top_texture;

    //切换楼层时要移动到的坐标
    let moveFloorPosition = {
        x: 16.5,
        y: 5,
        z: 0
    }

    const joinMallVisible = computed(() => {
        return loadingPercent.value >= 100 && null != pageInfoRef.value.inviteHallId && null != userInfoRef.value.acccompanycode
    })

    const shareUrlVisible = ref(false)
    const shareUrl = ref(null)
    const shareType = ref("0")
    const shareCompanycode = ref(null)

    //網站選擇框可見
    const companySelectorVisible = ref(false)
    //聊天選擇框可見
    const chatSelectorVisible = ref(false)
    //聊天名片id
    const chatCardId = ref(null)

    //聊天名片id
    const seleteStor = ref(null)

    //名片列表
    let allCardList = []
    //选定的名片
    const personCardObj = ref(null)

    //是否顯示商場選項
    const mallOptionVisible = ref(false)

    const hallSearchVisible = ref(false)

    let materialList = []


    function initValue() {
        dracoLoader.setDecoderPath(`${process.env.BASE_URL}static/js/draco/`)
        dracoLoader.setDecoderConfig({ type: 'js' });
        dracoLoader.preload();
        gltfLoader.setDRACOLoader(dracoLoader)


        funcListObj['updateTween'] = updateTween
        funcListObj['updateAIObj'] = updateAIObj
        funcListObj['checkTriggerMap'] = checkTriggerMap
        funcListObj['checkInteractionObj'] = checkInteractionObj

        scene = new THREE.Scene()
        // camera = new THREE.PerspectiveCamera(45, 8.0 / 5.0, 0.1, 600)
        const fov = isMobile ? 60 : 45

        THREE.ColorManagement.enabled = true;

        camera = new THREE.PerspectiveCamera(fov, 8.0 / 3.0, 0.11, 700)
        camera.aspect = (window.innerWidth) / (window.innerHeight);
        camera.updateProjectionMatrix();
        render = new THREE.WebGLRenderer({
            // logarithmicDepthBuffer: true, // 设置对数深度缓冲区，优化深度冲突问题
            antialias: true, //开启抗锯齿,
            alpha: true,
            precision: 'mediump',
            powerPreference: "high-performance",
        })

        render.gammaInput = true;
        render.gammaOutput = true;//inear转gamma
        render.toneMapping = THREE.ACESFilmicToneMapping
        render.outputColorSpace = THREE.SRGBColorSpace
        render.useLegacyLights = true

        render.setPixelRatio(window.devicePixelRatio); //设置屏幕像素比
        // render.setPixelRatio(1); //设置屏幕像素比
        render.setClearColor(0x000000, 1); //设置背景色

        // initPage()
        getHallData()
    }
    function offHallAIChat(){
       hallAIChat.value = false

      bottomInteractionUiVisible.value = true
      upperRightUiVisible.value = true
      nippleViewVisible.value = true

      controlFlag = true
      }
    function initPage() {
        if (hallObjInfo.addinfo17 === "1"||hallObjInfo.addinfo24 ==="2"){
            mallOptionVisible.value = true

            cameraOptionObj.defaultLookAtPosition = 1.6
            cameraOptionObj.currLookAtPosition = 1.6
            cameraOptionObj.defalutCameraPositionY = 1.6
            cameraOptionObj.currCameraPositionY = 1.6

            // MAX_POSITION_Z -= 30
            // MIN_POSITION_Z -= 30

            MAX_POSITION_X = 27
            MIN_POSITION_X = -27
            MAX_POSITION_Z = 43.8
            MIN_POSITION_Z = -43.5

            airWallList["Escalator_1"] = {
                MAX_POSITION_X: -9.9,
                MIN_POSITION_X: -15.14,
                MAX_POSITION_Z: 0.25,
                MIN_POSITION_Z: -6.13
            }

            airWallList["Elevator_1"] = {
                MAX_POSITION_X: 14,
                MIN_POSITION_X: 9.8,
                MAX_POSITION_Z: 2.15,
                MIN_POSITION_Z: -2.3
            }

            airWallList["Shop_wall_1"] = {
                MAX_POSITION_X: 27,
                MIN_POSITION_X: 13,
                MAX_POSITION_Z: -34.6,
                MIN_POSITION_Z: -43.44
            }

            airWallList["Shop_wall_2"] = {
                MAX_POSITION_X: -13,
                MIN_POSITION_X: -27,
                MAX_POSITION_Z: -34.6,
                MIN_POSITION_Z: -43.44
            }

            airWallList["Shop_wall_3"] = {
                MAX_POSITION_X: 26.9,
                MIN_POSITION_X: 21.4,
                MAX_POSITION_Z: 43.8,
                MIN_POSITION_Z: -35.6
            }

            airWallList["Shop_wall_4"] = {
                MAX_POSITION_X: -21.4,
                MIN_POSITION_X: -26.9,
                MAX_POSITION_Z: 43.8,
                MIN_POSITION_Z: -35.6
            }

            airWallList["Shop_wall_5"] = {
                MAX_POSITION_X: 21.4,
                MIN_POSITION_X: -21.4,
                MAX_POSITION_Z: 44,
                MIN_POSITION_Z: 35.9
            }
        }
		else if(hallObjInfo.addinfo17 !="1"&&hallObjInfo.addinfo10 === "0"){
			airWallList["Shop_wall_6"] = {
                MAX_POSITION_X: 27,
                MIN_POSITION_X: 3,
                MAX_POSITION_Z: -33,
                MIN_POSITION_Z: -44
			}
			// airWallList["Shop_wall_7"] = {
            //     MAX_POSITION_X: -3,
            //     MIN_POSITION_X: -27,
            //     MAX_POSITION_Z: -33,
            //     MIN_POSITION_Z: -36
			// }

		}

        if (isMobile){
            document.getElementById("three").addEventListener('touchmove', handleDefaultTouchEvt, {passive: false})
        }

        //創建搖桿
        var options = {
            zone: proxy.$refs.operationNipple,
            mode: 'static',
            position: {left: '50%', top: '50%'},
            // color: 'gray',
            color: 'red',
            size: window.innerWidth > 768 ? 120 : 120,
            threshold: 0.1
        }

        const manager = nipplejs.create(options);
        nippleObj = manager

        // manager.on('dir', function (evt, data) {
        //     console.log(data)
        //     // Do something.
        // });

        nippleObj.on('start', function (evt, data) {
            // console.log(data)

            if (!controlFlag){
                return;
            }

            // mousedownFlag = true
            // moveFlag = true
            nippleFlag = true

        });

        nippleObj.on('move', function (evt, data) {
            // console.log(data)
            // console.log(data.angle.radian)

            // evt.preventDefault()

            if (!controlFlag){
                return;
            }

            if (operateMode === "watch"){

                funcListObj["moveCameraFunc_1"] = () => {
                    rotationNum += data.vector.x * 0.02 * 30 * mixerUpdateDelta
                    rotationNumY += data.vector.y * 0.005 * 30 * mixerUpdateDelta

                    calcCameraPosition()
                }

            }else{
                if ((data.angle.radian > Math.PI / 180 * 45 && data.angle.radian < Math.PI / 180 * 135) || (data.angle.radian > Math.PI / 180 * 225 && data.angle.radian < Math.PI / 180 * 315)){

                    if (null != funcListObj["moveCameraFunc_1"]){
                        delete funcListObj["moveCameraFunc_1"]
                    }

                    mousedownFlag = true
                    moveFlag = true

                    moveVector3.x = 0 - camera.position.x
                    moveVector3.y = 0
                    moveVector3.z = 0 - camera.position.z

                    moveVector3.normalize()
                    moveVector3.applyAxisAngle(yAxis, data.angle.radian - Math.PI / 2)

                }else{
                    mousedownFlag = false
                    moveFlag = false

                    if (data.angle.radian > Math.PI / 180 * 135 && data.angle.radian < Math.PI / 180 * 225){
                        funcListObj["moveCameraFunc_1"] = () => {
                            rotationNum -= data.distance / 50 * 0.02 * 30 * mixerUpdateDelta

                            calcCameraPosition()
                        }
                    }else{
                        funcListObj["moveCameraFunc_1"] = () => {
                            rotationNum += data.distance / 50 * 0.02 * 30 * mixerUpdateDelta

                            calcCameraPosition()
                        }
                    }
                }
            }

            // moveVector3.x = data.vector.x * -1
            // moveVector3.y = 0
            // moveVector3.z = data.vector.y

            // moveVector3.x = 0 - camera.position.x
            // moveVector3.y = 0
            // moveVector3.z = 0 - camera.position.z
            //
            // moveVector3.normalize()
            //
            // moveVector3.applyAxisAngle(yAxis, data.angle.radian - Math.PI / 2)

        });

        nippleObj.on('end', function (evt, data) {
            // console.log(data)

            mousedownFlag = false
            moveFlag = false
            touchPoint = null
            nippleFlag = false

            delete funcListObj["moveCameraFunc_1"]
        });

        proxy.$refs.operationNipple.style.opacity = 0
        // proxy.$refs.operationNipple.style.display = "none"

        //創建島
        if(hallObjInfo.addinfo17 === "1"||hallObjInfo.addinfo24 ==="2"){
            createIsland2()
            getCardListFunc()
        }else if(hallObjInfo.addinfo17 != "1"&&hallObjInfo.addinfo24 !="2"&&hallObjInfo.addinfo10 === "0"){
			createIsland3()
		}else{
            createIsland()
        }

        //创建地面
        // createGround()

        //加入对象组
        scene.add(meshGroup)

        //造人
        createMan()
        // createMan2()

        meshGroup.add(camera)
        camera.position.set(0,5,-16);
        camera.lookAt(new THREE.Vector3(0,5,0));

        // let gui = new GUI()
        // gui.add(camera.position, "x").step(1)
        // gui.add(camera.position, "y").step(1)
        // gui.add(camera.position, "z").step(1)


        // let gui2 = new GUI()
        // gui2.add(camera.rotation, "x").step(0.01)
        // gui2.add(camera.rotation, "y").step(0.01)
        // gui2.add(camera.rotation, "z").step(0.01)

        //添加环境光
        scene.add(ambient);

        // 添加太陽光
        // directionalLight.castShadow = true

        // directionalLight.shadow.mapSize.width = 2048;
        // directionalLight.shadow.mapSize.height = 2048;
        //
        // directionalLight.shadow.camera.left = - 200;
        // directionalLight.shadow.camera.right = 200;
        // directionalLight.shadow.camera.top = 100;
        // directionalLight.shadow.camera.bottom = - 100;
        //
        // directionalLight.shadow.camera.far = 500;

        //加載天空盒
        const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256 );
        cubeCamera = new THREE.CubeCamera( 0.1, 1000, cubeRenderTarget)

        let environmentMap = new THREE.CubeTextureLoader().load( [
            process.env.BASE_URL + "mytextures/skt/px.jpg",
            process.env.BASE_URL + "mytextures/skt/nx.jpg",
            process.env.BASE_URL + "mytextures/skt/py.jpg",
            process.env.BASE_URL + "mytextures/skt/ny.jpg",
            process.env.BASE_URL + "mytextures/skt/pz.jpg",
            process.env.BASE_URL + "mytextures/skt/nz.jpg"], function (cubeTexture) {

            sceneEnvironmentMap = environmentMap
            scene.background = cubeTexture;

            cubeCamera.update( render, scene );

        } );

        // let environmentMap3 = new THREE.CubeTextureLoader().load( [
        //     process.env.BASE_URL + "mytextures/hallcube/px.png",
        //     process.env.BASE_URL + "mytextures/hallcube/nx.png",
        //     process.env.BASE_URL + "mytextures/hallcube/py.png",
        //     process.env.BASE_URL + "mytextures/hallcube/ny.png",
        //     process.env.BASE_URL + "mytextures/hallcube/pz.png",
        //     process.env.BASE_URL + "mytextures/hallcube/nz.png"], function ( cubeTexture ) {
        //
        //     sceneEnvironmentMap3 = environmentMap3
        //
        // } );

        let environmentMap2 = new THREE.CubeTextureLoader().load( [
            process.env.BASE_URL + "mytextures/sky2/posx.jpg",
            process.env.BASE_URL + "mytextures/sky2/negx.jpg",
            process.env.BASE_URL + "mytextures/sky2/posy.jpg",
            process.env.BASE_URL + "mytextures/sky2/negy.jpg",
            process.env.BASE_URL + "mytextures/sky2/posz.jpg",
            process.env.BASE_URL + "mytextures/sky2/negz.jpg"], function (cubeTexture) {

            testEnvMap = environmentMap2

        } );


        render.setSize(width, height);
        render.shadowMap.enabled = true //渲染器開啟陰影渲染
        render.shadowMap.type = THREE.PCFSoftShadowMap;
        render.render(scene, camera);

        document.getElementById("three").innerHTML = ""
        document.getElementById("three").appendChild(render.domElement);

        //监听鼠标、键盘事件
        document.addEventListener( 'keydown', onKeyDown );
        document.addEventListener( 'keyup', onKeyUp );

        if (isMobile){
            document.getElementById("three").addEventListener("touchmove", mouseMoveEvent)

            document.getElementById("three").addEventListener("touchstart", mouseDownEvent)

            document.getElementById("three").addEventListener("touchend", mouseUpEvent)

        }else{
            document.getElementById("three").addEventListener("mousemove", mouseMoveEvent)

            document.getElementById("three").addEventListener("mousedown", mouseDownEvent)

            document.getElementById("three").addEventListener("mouseup", mouseUpEvent)

            document.getElementById("three").addEventListener("click", mouseClickEvent)
        }
    }

    //触摸事件处理
    function handleDefaultTouchEvt(evt) {
        // if(!shopopeeChatVisible.value && !selectFloorVisible.value && !hallSelectorVisible.value && !hallShopListVisible.value){
        evt.preventDefault()
        // }
    }

    //切換動作
    function toggleActiveMotion(name){
        activeAction.paused = true
        previousAction = activeAction
        activeAction = allActions[name];
        activeAction.reset().play();

        previousAction.crossFadeTo( activeAction, 0.25 )
    }

    function onKeyDown( event ) {
        if (!controlFlag){
            return;
        }

        if (null != event && (event.code != 'KeyW' && event.code != 'KeyS' && event.code != 'KeyA' && event.code != 'KeyD' && event.code != 'ArrowUp' && event.code != 'ArrowDown' && event.code != 'ArrowLeft' && event.code != 'ArrowRight' )){
            return
        }

        if ( null != event || (operationObj.w || operationObj.s || operationObj.a || operationObj.d) ){
            camera.getWorldDirection(numVector3)
        }

        numVector3.setY(0)

        if (null != event ){
            switch ( event.code ) {

                case 'ArrowUp':
                case 'KeyW':
                    if (!operationObj.w){
                        operationObj.w = true
                    }

                    moveFlag = true

                    break;

                case 'ArrowDown':
                case 'KeyS':
                    if (!operationObj.s){
                        operationObj.s = true
                    }

                    moveFlag = true

                    break;

                // case 'ArrowLeft':
                case 'KeyA':
                    if (!operationObj.a){
                        operationObj.a = true
                    }

                    moveFlag = true

                    break;

                // case 'ArrowRight':
                case 'KeyD':
                    if (!operationObj.d){
                        operationObj.d = true
                    }

                    moveFlag = true

                    break;

                case 'ArrowLeft':
                    funcListObj["moveCameraFunc_1"] = () => {
                        rotationNum -=  0.02 * 30 * mixerUpdateDelta

                        calcCameraPosition()
                    }
                    break;

                case 'ArrowRight':
                    funcListObj["moveCameraFunc_1"] = () => {
                        rotationNum +=  0.02 * 30 * mixerUpdateDelta

                        calcCameraPosition()
                    }
                    break;

                // case 'KeyC': controls.crouch = true; break;
                // case 'Space': controls.jump = true; break;
                // case 'ControlLeft':
                // case 'ControlRight': controls.attack = true; break;

            }
        }



        if (operationObj.w){

        }

        if (operationObj.s){
            numVector3.negate()
        }

        if (operationObj.a){
            if (operationObj.w){
                numVector3.applyAxisAngle(yAxis,Math.PI/4)
            }else if(operationObj.s){
                numVector3.applyAxisAngle(yAxis,Math.PI/4 * -1)
            }else{
                numVector3.applyAxisAngle(yAxis,Math.PI/2)
            }

        }

        if (operationObj.d){

            if (operationObj.w){
                numVector3.applyAxisAngle(yAxis,Math.PI/4 * -1)
            }else if(operationObj.s){
                numVector3.applyAxisAngle(yAxis,Math.PI/4)
            }else{
                numVector3.applyAxisAngle(yAxis,Math.PI/2 * -1)
            }

        }

        moveVector3.copy(numVector3)

        // moveFlag = true

    }

    //按键抬起
    function onKeyUp( event ) {

        switch ( event.code ) {

            case 'ArrowUp':
            case 'KeyW':
                if (operationObj.w){
                    operationObj.w = false
                    onKeyDown()
                }
                break;

            case 'ArrowDown':
            case 'KeyS':
                if (operationObj.s){
                    operationObj.s = false
                    onKeyDown()
                }
                break;

            // case 'ArrowLeft':
            case 'KeyA':
                if (operationObj.a){
                    operationObj.a = false
                    onKeyDown()
                }
                break;

            // case 'ArrowRight':
            case 'KeyD':
                if (operationObj.d){
                    operationObj.d = false
                    onKeyDown()
                }
                break;

            case 'ArrowLeft':
                delete funcListObj["moveCameraFunc_1"]
                break;

            case 'ArrowRight':
                delete funcListObj["moveCameraFunc_1"]
                break;
        }

        if ( !(operationObj.w || operationObj.s || operationObj.a || operationObj.d) ){
            moveFlag = false
            numVector3.set(0, 0, 0)
        }

    }

    //人物移动方法
    function movePerson(){
        if (moveFlag || speed > 0){
            const currAddSize = mixerUpdateDelta * speedAddSize
            const currMinusSize = mixerUpdateDelta * speedMinusSize
            moveVector3.normalize()

            if (moveFlag){
                speed += currAddSize

                if (speed >= userInfoRef.value.speed){
                    speed = userInfoRef.value.speed
                }
            }else{
                speed *= 0.96
                speed -= currMinusSize

                if (speed < 0.06){
                    speed = 0
                    moveVector3.set(0, 0, 0)
                    toggleActiveMotion("idle")
                }
            }

            let timeScale = speed / 0.06
            const currMoveSpeed = speed * 60 * mixerUpdateDelta

            if (speed > 0.12){
                timeScale = 1
                timeScale += (speed - 0.12) / 14.0

                if (activeAction._clip.name == "walk"){
                    toggleActiveMotion("running")
                }
            }else if (speed > 0 && speed <= 1.2){
                timeScale = 1

                if (activeAction._clip.name == "running"){
                    toggleActiveMotion("walk")
                }else if (activeAction._clip.name == "idle"){
                    toggleActiveMotion("walk")
                }
            }

            activeAction.timeScale = timeScale

            meshGroup.translateOnAxis(moveVector3, currMoveSpeed);

            let xnum2 = meshGroup.position.x + 1 * moveVector3.getComponent(0)
            let znum2 = meshGroup.position.z + 1 * moveVector3.getComponent(2)

            testBox.getWorldDirection(faceVector3)

            if (speed > 0){
                testBox.lookAt(xnum2, meshGroup.position.y, znum2)
            }

            for (const key in airWallList){
                const v = airWallList[key]
                const flagX1 = meshGroup.position.x < v.MAX_POSITION_X
                const flagX2 = meshGroup.position.x > v.MIN_POSITION_X

                const flagZ1 = meshGroup.position.z < v.MAX_POSITION_Z
                const flagZ2 = meshGroup.position.z > v.MIN_POSITION_Z
				// console.log(key)
				// console.log("flagX1: " + flagX1+ ",flagX2:" + flagX2+ ",flagZ1:" + flagZ1+ ",flagZ2:" + flagZ2)
                if (flagX1 && flagX2 && flagZ1 && flagZ2){

                    // if (Math.abs(v.MAX_POSITION_X - meshGroup.position.x) < Math.abs(v.MIN_POSITION_X - meshGroup.position.x)){
                    //     meshGroup.position.x = v.MAX_POSITION_X + 0.2
                    // }else{
                    //     meshGroup.position.x = v.MIN_POSITION_X - 0.2
                    // }

                    let minX = null
                    let minZ = null
                    let min = null

                    const distanceX1 = Math.abs(v.MAX_POSITION_X - meshGroup.position.x)
                    const distanceX2 = Math.abs(v.MIN_POSITION_X - meshGroup.position.x)

                    const distanceZ1 = Math.abs(v.MAX_POSITION_Z - meshGroup.position.z)
                    const distanceZ2 = Math.abs(v.MIN_POSITION_Z - meshGroup.position.z)

                    minX = distanceX1 < distanceX2 ? distanceX1 : distanceX2
                    minZ = distanceZ1 < distanceZ2 ? distanceZ1 : distanceZ2
                    min = minX < minZ ? minX : minZ
                    min = min * -1 - 0.2
                    meshGroup.translateOnAxis(moveVector3, min);
                    // if (Math.abs(v.MAX_POSITION_Z - meshGroup.position.z) < Math.abs(v.MIN_POSITION_Z - meshGroup.position.z)){
                    //     meshGroup.position.z = v.MAX_POSITION_Z + 0.2
                    // }else{
                    //     meshGroup.position.z = v.MIN_POSITION_Z - 0.2
                    // }
                }
            }

            if (meshGroup.position.x > MAX_POSITION_X){
                meshGroup.position.x = MAX_POSITION_X - 0.2
            }

            if (meshGroup.position.x < MIN_POSITION_X){
                meshGroup.position.x = MIN_POSITION_X + 0.2
            }

            if (meshGroup.position.z > MAX_POSITION_Z){
                meshGroup.position.z = MAX_POSITION_Z - 0.2
            }

            if (meshGroup.position.z < MIN_POSITION_Z){
                meshGroup.position.z = MIN_POSITION_Z + 0.2
            }

            moveTimeStamp += mixerUpdateDelta

            if (moveTimeStamp > 1.0){
                moveTimeStamp = moveTimeStamp % 1.0
            }

            if (rotationNumY !== 0){
                rotationNumY = 0
                calcCameraPosition()
            }

            // console.log("x: " + meshGroup.position.x + " ,z: " + meshGroup.position.z)
        }
    }

    //更新播放动作方法
    function updateMixerByTime(){
        //播放动画
        for (let i in mixerObj){
            mixerObj[i].update( mixerUpdateDelta );
        }
    }

    function getMousePosition(e, objList = islandList){
        const obj = {
            position: null,
            direction: null,
            intersects: []
        }

        let px
        let py

        if (isMobile){
            try {
                px = e.touches[0].clientX - 10;
                py = e.touches[0].clientY - 10;
            }catch (e) {
                return
            }
        }else{
            px = e.clientX - 10;
            py = e.clientY - 10;
        }

        //屏幕坐标px、py转标准设备坐标x、y
        //width、height表示canvas画布宽高度
        const x = (px / width) * 2 - 1;
        const y = -(py / height) * 2 + 1;

        //创建一个射线投射器`Raycaster`
        const raycaster = new THREE.Raycaster();

        raycaster.setFromCamera(new THREE.Vector2(x, y), camera);

        // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
        const intersects = raycaster.intersectObjects(objList);

        if (intersects != null && intersects.length > 0){
            obj.intersects = intersects
            obj.position = intersects[0].point
        }

        if (obj.intersects.length > 0){
            const point = obj.intersects[0].point
            const vec3 = new THREE.Vector3()

            vec3.x = point.x - meshGroup.position.x
            vec3.z = point.z - meshGroup.position.z

            vec3.normalize()
            obj.direction = vec3
        }else{
            obj.direction = raycaster.ray.direction
        }



        return obj
    }

    function createMan() {
        let fileName = process.env.BASE_URL + "mymodels/fbx/town2/boy21.fbx"
        // // let fileName = process.env.BASE_URL + "mymodels/fbx/manp.fbx"
        //
        // if ( userInfoRef.value.modelSex === 1 ){
        //     fileName = process.env.BASE_URL + "mymodels/fbx/town2/woman.fbx"
        // }
        //
        // if (null != userInfoRef.value.memmale && null == userInfoRef.value.modelSex){
        //     if (userInfoRef.value.memmale == 0){
        //         fileName = process.env.BASE_URL + "mymodels/fbx/town2/boy21.fbx"
        //         userInfoRef.value.modelSex = 0
        //     }else{
        fileName = process.env.BASE_URL + "mymodels/fbx/town2/woman.fbx"
        // userInfoRef.value.modelSex = 1
        //     }
        // }

        loadLeadModel(fileName, true)

        //临时放置
        meshGroup.visible = false
        cameraOptionObj.defaultCameraDistance = cameraOptionObj.defaultFirstCameraDistance
        cameraOptionObj.currCameraDistance = cameraOptionObj.defaultFirstCameraDistance
        camera.far = 400
        camera.updateProjectionMatrix()

        // toggleActiveMotion("idle")
        // rotationNum = camera.rotation.y
        rotationNum = 4.69

        const positionX = 0
        const positionY = cameraOptionObj.defalutCameraPositionY
        const positionZ = - cameraOptionObj.defaultCameraDistance

        const rotationX = 0 - Math.PI
        const rotationY = 0
        const rotationZ = Math.PI

        camera.position.x = positionX
        camera.position.y = positionY
        camera.position.z = positionZ

        camera.rotation.x = rotationX
        camera.rotation.y = rotationY
        camera.rotation.z = rotationZ

        controlFlag = true
        nippleViewVisible.value = true
        proxy.$refs.operationNipple.style.display = "block"

        renderFrame()
    }

    function loadLeadModel(fileName, initFlag = false) {
        fbxLoader.load(fileName, (fbx) => {
            // fbx.children[1].material.shininess = 0
            // const material = new THREE.MeshLambertMaterial({})
            // material.copy(fbx.children[1].material)
            // fbx.children[1].material = material

            model = fbx;
            testBox = model
            //放大縮小
            let box3 = new THREE.Box3()
            let obj = new THREE.Vector3()
            let scaleNum
            box3.setFromObject(model)
            box3.getSize(obj)

            scaleNum = 2.6 / obj.getComponent(1)

            let vector = new THREE.Vector3(scaleNum, scaleNum, scaleNum);
            model.scale.multiply(vector);

            box3.setFromObject(model)
            box3.getSize(obj)

            model.position.x = 0
            model.position.y = 0
            model.position.z = 0

            meshGroup.add( model );

            model.traverse( function ( object ) {

                if ( object.isMesh ) {
                    object.castShadow = true;

                    object.material.emissive = new THREE.Color(1,1,1);
                    object.material.emissiveIntensity = 1;
                    object.material.emissiveMap = object.material.map;
                }

                if (object.name === "ashangshen"){
                    object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
                }

                if (object.name === "asjiao"){
                    object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
                    // const material = new THREE.MeshLambertMaterial()
                    // material.copy(object.material)
                    // object.material = material
                    // object.material.color = new THREE.Color(0, 0, 1)
                    // object.material.shininess = 0
                }

                if (object.name === "astui"){
                    object.material.color = new THREE.Color(Math.random(), Math.random(), Math.random())
                }

                if (object.name === "toufa"){
                    const material = new THREE.MeshLambertMaterial()
                    material.copy(object.material)
                    object.material = material
                }
            } );

            //动作
            const mixer = new THREE.AnimationMixer( model );
            mixerObj[meshGroup.id] = mixer
            //注册动作播放方法
            funcListObj['updateMixerByTime'] = updateMixerByTime

            allActions = {};

            let animations = fbx.animations;

            //遍歷所有動作
            for ( let i = 0; i !== animations.length; ++ i ) {
                //動作
                const clip = animations[ i ];
                const action = mixer.clipAction( clip );
                allActions[clip.name ] = action;

            }

            activeAction = allActions['idle'];
            activeAction.play();

            //将头加入到人物
            meshGroup.add(headGroup)
            headGroup.position.setY(2.5)

            //將燈光綁定到人物
            // meshGroup.add(directionalLight)
            // const lightPoint = new THREE.Group()
            // meshGroup.add(lightPoint)
            // lightPoint.position.set(50, 0, 50)
            // directionalLight.position.set(0, 50, 0)
            // directionalLight.target = lightPoint

            //注册改变太阳光焦点方法
            // funcListObj['changeSunLightTarget'] = () => {
            //     directionalLight.target = lightPoint
            // }

            renderFlag = true

            if (initFlag){
                loadingPercent.value += 10
                loadLeadModelCallback()
            }

        })
    }

    function loadLeadModelCallback() {
        //注册人物移动方法
        funcListObj['movePerson'] = movePerson

        meshGroup.position.set(0, 0, -40.5)
		if(hallObjInfo.addinfo17 != "1"&&hallObjInfo.addinfo24
        !="2"&&hallObjInfo.addinfo10 === "0"){
			meshGroup.position.set(-26, 0, -40.5)
			// meshGroup.rotation.y =  Math.PI /2
			rotationNum = Math.PI
		}
        calcCameraPosition()

        proxy.$refs.operationNipple.style.display = "block"

        // loadingPercent.value += 5

        controlFlag = true

        // setTimeout(() => {
        //     loadingCarViewVisible.value = false
        //     proxy.$refs.operationNipple.style.opacity = 1
        //     bottomInteractionUiVisible.value = true
        //     upperRightUiVisible.value = true
        //
        //     if (null != regionMap.selectShopIndex){
        //         movePersonToShopPosition(regionMap.selectShopIndex)
        //         regionMap.selectShopIndex = null
        //     }
        //
        //     toggleSelectFloorBox(true)
        //
        //     saveShopVisits()
        // }, 1500)


        renderFrame()
    }

    function mouseDownEvent(e){
        if (!controlFlag){
            return;
        }

        mouseDownTimeStamp = new Date().getTime()

        // if (!isMobile){
            mousedownFlag = true
        // }

        // moveFlag = true
        //
        if (isMobile){
            if (null == e.touches){
                return
            }

            touchPoint = e.touches[0]
        }
        //
        // var obj = getMousePosition(e)
        //
        // obj.direction.setY(0)
        // moveVector3.copy(obj.direction)
    }

    function mouseUpEvent(e){
        if (isMobile){
            if (controlFlag){
                const temp = {
                    touches: [
                        touchPoint
                    ]
                }
                mouseClickEvent(temp)
            }
        }

        mousedownFlag = false
        moveFlag = false
        touchPoint = null
    }

    function mouseMoveEvent(e){
        if (!mousedownFlag)
            return

        if (!controlFlag){
            return;
        }

        // if (isMobile && operateMode != "watch"){
        //     return;
        // }

        // if (nippleFlag){
        //     return;
        // }

        if (isMobile){
            if (null == e.changedTouches){
                return
            }

            rotationNum -= (touchPoint.clientX - e.changedTouches[0].clientX) / 300;
            rotationNumY -= (touchPoint.clientY - e.changedTouches[0].clientY) / -1200;
            touchPoint = e.changedTouches[0]
        }else{
            rotationNum += e.movementX / 300;
            rotationNumY -= e.movementY / 1200;
        }

        //如果改变了镜头距离
        if (cameraOptionObj.changeCameraDistance){
            cameraOptionObj.changeCameraDistance = false

            const tween = new TWEEN.Tween(cameraOptionObj)
                .to({currCameraDistance: cameraOptionObj.defaultCameraDistance}, 5000)
                .start()
                .easing(TWEEN.Easing.Sinusoidal.InOut)
                .onComplete(() => {
                    delete animationObjGroup["changeCameraDistance"]
                })
                .onUpdate(() => {
                    let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
                    let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;

                    camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
                    // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
                    camera.lookAt(new THREE.Vector3(meshGroup.position.x,cameraOptionObj.currLookAtPosition,meshGroup.position.z));
                })

            animationObjGroup["changeCameraDistance"] = tween
        }

        //如果改变了镜头高度
        if (cameraOptionObj.changeCameraPostionY){
            cameraOptionObj.changeCameraPostionY = false

            const tween = new TWEEN.Tween(cameraOptionObj)
                .to({currCameraPositionY: cameraOptionObj.defalutCameraPositionY}, 5000)
                .start()
                .easing(TWEEN.Easing.Sinusoidal.InOut)
                .onComplete(() => {

                    delete animationObjGroup["changeCameraPostionY"]
                })
                .onUpdate(() => {
                    camera.position.y = cameraOptionObj.currCameraPositionY
                })

            animationObjGroup["changeCameraPostionY"] = tween
        }

        // let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
        // let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;
        //
        // camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
        // // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
        // camera.lookAt(new THREE.Vector3(meshGroup.position.x,2.5,meshGroup.position.z));

        calcCameraPosition()

        // var obj = getMousePosition(e)
        //
        // obj.direction.setY(0)
        // moveVector3.copy(obj.direction)
        //
        // // 将局部坐标转换为世界坐标
        // let v = new THREE.Vector3()
        // camera.localToWorld(v);

        // clearRam()

    }

    function calcCameraPosition() {
        // if (operateMode === "watch" || !isMobile){
            if (rotationNumY > 0.25){
                rotationNumY = 0.25
            }

            if (rotationNumY < -0.25){
                rotationNumY = -0.25
            }

            let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
            let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;

            camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
            // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
            camera.lookAt(new THREE.Vector3(meshGroup.position.x,cameraOptionObj.currLookAtPosition + rotationNumY,meshGroup.position.z));
        // }else{
        //     let camera_x = cameraOptionObj.currCameraDistance * Math.cos(-rotationNum);
        //     let camera_z = cameraOptionObj.currCameraDistance * Math.sin(-rotationNum) * -1;
        //
        //     camera.position.set(camera_x, cameraOptionObj.currCameraPositionY, camera_z);
        //     // camera.lookAt(new THREE.Vector3(0,100,camera_z * -1 - 200));
        //     camera.lookAt(new THREE.Vector3(meshGroup.position.x,cameraOptionObj.currLookAtPosition,meshGroup.position.z));
        // }
    }

    function mouseClickEvent(e){
        if (!controlFlag){
            return;
        }

        if (null != previewImgUrl.value){
            return;
        }

        if (new Date().getTime() - mouseDownTimeStamp > 1000){
            return;
        }

        const obj = getMousePosition(e, interactionList)

        if (null == obj){
            return;
        }

        if (obj.intersects != null && obj.intersects.length > 0){
            const intersect = obj.intersects[0]
            if (intersect.distance < 30){
                const uuid = intersect.object.uuid
                const temp = interactionObj[uuid]

                if (temp.length > 0){
                    for (const item in temp){
                        const obj = temp[item]
                        if (obj != null && null != obj.callback && typeof obj.callback === "function"){
                            obj.callback()
                        }
                    }
                }else{
                    if (temp != null && null != temp.callback && typeof temp.callback === "function"){
                        temp.callback()
                    }
                }
            }
        }
    }

    function renderFrame() {
        // stats.update();
        mixerUpdateDelta = clock.getDelta()

        if (loadingPercent.value > 39 &&loadingPercent.value < 100){
            loadingPercent.value += 1
        }
        else if (loadingPercent.value == 100){
            usePercent.value = false
            loadingPercent.value += 1

            setTimeout(() => {
                loadingCarViewVisible.value = false
                proxy.$refs.operationNipple.style.opacity = 1
                bottomInteractionUiVisible.value = true
                upperRightUiVisible.value = true

                if (null != regionMap.selectShopIndex){
                    goNextRegion()
                    // movePersonToShopPosition(regionMap.selectShopIndex)
                    regionMap.selectShopIndex = null
                }

                if (null == props.fid && !fromPEFlag){
                    toggleSelectFloorBox(true)
                }

                saveShopVisits()
            }, 250)
        }



        //更新时间戳
        if (renderFlag){
            for (const v in funcListObj){
                if (typeof funcListObj[v] === "function"){
                    funcListObj[v]()
                }
            }
        }

        // getSceneModelFaceNum(scene)
        timeStamp += mixerUpdateDelta;
        if (timeStamp > singleFrameTime) {
            //更新地面
            if (null != groundMesh){
                groundMesh.material.update()
            }

            render.render(scene, camera)

            //渲染
            // 剩余的时间合并进入下次的判断计算 这里使用取余数是因为 当页页面失去焦点又重新获得焦点的时候，delta数值会非常大， 这个时候就需要
            timeStamp = (timeStamp % singleFrameTime);

        }

        animationFrameId = requestAnimationFrame(renderFrame)

    }

    //創建島
    function createIsland(){
        loadGlbModel("island/pav/pavilion.gltf",{
            // loadFbxModel("island/pav/pavilion.fbx", {
            // positionX: -12,
            positionY: 0,
            // positionZ: -30,
            scaleY: 30,
            loadCallback: (gltf,model) => {

                model.traverse( function ( object ) {

                    if ( object.isMesh ) {
                        object.material.emissive = null;
                        object.material.emissiveIntensity = 0;
                        object.material.emissiveMap = null;

                    }
                    if(object.name == "qiangzhu"){
                        const obj1 = {
                            color:0x00A3ED,
                        }

                        object.material.color.set(obj1.color);

                        // object.material.emissiveIntensity = 1
						// object.material.colorSpace = THREE.NoColorSpace
						// object.material.map.colorSpace = THREE.SRGBColorSpace
						// object.material.map.colorSpace = THREE.LinearSRGBColorSpace

							// const textures = texLoader.load(publicPath + "mymodels/gltf/island/pav/floor_01.jpg", (texture) => {
							// 	texture.colorSpace = THREE.SRGBColorSpace

							// });
							// const material = new THREE.MeshBasicMaterial({ //普通材质
							//     // color: 0xffffff,
							//     map: texture,
							// });

							// object.material = material

							// object.material.needsUpdate = true
						// console.log(object)

                    }
                    if(object.name == "screen-ad"){

                        //加载视频
                        let video = document.getElementById("video");
                        const shopopeeAdsPlaneTex = new THREE.VideoTexture(video);
                        shopopeeAdsPlaneTex.center.set(0.6, 0.5)
                        shopopeeAdsPlaneTex.flipY  = false
                        // shopopeeAdsPlaneTex.rotation =  -Math.PI /2
                        const shopopeeAdsMaterial = new THREE.MeshBasicMaterial({ //普通材质
                            // color: 0xffffff,//0xff0000设置材质颜色为红色
                            map: shopopeeAdsPlaneTex,
                            // side: THREE.DoubleSide
                        });
                        object.material = shopopeeAdsMaterial

                    }

                    if (object.name == "door_off"){
                        const vec3 = new THREE.Vector3()
                        object.getWorldPosition(vec3)

                        // vec3.x /= 50
                        // vec3.z /= 50
                        vec3.y = 0

                        triggerAreaMap[object.uuid] = {
                            scope: {
                                MAX_POSITION_X: vec3.x + 5.5,
                                MIN_POSITION_X: vec3.x - 5.5,
                                MAX_POSITION_Z: vec3.z +1,
                                MIN_POSITION_Z: vec3.z ,
                            },
                            alive: false,
                            timer: 0.5,
                            timeLimit: 0.5,
                            func: () => {
                                meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);

                                // selectFloorVisible.value = true
                                toggleSelectFloorBox(true)

                            }
                        }
                        // clearDataList.push({"key": object.uuid, map: triggerAreaMap})
                    }

                    if (object.name.indexOf("shop_") != -1){
                        shopPointMap[object.name.replaceAll("shop_", "")] = {
                            positionObj: object,
                            shopmanPositionObj: null,
                            shopObj: null,
                            shopman: null
                        }

                    }
                    if(object.name.indexOf("shoplogo_") != -1){
                        logoDataList[object.name] = object
                    }

                    if (object.name.indexOf("clerk") != -1){
                        const key = object.name.replaceAll("clerk", "")
                        shopPointMap[key].shopmanPositionObj = object
                    }

                    //創建展館招牌
                    if (object.name == 'aiqiang_title'){
                        createHallNamePad(object)
                    }

                    //創建展館樓層標識
                    if (object.name == 'aiqiang_num'){
                        hallFloorPadMesh = object
                        createFloorNamePad()
                    }

                    //电梯方法
                    if (object.name == 'elevator'){
                        // interactionObj[object.uuid] = [{
                        //     distance: 4,
                        //     icon: "fa-solid fa-elevator",
                        //     // name: shopData.companyName,
                        //     name: i18n.tkey("lang_elevator"),
                        //     // mesh: shopList[index].children[0],
                        //     mesh: object,
                        //     callback: () => {
                        //         toggleSelectFloorBox(true)
                        //     }
                        // }]

                        const vec3 = new THREE.Vector3()
                        object.getWorldPosition(vec3)

                        triggerAreaMap[object.uuid] = {
                            scope: {
                                MAX_POSITION_X: vec3.x + 3,
                                MIN_POSITION_X: vec3.x - 3,
                                MAX_POSITION_Z: vec3.z + 1,
                                MIN_POSITION_Z: vec3.z ,
                            },
                            alive: false,
                            timer: 0.5,
                            timeLimit: 0.5,
                            func: () => {
                                meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);

                                toggleSelectFloorBox(true)
                            }
                        }
                    }

                    //招牌替換
                    if (object.name== 'exhibitionimg'){
                        let filename = null

                        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                            filename = hallObjInfo.addinfo11
                        }else{
                            filename = hallObjInfo.addinfo12
                        }

                        if (null == filename){
                            object.visible = false
                        }

                        const texture = texLoader.load(filename);
                        const material = new THREE.MeshBasicMaterial({ //普通材质
                            // color: 0xffffff,
                            map: texture,
                        });

                        texture.flipY = false


                        object.material = material
                        object.material.emissiveIntensity = 0;
                        object.material.lightMap = texture

                        object.__deleteTag__ = false
                        interactionList.push(object)
                        interactionObj[object.uuid] = [{
                            callback: () => {
                                goViewImg(proxy.$ShopopeeUrl + filename)
                            }
                        }]
                    }

                    //創建迎賓員
                    if (object.name == "shopman_02"){
                        createUsher(object)
                    }

                    //替換屋頂上的條幅
                    if (object.name.indexOf("shopad") != -1){
                        shopAdMeshList.push(object)
                    }

                    //更換門口的廣告牌
                    if (object.name.indexOf("Billboard_ad_0") != -1){
                        hallDoorAdvList.push(object)
                    }

                } );

                createShopAdMaterial()
                createShopAndMan()
                loadHallDoorAdvImg()

                loadingPercent.value += 5

            },
            callback: (group) => {
                // group.scale.x = 0.02
                // group.scale.y = 0.02
                // group.scale.z = 0.02

                scene.add(group)
                islandList.push(group)

                var video = document.getElementById("video");
                video.volume = 0
                video.muted = true
                try{
                    video.play()
                }catch(e){
                    console.log(e)
                }

            }
        })


    }
 //切換模型3
    function createIsland3(){
        loadGlbModel("island/pav/pavilion3.gltf",{
            // loadFbxModel("island/pav/pavilion.fbx", {
            // positionX: -12,
            positionY: 0,
            // positionZ: -30,
            scaleY: 30,
            loadCallback: (gltf,model) => {

                model.traverse( function ( object ) {

                    if ( object.isMesh ) {
                        object.material.emissive = null;
                        object.material.emissiveIntensity = 0;
                        object.material.emissiveMap = null;

                    }
					if(object.name == "qiang_glass2"){

						// console.log(object.material)
						// object.material.transparent = true
						// object.material.opacity = 0.6
						// object.material.color = new THREE.Color(1, 1, 1)
						const material = new THREE.MeshPhysicalMaterial({
                            color: 0xffffff,
                            metalness:0.25,
                            roughness:0,
                            emissive:0x333333,
                            transmission:1.0,
						});
						object.material = material

						// console.log(object.material)
					}
					if(object.name == "pingtai_glass"||object.name == "pingtai_glass2"){
						// object.material.opacity = 0.5
						// object.material.color = new THREE.Color(0, 1, 1)
						// object.material.transparent = true
						const material = new THREE.MeshPhysicalMaterial({
                            color: 0xffffff,
                            metalness:0.25,
                            roughness:0,
                            transmission:1.0,
                            emissiveMap:testEnvMap,
                            envMap:testEnvMap,
                            map:object.material.map
						});
						object.material = material

						// console.log(object.material)
					}if(object.name == "top"){



						// object.material.emissiveIntensity = 1
						object.material.opacity = 0.1
						object.material.transparent = true
						// object.material.envMapIntensity = 1
						// object.material.envMap = material.map
						// object.material.lightMapIntensity=1
						// object.material.lightMap = object.material.map
						// object.material.emissiveMap = texture

					}
                    if(object.name == "screen-ad"){

                        //加载视频
                        let video = document.getElementById("video");
                        const shopopeeAdsPlaneTex = new THREE.VideoTexture(video);
                        shopopeeAdsPlaneTex.center.set(0.6, 0.5)
                        shopopeeAdsPlaneTex.flipY  = false
                        // shopopeeAdsPlaneTex.rotation =  -Math.PI /2
                        const shopopeeAdsMaterial = new THREE.MeshBasicMaterial({ //普通材质
                            // color: 0xffffff,//0xff0000设置材质颜色为红色
                            map: shopopeeAdsPlaneTex,
                            // side: THREE.DoubleSide
                        });
                        object.material = shopopeeAdsMaterial

                    }

                    if (object.name == "door"){
                        const vec3 = new THREE.Vector3()
                        object.getWorldPosition(vec3)

                        // vec3.x /= 50
                        // vec3.z /= 50
                        vec3.y = 0

                        triggerAreaMap[object.uuid] = {
                            scope: {
                                MAX_POSITION_X: vec3.x + 1,
                                MIN_POSITION_X: vec3.x - 1,
                                MAX_POSITION_Z: vec3.z +5.5,
                                MIN_POSITION_Z: vec3.z -5.5,
                            },
                            alive: false,
                            timer: 0.5,
                            timeLimit: 0.5,
                            func: () => {
                                meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);
								// console.log(moveVector3)
                                // selectFloorVisible.value = true
                                toggleSelectFloorBox(true)

                            }
                        }
                        // clearDataList.push({"key": object.uuid, map: triggerAreaMap})
                    }

                    if (object.name.indexOf("shop_") != -1){
                        shopPointMap[object.name.replaceAll("shop_", "")] = {
                            positionObj: object,
                            shopmanPositionObj: null,
                            shopObj: null,
                            shopman: null
                        }

                    }
                    if(object.name.indexOf("shoplogo_") != -1){
                        logoDataList[object.name] = object
                    }

                    if (object.name.indexOf("clerk") != -1){
                        const key = object.name.replaceAll("clerk", "")
                        shopPointMap[key].shopmanPositionObj = object
                    }

                    //創建展館招牌
                    if (object.name == 'aiqiang_title'){
                        createHallNamePad(object)
                    }

                    //創建展館樓層標識
                    if (object.name == 'aiqiang_num'){
                        hallFloorPadMesh = object
                        createFloorNamePad()
                    }

                    //电梯方法
                    if (object.name == 'elevator'){
                        // interactionObj[object.uuid] = [{
                        //     distance: 4,
                        //     icon: "fa-solid fa-elevator",
                        //     // name: shopData.companyName,
                        //     name: i18n.tkey("lang_elevator"),
                        //     // mesh: shopList[index].children[0],
                        //     mesh: object,
                        //     callback: () => {
                        //         toggleSelectFloorBox(true)
                        //     }
                        // }]

                        const vec3 = new THREE.Vector3()
                        object.getWorldPosition(vec3)

                        triggerAreaMap[object.uuid] = {
                            scope: {
                                MAX_POSITION_X: vec3.x + 3,
                                MIN_POSITION_X: vec3.x - 3,
                                MAX_POSITION_Z: vec3.z + 1,
                                MIN_POSITION_Z: vec3.z -1,
                            },
                            alive: false,
                            timer: 0.5,
                            timeLimit: 0.5,
                            func: () => {
                                meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);
								console.log(moveVector3)
                                toggleSelectFloorBox(true)
                            }
                        }
                    }

                    //招牌替換
                    if (object.name== 'exhibitionimg'){
                        let filename = null

                        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                            filename = hallObjInfo.addinfo11
                        }else{
                            filename = hallObjInfo.addinfo12
                        }

                        if (null == filename){
                            object.visible = false
                        }

                        const texture = texLoader.load(filename);
                        const material = new THREE.MeshBasicMaterial({ //普通材质
                            // color: 0xffffff,
                            map: texture,
                        });

                        texture.flipY = false


                        object.material = material
                        object.material.emissiveIntensity = 0;
                        object.material.lightMap = texture

                        object.__deleteTag__ = false
                        interactionList.push(object)
                        interactionObj[object.uuid] = [{
                            callback: () => {
                                goViewImg(proxy.$ShopopeeUrl + filename)
                            }
                        }]
                    }

                    //創建迎賓員
                    if (object.name == "shopman_02"){
                        createUsher(object)
                    }

                    //替換屋頂上的條幅
                    if (object.name.indexOf("shopad") != -1){
                        shopAdMeshList.push(object)
                    }

                    //更換門口的廣告牌
                    if (object.name.indexOf("Billboard_ad_0") != -1){
                        hallDoorAdvList.push(object)
                    }

                } );

                createShopAdMaterial()
                createShopAndMan()
                loadHallDoorAdvImg()

                loadingPercent.value += 5

            },
            callback: (group) => {
                // group.scale.x = 0.02
                // group.scale.y = 0.02
                // group.scale.z = 0.02

                scene.add(group)
                islandList.push(group)

                var video = document.getElementById("video");
                video.volume = 0
                video.muted = true
                try{
                    video.play()
                }catch(e){
                    console.log(e)
                }

            }
        })


    }

    //創建商場
    function createIsland2(){
        loadGlbModel("island/pav/pavilion2.gltf",{
            positionY: 0,
            scaleY: 30,
            loadCallback: (gltf,model) => {
                // model.position.z = -30

                //创建地面
                createGround(model)

                model.traverse( function ( object ) {

                    // if ( object.isMesh ) {
                    //     object.material.emissive = null;
                    //     object.material.emissiveIntensity = 0;
                    //     object.material.emissiveMap = null;
                    //
                    // }

                    //地面倒影
                    // if(object.name == "floor"||object.name == "floor2"){
                        // object.material.envMap = sceneEnvironmentMap
                        // object.material.reflectivity = 0.33
                        // object.visible = false
                        // const map = texLoader.load(publicPath + "mymodels/gltf/island/pav/floor_01.jpg", (texture) => {
                        //
                        //     const newMaterial = new THREE.MeshLambertMaterial()
                        //     newMaterial.copy(object.material)
                        //
                        //     texture.colorSpace = THREE.SRGBColorSpace
                        //
                        //     // object.material.map = texture
                        //     newMaterial.emissive = new THREE.Color(1, 1, 1);
                        //     newMaterial.emissiveIntensity = 1;
                        //     newMaterial.emissiveMap = texture;
                        //
                        //     object.material = newMaterial
                        // })

                    // }
                    if(object.name == "floor"){
                        object.material.envMap = sceneEnvironmentMap
                        object.material.reflectivity = 0.33
                        // object.visible = false
                        // const map = texLoader.load(publicPath + "mymodels/gltf/island/pav/floor_01.jpg", (texture) => {
                        //
                        //     const newMaterial = new THREE.MeshLambertMaterial()
                        //     newMaterial.copy(object.material)
                        //
                        //     texture.colorSpace = THREE.SRGBColorSpace
                        //
                        //     // object.material.map = texture
                        //     newMaterial.emissive = new THREE.Color(1, 1, 1);
                        //     newMaterial.emissiveIntensity = 1;
                        //     newMaterial.emissiveMap = texture;
                        //
                        //     object.material = newMaterial
                        // })

                    }

					if(object.name == "stage_1"){

						    object.material.envMap = sceneEnvironmentMap
						    object.material.reflectivity = 0.33
					}

					if(object.name == "screen"){

					  object.position.set(10000, 10000, 10000);

					}

					if(object.name == "handescalator_floor"){

                       object.material.map.wrapS = object.material.map.wrapT = THREE.RepeatWrapping;
                       // shop_top_texture.center.set(0.5, 0.5)
                       funcListObj[`handescalator_floor`] = () => {
                           object.material.map.offset.y -= 0.0001
                           // shop_top_texture.offset.y += 0.00005
                       	// shop_top_texture.rotation += 0.0001
                       }

                    }

					if(object.name == "handescalator_floor2"){
						const newmaterial = object.material.clone()
						object.material = newmaterial
						const newMap = object.material.map.clone()
						object.material.map = newMap
					   object.material.map.wrapS = object.material.map.wrapT = THREE.RepeatWrapping;
					   // shop_top_texture.center.set(0.5, 0.5)
					   funcListObj[`handescalator_floor2`] = () => {
					       object.material.map.offset.y += 0.0001
					       // shop_top_texture.offset.y += 0.00005
					   	// shop_top_texture.rotation += 0.0001
					   }

					}

                    if(object.name == "zhu_elevator"){
                        object.material.transparent = true
                        object.material.opacity = 0.8
                        object.material.colorSpace = THREE.SRGBColorSpace

                    }
                    if(object.name == "qiang_glass2"){

                        const material = new THREE.MeshPhysicalMaterial({
                            color: 0xffffff,
                            metalness:0.25,
                            roughness:0,
                            emissive:0x333333,
                            transmission:1.0,
                        });
                        object.material = material

                    }
                    if(object.name == "pingtai_glass"||object.name == "pingtai_glass2"){

                        const material = new THREE.MeshPhysicalMaterial({
                            color: 0xffffff,
                            metalness:0.25,
                            roughness:0,
                            transmission:1.0,
                            // emissiveMap:testEnvMap,
                            envMap:testEnvMap,
                            map:object.material.map
                        });
                        object.material = material

                    }if(object.name == "top"){

                        object.material.opacity = 0.1
                        object.material.transparent = true

                    }
                    if(object.name == "qiangzhu"){

                    }
                    if(object.name == "screen-ad"){

                        //加载视频
                        let video = document.getElementById("video");
                        const shopopeeAdsPlaneTex = new THREE.VideoTexture(video);
                        shopopeeAdsPlaneTex.center.set(0.6, 0.5)
                        shopopeeAdsPlaneTex.flipY  = false
                        // shopopeeAdsPlaneTex.rotation =  -Math.PI /2
                        const shopopeeAdsMaterial = new THREE.MeshBasicMaterial({ //普通材质
                            // color: 0xffffff,//0xff0000设置材质颜色为红色
                            map: shopopeeAdsPlaneTex,
                            // side: THREE.DoubleSide
                        });
                        object.material = shopopeeAdsMaterial

                    }

                    if (object.name == "door_off"){

                        const vec3 = new THREE.Vector3()
                        object.getWorldPosition(vec3)

                        vec3.y = 0

                        // let boxGeometry = new THREE.BoxGeometry(12, 4, 4)
                        // let lambertMaterial = new THREE.MeshBasicMaterial({
                        //     color: 0xff0000
                        // })
                        //
                        // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
                        // scene.add(mesh)
                        //
                        // mesh.position.x = vec3.x
                        // mesh.position.z = vec3.z

                        triggerAreaMap[object.uuid] = {
                            scope: {
                                MAX_POSITION_X: vec3.x + 6,
                                MIN_POSITION_X: vec3.x - 6,
                                MAX_POSITION_Z: vec3.z + 2,
                                MIN_POSITION_Z: vec3.z - 2,
                            },
                            alive: false,
                            timer: 0.5,
                            timeLimit: 0.5,
                            func: () => {
                                meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);

                                moveFloorPosition.x = 16.5
                                moveFloorPosition.y = 5
                                moveFloorPosition.z = 0

                                toggleSelectFloorBox(true)

                            }
                        }
                        // clearDataList.push({"key": object.uuid, map: triggerAreaMap})
                    }

                    if (object.name.indexOf("shop_") != -1){
                        let key = ""

                        key = object.name.replaceAll("shop_1_", "")

                        shopPointMap[key] = {
                            positionObj: object,
                            shopmanPositionObj: null,
                            shopObj: null,
                            shopman: null
                        }

                    }
                    if(object.name.indexOf("shoplogo_") != -1){
                        logoDataList[object.name] = object
                    }

                    if (object.name.indexOf("clerk") != -1){
                        let key = ""

                        if (object.name.indexOf("clerk_1") != -1){
                            key = object.name.replaceAll("clerk_1_", "")
                        }else{
                            key = object.name.replaceAll("clerk_2_", "")
                            key = "shop_2_" + key
                        }

                        // if(key<21){
                            shopPointMap[key].shopmanPositionObj = object
                        // }
                    }

                    //創建展館招牌
                    if (object.name == 'aiqiang_title'){
                        createHallNamePad(object)
                    }

                    //創建展館樓層標識
                    if (object.name == 'aiqiang_num'){
                        hallFloorPadMesh = object
                        createFloorNamePad()
                    }

                    //电梯方法
                    if (object.name == 'elevator'){
                        const vec3 = new THREE.Vector3()
                        object.getWorldPosition(vec3)

                        // let boxGeometry = new THREE.BoxGeometry(3, 4, 3)
                        // let lambertMaterial = new THREE.MeshBasicMaterial({
                        //     color: 0xff0000
                        // })
                        //
                        // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
                        // scene.add(mesh)
                        //
                        // mesh.position.x = vec3.x
                        // mesh.position.z = vec3.z
                        //
                        // const mesh2 = new THREE.Mesh(boxGeometry, lambertMaterial)
                        // scene.add(mesh2)
                        //
                        // mesh.position.x = vec3.x
                        // mesh.position.y = 5
                        // mesh.position.z = vec3.z

                        triggerAreaMap[object.uuid] = {
                            scope: {
                                MAX_POSITION_X: vec3.x + 1.5,
                                MIN_POSITION_X: vec3.x - 1.5,
                                MAX_POSITION_Z: vec3.z + 1.5,
                                MIN_POSITION_Z: vec3.z - 1.5,
                            },
                            alive: false,
                            timer: 0.5,
                            timeLimit: 0.5,
                            func: () => {
                                meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);

                                moveFloorPosition.x = 16.5
                                moveFloorPosition.y = 5
                                moveFloorPosition.z = 0

                                toggleSelectFloorBox(true)
                            }
                        }
                    }

                    //扶梯方法
                    if (object.name == 'triggerswitch_1_01'){
                        const vec3 = new THREE.Vector3()
                        object.getWorldPosition(vec3)

                        triggerAreaMap[object.uuid] = {
                            scope: {
                                MAX_POSITION_X: vec3.x + 4,
                                MIN_POSITION_X: vec3.x - 2.5,
                                MAX_POSITION_Z: vec3.z + 1.5,
                                MIN_POSITION_Z: vec3.z - 1.5,
                            },
                            alive: false,
                            timer: 0.5,
                            timeLimit: 0.5,
                            func: () => {
                                meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);

                                moveFloorPosition.x = -18
                                moveFloorPosition.y = 5
                                moveFloorPosition.z = 7.3

                                toggleSelectFloorBox(true)
                            }
                        }
                    }

                    if (object.name == 'triggerswitch_2_01_2'){
                        const vec3 = new THREE.Vector3()
                        object.getWorldPosition(vec3)

                        triggerAreaMap[object.uuid] = {
                            scope: {
                                MAX_POSITION_X: vec3.x + 1.5,
                                MIN_POSITION_X: vec3.x - 1.5,
                                MAX_POSITION_Z: vec3.z + 1.5,
                                MIN_POSITION_Z: vec3.z - 1.5,
                            },
                            alive: false,
                            timer: 0.5,
                            timeLimit: 0.5,
                            func: () => {
                                if (regionMap.currPage > 1){
                                    meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);

                                    moveFloorPosition.x = -18
                                    moveFloorPosition.y = 5
                                    moveFloorPosition.z = 7.2

                                    toggleSelectFloorBox(true)
                                }
                            }
                        }
                    }

                    //招牌替換
                    if (object.name== 'exhibitionimg'){
                        let filename = null

                        if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                            filename = hallObjInfo.addinfo11
                        }else{
                            filename = hallObjInfo.addinfo12
                        }

                        if (null == filename){
                            object.visible = false
                        }

                        const texture = texLoader.load(filename);
                        texture.colorSpace = THREE.SRGBColorSpace
                        const material = new THREE.MeshBasicMaterial({ //普通材质
                            // color: 0xffffff,
                            map: texture,
                        });

                        texture.flipY = false
                        texture.generateMipmaps = false

                        object.material = material
                        object.material.emissiveIntensity = 0;
                        // object.material.lightMap = texture

                        object.__deleteTag__ = false
                        interactionList.push(object)
                        interactionObj[object.uuid] = [{
                            callback: () => {
                                goViewImg(proxy.$ShopopeeUrl + filename)
                            }
                        }]
                    }

                    //創建迎賓員
                    if (object.name == "shopman_01"){
                        if ("0" == hallObjInfo.addinfo19.mode){
                            createUsher(object)
                        }
                    }

                    //創建迎賓員
                    // if (object.name == "shopman_02"){
                    //     createUsher(object)
                    // }

                    //替換屋頂上的條幅
                    if (object.name.indexOf("shopad") != -1){
                        shopAdMeshList.push(object)
                    }

                    //更換門口的廣告牌
                    if (object.name.indexOf("Billboard_ad_0") != -1){
                        hallDoorAdvList.push(object)
                    }

                    //创建服务台
                    if (object.name.indexOf("severdesk") != -1){
                        if ("0" == hallObjInfo.addinfo19.mode){
                            loadServeDesk(object)
                        }

                    }

                    //T台
                    if (object.name == "Runway"){
                        if ("2" != hallObjInfo.addinfo19.mode){
                            object.visible = false
                        }
                    }

                    //話筒
                    if (object.name == "Microphone"){
                        if ("1" != hallObjInfo.addinfo19.mode){
                            object.visible = false
                        }
                    }

                    //舞台
                    if (object.name == "stage"){
                        if ("0" == hallObjInfo.addinfo19.mode){
                            object.visible = false
                        }else{
                            createStageContent(object)
                        }
                    }

                    //舞台背景
                    if (object.name == "Partition_2"){
                        if (myUtil.isEmpty(hallObjInfo.addinfo19.stageBackground)){
                            texLoader.load(publicPath + "mymodels/gltf/island/pav/stage_background0.jpg", (texture) => {
                                texture.flipY = false
                                texture.colorSpace = THREE.SRGBColorSpace
                                object.material.map = texture
                            })
                        }else{
                            texLoader.load(hallObjInfo.addinfo19.stageBackground, (texture) => {
                                texture.flipY = false
                                texture.colorSpace = THREE.SRGBColorSpace
                                object.material.map = texture
                            })
                        }
                    }

                } );

                createShopAdMaterial()
                createShopAndMan2()
                loadHallDoorAdvImg()

                loadingPercent.value += 5

            },
            callback: (group) => {
                scene.add(group)
                islandList.push(group)

                var video = document.getElementById("video");
                video.volume = 0
                video.muted = true
                try{
                    video.play()
                }catch(e){
                    console.log(e)
                }

            }
        })

    }

    //加载glb模型
    function loadGlbModel(modelName, option = {}) {
        let deleteFlag = true

        if (glbLoadFlag){
            glbLoadQueue.push(() => {
                loadGlbModel(modelName, option)
            })
            return
        }else{
            if (glbLoadQueue.length == 0){
                deleteFlag = false
            }

            glbLoadFlag = true
        }

        let optionObj = {
            positionX: 0,
            positionY: 0,
            positionZ: 0,
            scaleY: 0,
            rotateX: 0,
            rotateY: 0,
            rotateZ: 0,
            castShadow: false,
            receiveShadow: false,
            //加载模型成功后的回调
            loadCallback: null,
            //执行结束后的回调
            callback: null,
            //是否缓存加载的模型
            cache: true
        }

        optionObj = Object.assign(optionObj, option);

        const ObjGroup = new THREE.Group()

        //如果在缓存中没有该模型,加载模型
        if (null == loadObj[modelName]){
            //同步加载，避免出现同时加载多个时null
            const promiseHander = new Promise((resolve, reject) =>{
                gltfLoader.load( process.env.BASE_URL + `mymodels/gltf/${modelName}?r=${proxy.$versionNum}`, function ( gltf ) {

                    if (optionObj.cache){
                        loadObj[modelName] = gltf
                        // model = model.clone()
                        loadObj[modelName].scenes = []
                        const modelData = loadObj[modelName].scene
                        loadObj[modelName].scene = null

                        const copyObj = Object.assign({}, loadObj[modelName])
                        copyObj.scene = clone(modelData)
                        loadObj[modelName].scene = modelData

                        gltf = copyObj
                    }

                    let model = gltf.scene;

                    optionObj["format"] = "gltf"

                    handleModel(model, optionObj)

                    ObjGroup.add(model)

                    if (typeof optionObj.loadCallback === "function"){
                        optionObj.loadCallback(gltf, model)
                    }

                    ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

                    if (typeof optionObj.callback === "function"){
                        optionObj.callback(ObjGroup)
                    }

                    if (deleteFlag){
                        glbLoadQueue.splice(0, 1)
                    }

                    glbLoadFlag = false
                    if (glbLoadQueue.length > 0){
                        glbLoadQueue[0]()
                    }

                    return ObjGroup

                    resolve()
                })
            })

        }else{
            //如果缓存中有此模型，克隆该模型
            const modelData = loadObj[modelName].scene
            loadObj[modelName].scene = null
            const copyObj = Object.assign({}, loadObj[modelName])
            copyObj.scene = clone(modelData)
            loadObj[modelName].scene = modelData

            let gltf = copyObj
            let model = gltf.scene

            handleModel(model, optionObj)

            ObjGroup.add(model)

            if (typeof optionObj.loadCallback === "function"){
                optionObj.loadCallback(gltf, model)
            }

            ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

            if (typeof optionObj.callback === "function"){
                optionObj.callback(ObjGroup)
            }

            if (deleteFlag){
                glbLoadQueue.splice(0, 1)
            }
            glbLoadFlag = false
            if (glbLoadQueue.length > 0){
                glbLoadQueue[0]()
            }

            return ObjGroup
        }
    }

    function loadFbxModel(modelName, option = {}){
        let deleteFlag = true

        if (fbxLoadFlag){
            fbxLoadQueue.push(() => {
                loadFbxModel(modelName, option)
            })
            return
        }else{
            if (fbxLoadQueue.length == 0){
                deleteFlag = false
            }

            fbxLoadFlag = true
        }

        let optionObj = {
            positionX: 0,
            positionY: 0,
            positionZ: 0,
            scaleY: 0,
            rotateX: 0,
            rotateY: 0,
            rotateZ: 0,
            castShadow: false,
            receiveShadow: false,
            //加载模型成功后的回调
            loadCallback: null,
            //执行结束后的回调
            callback: null,
            //是否缓存加载的模型
            cache: true
        }

        optionObj = Object.assign(optionObj, option);

        const ObjGroup = new THREE.Group()

        //如果在缓存中没有该模型,加载模型
        if (null == loadObj[modelName]){
            //同步加载，避免出现同时加载多个时null
            const promiseHander = new Promise((resolve, reject) =>{
                fbxLoader.load( process.env.BASE_URL + `mymodels/fbx/${modelName}?r=${proxy.$versionNum}`, function ( model ) {
                    if (optionObj.cache){
                        loadObj[modelName] = model
                        // model = model.clone()
                        model = clone(model)
                    }

                    optionObj["format"] = "fbx"

                    handleModel(model, optionObj)

                    ObjGroup.add(model)

                    if (typeof optionObj.loadCallback === "function"){
                        optionObj.loadCallback(model)
                    }

                    ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

                    if (typeof optionObj.callback === "function"){
                        optionObj.callback(ObjGroup)
                    }

                    if (deleteFlag){
                        fbxLoadQueue.splice(0, 1)
                    }

                    fbxLoadFlag = false
                    if (fbxLoadQueue.length > 0){
                        fbxLoadQueue[0]()
                    }

                    return ObjGroup

                    resolve()
                })
            })

        }else{
            //如果缓存中有此模型，克隆该模型
            // let model = loadObj[modelName].clone()
            let model = clone(loadObj[modelName])

            optionObj["format"] = "fbx"

            handleModel(model, optionObj)

            ObjGroup.add(model)

            if (typeof optionObj.loadCallback === "function"){
                optionObj.loadCallback(model)
            }

            ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)

            if (typeof optionObj.callback === "function"){
                optionObj.callback(ObjGroup)
            }

            if (deleteFlag){
                fbxLoadQueue.splice(0, 1)
            }
            fbxLoadFlag = false
            if (fbxLoadQueue.length > 0){
                fbxLoadQueue[0]()
            }

            return ObjGroup
        }


        // ObjGroup.position.set(optionObj.positionX, optionObj.positionY, optionObj.positionZ)
        //
        // if (typeof optionObj.callback === "function"){
        //     optionObj.callback(ObjGroup)
        // }
        //
        // return ObjGroup
    }

    //根据传入的参数调整模型
    function handleModel(model, optionObj) {
        let box3 = new THREE.Box3()
        let obj = new THREE.Vector3()
        let scaleNum
        box3.setFromObject(model)
        box3.getSize(obj)

        // if (optionObj.castShadow || optionObj.receiveShadow){
        model.traverse( function ( object ) {
            if ( object.isMesh ) {
                // if (optionObj.castShadow ){
                object.castShadow = true;
                // }

                // if (optionObj.receiveShadow ){
                object.receiveShadow = true;
                // }

                if (optionObj.format === "fbx"){
                    object.material.emissive = new THREE.Color(1,1,1);
                    object.material.emissiveIntensity = 1;
                    object.material.emissiveMap = object.material.map;
                }

            }
        } );
        // }

        if (optionObj.rotateX > 0){
            model.rotation.x = optionObj.rotateX
        }

        if (optionObj.rotateY > 0){
            model.rotation.y = optionObj.rotateY
        }

        if (optionObj.rotateZ > 0){
            model.rotation.z = optionObj.rotateZ
        }

        if (optionObj.scaleY > 0){
            scaleNum = optionObj.scaleY / obj.getComponent(1)
            let vector = new THREE.Vector3(scaleNum, scaleNum, scaleNum);
            model.scale.multiply(vector);
        }


        return model
    }

    function getSceneModelFaceNum(view) {  // 将scene传进去
        let objects = 0; // 场景模型对象
        let triangles = 0; // 模型面片

        for (let index = 0; index < view.children.length; index++) {
            let object = view.children[index];
            object.traverse(obj => {
                objects ++;
                if (obj instanceof THREE.Mesh || object instanceof THREE.Line) {
                    let geometry = obj.geometry;
                    if (geometry instanceof THREE.BufferGeometry) {
                        if (geometry.index && geometry.index.count) {
                            triangles += geometry.index.count
                        } else if (geometry.attributes.position) {
                            const pos = geometry.attributes.position
                            if (pos.count && pos.itemSize) {
                                triangles += Math.round(pos.count / pos.itemSize)
                            }
                        }
                    }
                }
            });
        }
        console.log('模型对象数量: ' + objects, '模型面片数: ' + triangles);
    }

    function openConfirm(text, func, func2){
        moveFlag = false
        speed = 0
        confirmVisible.value = true
        confirmFunc = func
        cancelFunc = func2
        controlFlag = false
        nippleViewVisible.value = false
        setTimeout(() => {
            confirmText.value = text
        }, 1250)
    }

    function sureConfirm() {
        if (typeof confirmFunc === "function"){
            confirmFunc()
        }

        confirmVisible.value = false
        confirmText.value = ""
        confirmFunc = null
        cancelFunc = null
        bottomInteractionUiVisible.value = true
        upperRightUiVisible.value = true

        controlFlag = true

        setTimeout(() => {
            nippleViewVisible.value = true
        }, 250)
    }

    function closeConfirm() {
        if (typeof cancelFunc === "function"){
            cancelFunc()
        }

        confirmVisible.value = false
        confirmText.value = ""
        confirmFunc = null
        cancelFunc = null
        bottomInteractionUiVisible.value = true
        upperRightUiVisible.value = true

        controlFlag = true

        setTimeout(() => {
            nippleViewVisible.value = true
        }, 250)
    }

    //檢測觸發區域
    function checkTriggerMap() {
        for (const key in triggerAreaMap){
            const obj = triggerAreaMap[key]

            if (checkInAreaFlag(obj.scope)){
                if (!obj.alive && (obj.timer > obj.timeLimit)){
                    obj.timer = 0
                    obj.alive = true

                    if (typeof obj.func === "function"){
                        obj.func()
                    }
                }
            }else{
                if (!obj.alive){
                    obj.timer += mixerUpdateDelta
                }else{
                    obj.alive = false

                    if (null != obj.leaveCallback && typeof obj.leaveCallback === "function"){
                        obj.leaveCallback()
                    }
                }
            }
        }
    }

    //檢測主角是否在某個區域中
    function checkInAreaFlag(obj){
        const flagX1 = meshGroup.position.x < obj.MAX_POSITION_X
        const flagX2 = meshGroup.position.x > obj.MIN_POSITION_X

        const flagZ1 = meshGroup.position.z < obj.MAX_POSITION_Z
        const flagZ2 = meshGroup.position.z > obj.MIN_POSITION_Z

        return flagX1 && flagX2 && flagZ1 && flagZ2
    }

    function getHallData(){

      // if (myUtil.isEmpty(props.hid)){
      //   return
      // }
        if (myUtil.isEmpty(userInfoRef.value.hid)){
            return
        }

        const request = companyApi.getHallListForThree
        const params = request.getParams()

        params.id = userInfoRef.value.hid

        request.send(params, (res) => {
            loadingPercent.value += 5
          materialList = []
          res.detail.threeHallModelList.forEach((v, i) => {
            if(v.threeShopModel.materialModels != null){

              v.threeShopModel.materialModels.forEach((v2, i2) => {
                materialList.push(v2)
              })

            }
          })
            initRegionStatus(res.detail)
            initPage()
        })

    }
    function goIndex(){

      proxy.$router.push({name: "main"})
    }

    function clickGetHallData(obj){
        userInfoRef.value.hid = obj.id
        hallSelectorVisible.value = false
        proxy.$router.push({path: `/hall/${obj.id}`})
        //getHallData()
    }

    function clickGoHall(fid, hid){
        hallShopListVisible.value = false
        goSelectFloor(fid, hid)
    }

    function phoneGoFloorCallback(fid, hid) {
        hideShopopeeChatBox()
        goSelectFloor(fid, hid)
    }

    function initRegionStatus(info){
        hallObjInfo = info
        hallType.value = hallObjInfo.addinfo17
        floorType.value = hallObjInfo.addinfo22
        if (myUtil.isNotEmpty(info.addinfo19)){
            info.addinfo19 = JSON.parse(info.addinfo19)
            if (null == info.addinfo19.mode){
                info.addinfo19.mode = 0
            }
        }else{
            info.addinfo19 = {
                mode: 0
            }
        }

        let lastPage = 1
        let list = info.threeHallModelList

        list.forEach((v, i) => {
            if (v.addinfo1 > lastPage){
                lastPage = v.addinfo1
            }

            if (null != v.addinfo12){
                try{
                    v.addinfo12 = JSON.parse(v.addinfo12)
                }catch (e) {
                    v.addinfo12 = null
                }
            }

            if (null == regionMap.shopMap[v.addinfo1]){
                regionMap.shopMap[v.addinfo1] = {}
            }

            const shopObj = {
                data: v,
                shopMesh: null,
                shopmanMEsh: null
            }

            regionMap.shopMap[v.addinfo1][v.addinfo2] = shopObj
        })

        regionMap.lastPage = Number(lastPage)
        lastPageNum.value = Number(lastPage)

        if (null != props.fid && null != regionMap.shopMap[props.fid]){
            regionMap.currPage = props.fid
        }else {
            if (null != userInfoRef.value.fid){
                regionMap.currPage = userInfoRef.value.fid
            }

        }

        if (userInfoRef.value.demo_stage != null && hallObjInfo.id == 1){
            hallObjInfo.addinfo17 = userInfoRef.value.demo_stage
            userInfoRef.value.demo_stage = null
        }

    }

    function createShopAndMan(){
        for (const key in shopPointMap){
            const obj = shopPointMap[key]

            const doorNum = Number(key.replaceAll("shop_", ""))
            const floorNum = regionMap.currPage
            let shopData = null
            let shopGroup = null

            if (
                null != regionMap &&
                null != regionMap.shopMap &&
                null != regionMap.shopMap[floorNum] &&
                null != regionMap.shopMap[floorNum][doorNum]
            ){
                shopGroup = regionMap.shopMap[floorNum][doorNum]
                shopData = shopGroup.data
            }

            if (null == obj.shopObj){
                if (hallObjInfo.addinfo17 === "1"||hallObjInfo.addinfo24 ==="2"){
                    createShopMesh2(obj, shopData)
                }else{
                    createShopMesh(obj, shopData)
                }

            }else{

            }

            if (null == obj.shopman){
                createShopmanMesh(obj, shopData)
            }else{

            }

        }
    }

    function createShopAndMan2(){
        for (const key in shopPointMap){
            if (key.indexOf("shop_") != -1){
                if(regionMap.currPage == 1){
                    continue
                }
            }else{
                if(regionMap.currPage != 1){
                    continue
                }
            }


            const obj = shopPointMap[key]

            let doorNum = ""

            if (regionMap.currPage == 1){
                doorNum = Number(key.replaceAll("1_", ""))
            }else{
                doorNum = Number(key.replaceAll("shop_2_", ""))
            }

            const floorNum = regionMap.currPage
            let shopData = null
            let shopGroup = null

            if (
                null != regionMap &&
                null != regionMap.shopMap &&
                null != regionMap.shopMap[floorNum] &&
                null != regionMap.shopMap[floorNum][doorNum]
            ){
                shopGroup = regionMap.shopMap[floorNum][doorNum]
                shopData = shopGroup.data
            }

            if (null == obj.shopObj){
                if (hallObjInfo.addinfo17 === "1"||hallObjInfo.addinfo24 ==="2"){
                    createShopMesh2(obj, shopData)
                }else{
                    createShopMesh(obj, shopData)
                }

            }else{

            }

            if (null == obj.shopman){
                createShopmanMesh(obj, shopData)
            }else{

            }

        }
    }

    function createShopMesh(obj, data){
        let settingJSon = data

      console.log(obj)
        if (null != settingJSon){
            settingJSon = settingJSon.addinfo12
        }
        const doorNum = Number(obj.positionObj.name.replaceAll("shop_", ""))

        let logoname = obj.positionObj.name.replaceAll("shop_", "shoplogo_")
        let logoBox = logoDataList[logoname]

        loadGlbModel("island/pav/shop.gltf",{
            // loadFbxModel("island/pav/shop.fbx", {
            // positionX: -12,
            positionY: 0.1,
            // positionZ: -30,
            // scaleY: 4.5,
            loadCallback: (gltf,model) => {
                model.traverse( function ( child ) {
                    // if (child.isMesh) {
                    //     child.material = new THREE.MeshLambertMaterial({ color: 0x004444, transparent: true, opacity: 0.5 });
                    //     const edges = new THREE.EdgesGeometry(child.geometry);
                    //     const edgesMaterial = new THREE.LineBasicMaterial({ color: 0x00ffff });
                    //     const line = new THREE.LineSegments(edges, edgesMaterial);
                    //     child.add(line);
                    // }
                    // if ( object.isMesh ) {
                    //     object.material.emissive = null;
                    //     object.material.emissiveIntensity = 0;
                    //     object.material.emissiveMap = null;
                    // }

                    if (child instanceof THREE.Mesh) {

                        child.material.emissiveIntensity = 0;
                        //   child.castShadow = false
                        //   child.receiveShadow = false
                        // if(object.name=="shop_02"){

                        if (child.name == "shopnom"){
                            createShopNumMaterial(child, doorNum)

                            if (null != data){
                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        //const url = `${proxy.$ThreeDShopopeePath}hall/${userInfoRef.value.hid}/${regionMap.currPage}/${doorNum}`
                                      var mdata =regionMap.shopMap[regionMap.currPage][doorNum].data
                                      var url = ""
                                      if(myUtil.isNotEmpty(mdata) ){
                                        url =`${proxy.$ThreeDShopopeePath}hallShop/${mdata.id}`
                                      }else{
                                        url = `${proxy.$ThreeDShopopeePath}hall/${userInfoRef.value.hid}/${regionMap.currPage}/${doorNum}`
                                      }
                                     // const url = `${proxy.$ThreeDShopopeePath}hallshop/}`
                                        shareType.value = hallObjInfo.addinfo17
                                        shareUrl.value = url
                                        shareUrlVisible.value = true
                                        shareCompanycode.value = data.companycode
                                        // copy(url)
                                        // myUtil.alertSuccess(i18n.tkey("lang_copy_shop_url_alert"))
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }
                        }
                        if (child.name == "shop01_starry"){
                            // shop_top_texture = child.map
                            shop_top_texture = child.material.map
                            shop_top_texture.wrapS = shop_top_texture.wrapT = THREE.RepeatWrapping;
                            // shop_top_texture.center.set(0.5, 0.5)
                            funcListObj[`water_flow`] = () => {
                                shop_top_texture.offset.x -= 0.00005
                                // shop_top_texture.offset.y += 0.00005
                                // shop_top_texture.rotation += 0.0001
                            }
                        }
                        if(child.name == "shoptai_map"){
                            child.material.emissiveMap = null;
                            child.material.emissiveIntensity = 0.1;
                        }
                        if (child.name == "shopname"){
                            if (null != data && null != data.threeShopModel && null != data.threeShopModel.companyName){
                                let companyName = ""

                                if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                                    companyName = data.threeShopModel.companyName
                                }else{
                                    if (myUtil.isNotEmpty(data.threeShopModel.companyName2)){
                                        companyName = data.threeShopModel.companyName2
                                    }else{
                                        companyName = data.threeShopModel.companyName
                                    }

                                }

                                // createShopnameMaterial(child, data.threeShopModel.companyName)
                                createShopnameMaterial(child, companyName)

                                funcListObj[child.uuid] = () => {
                                    child.rotation.y -= 0.001

                                    if (child.rotation.y < -2 * Math.PI){
                                        child.rotation.y += 2 * Math.PI
                                    }

                                }

                                clearDataList.push({"key": child.uuid, map: funcListObj})
                            }
                        }

                        if(child.name=="ad00"){
                            if (null != settingJSon && null != settingJSon.img0){
                                const verticalAdsText1 = texLoader.load(settingJSon.img0);
                                const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: verticalAdsText1,
                                    side: DoubleSide,
                                });

                                verticalAdsText1.flipY = false

                                child.material = verticalAdsMaterial1
                                child.material.lightMap = verticalAdsText1
                                logoBox.material = verticalAdsMaterial1
                                logoBox.material.lightMap = verticalAdsText1
                                child.visible = true
                                logoBox.visible = true

                                // interactionList.push(logoBox)
                                // interactionObj[logoBox.uuid] = [{
                                //     callback: () => {
                                //         goViewImg(proxy.$ShopopeeUrl + settingJSon.img0, data.threeShopModel.companyName, i18n.tkey("lang_go_booth"), doorNum)
                                //     }
                                // }]
                                //
                                // clearDataList.push({"key": logoBox.uuid, map: interactionObj})
                                //
                                // interactionList.push(child)
                                // interactionObj[child.uuid] = [{
                                //     callback: () => {
                                //         goViewImg(proxy.$ShopopeeUrl + settingJSon.img0, data.threeShopModel.companyName)
                                //     }
                                // }]

                                interactionList.push(logoBox)
                                interactionObj[logoBox.uuid] = [{
                                    callback: () => {
                                        //const url = `${proxy.$ThreeDShopopeePath}hall/${userInfoRef.value.hid}/${regionMap.currPage}/${doorNum}`
                                      var mdata =regionMap.shopMap[regionMap.currPage][doorNum].data
                                      var url = ""
                                      if(myUtil.isNotEmpty(mdata) ){
                                        url =`${proxy.$ThreeDShopopeePath}hallShop/${mdata.id}`
                                      }else{
                                        url = `${proxy.$ThreeDShopopeePath}hall/${userInfoRef.value.hid}/${regionMap.currPage}/${doorNum}`
                                      }
                                        shareType.value = hallObjInfo.addinfo17
                                        shareUrl.value = url
                                        shareUrlVisible.value = true
                                        shareCompanycode.value = data.companycode
                                    }
                                }]

                                clearDataList.push({"key": logoBox.uuid, map: interactionObj})

                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        //const url = `${proxy.$ThreeDShopopeePath}hall/${userInfoRef.value.hid}/${regionMap.currPage}/${doorNum}`
                                      var mdata =regionMap.shopMap[regionMap.currPage][doorNum].data
                                      var url = ""
                                      if(myUtil.isNotEmpty(mdata) ){
                                        url =`${proxy.$ThreeDShopopeePath}hallShop/${mdata.id}`
                                      }else{
                                        url = `${proxy.$ThreeDShopopeePath}hall/${userInfoRef.value.hid}/${regionMap.currPage}/${doorNum}`
                                      }
                                        shareType.value = hallObjInfo.addinfo17
                                        shareUrl.value = url
                                        shareUrlVisible.value = true
                                        shareCompanycode.value = data.companycode
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }else if (null != data && null != data.threeShopModel && null != data.threeShopModel.companyName){
                              let companyName = ""

                              if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                                companyName = data.threeShopModel.companyName
                              }else{
                                if (myUtil.isNotEmpty(data.threeShopModel.companyName2)){
                                  companyName = data.threeShopModel.companyName2
                                }else{
                                  companyName = data.threeShopModel.companyName
                                }

                              }

                              // createShopnameMaterial(child, data.threeShopModel.companyName)
                            var mater =  createShopnameMaterial3(child, companyName)
                              logoBox.material = mater

                            }else{
                               child.visible = false
                               try {
                                   child.material.dispose();
                               }catch (e) {

                                }
                               logoBox.visible = false
                                logoBox.material = null

                            }

                        }

                        if(child.name=="plan01"){
                            if (null != settingJSon && null != settingJSon.img1){
                                const verticalAdsText1 = texLoader.load(settingJSon.img1);
                                const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: verticalAdsText1,
                                });

                                verticalAdsText1.flipY = false

                                child.material = verticalAdsMaterial1
                                child.material.lightMap = verticalAdsText1

                                child.parent.visible = true

                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        goViewImg(proxy.$ShopopeeUrl + settingJSon.img1)
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }else if(null != data && null != data.addinfo10){
                                imgGenerateMap.value[child.uuid] = {
                                    uuid: child.uuid,
                                    code: data.addinfo10,
                                    mesh: child,
                                    width: 600,
                                    height: 800
                                }

                                child.parent.visible = true

                                // interactionList.push(child)
                                // interactionObj[child.uuid] = [{
                                //     callback: () => {
                                //         goViewImg(proxy.$ShopopeeUrl + settingJSon.img1)
                                //     }
                                // }]
                                //
                                // clearDataList.push({"key": child.uuid, map: interactionObj})
                            }else{
                                child.material.dispose();
                                child.parent.visible = false
                            }

                        }

                        if(child.name=="plan02"){

                            if (null != settingJSon && null != settingJSon.img2){
                                const verticalAdsText1 = texLoader.load(settingJSon.img2);
                                const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: verticalAdsText1,
                                });

                                verticalAdsText1.flipY = false

                                child.material = verticalAdsMaterial1
                                child.material.lightMap = verticalAdsText1

                                child.parent.visible = true

                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        goViewImg(proxy.$ShopopeeUrl + settingJSon.img2)
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }else{
                                child.material.dispose();
                                child.parent.visible = false
                            }

                        }

                        if(child.name=="plan03"){

                            if (null != settingJSon && null != settingJSon.img3){
                                const verticalAdsText1 = texLoader.load(settingJSon.img3);
                                const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: verticalAdsText1,
                                });

                                verticalAdsText1.flipY = false

                                child.material = verticalAdsMaterial1
                                child.material.lightMap = verticalAdsText1

                                child.parent.visible = true

                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        goViewImg(proxy.$ShopopeeUrl + settingJSon.img3)
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }else{
                                child.material.dispose();
                                child.parent.visible = false
                            }

                        }

                        if(child.name=="plan04"){

                            if (null != settingJSon && null != settingJSon.img4){
                                const verticalAdsText1 = texLoader.load(settingJSon.img4);
                                const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: verticalAdsText1,
                                });

                                verticalAdsText1.flipY = false

                                child.material = verticalAdsMaterial1
                                child.material.lightMap = verticalAdsText1

                                child.parent.visible = true

                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        goViewImg(proxy.$ShopopeeUrl + settingJSon.img4)
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }else{
                                child.material.dispose();
                                child.parent.visible = false

                            }

                        }

                        if(child.name=="plan05"){

                            if (null != settingJSon && null != settingJSon.img5){
                                const verticalAdsText1 = texLoader.load(settingJSon.img5);
                                const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: verticalAdsText1,
                                });

                                verticalAdsText1.flipY = false

                                child.material = verticalAdsMaterial1
                                child.material.lightMap = verticalAdsText1

                                child.parent.visible = true

                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        goViewImg(proxy.$ShopopeeUrl + settingJSon.img5)
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }else{
                                child.material.dispose();
                                child.parent.visible = false
                            }

                        }

                        if(child.name=="plan06"){

                            if (null != settingJSon && null != settingJSon.img6){
                                const verticalAdsText1 = texLoader.load(settingJSon.img6);
                                const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: verticalAdsText1,
                                });

                                verticalAdsText1.flipY = false

                                child.material = verticalAdsMaterial1
                                child.material.lightMap = verticalAdsText1

                                child.parent.visible = true

                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        goViewImg(proxy.$ShopopeeUrl + settingJSon.img6)
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }else{
                                child.material.dispose();
                                child.parent.visible = false
                            }

                        }

                        if(child.name=="plan07"){

                            if (null != settingJSon && null != settingJSon.img7){
                                const verticalAdsText1 = texLoader.load(settingJSon.img7);
                                const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
                                    // color: 0xffffff,
                                    map: verticalAdsText1,
                                });

                                verticalAdsText1.flipY = false

                                child.material = verticalAdsMaterial1
                                child.material.lightMap = verticalAdsText1

                                child.parent.visible = true

                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        goViewImg(proxy.$ShopopeeUrl + settingJSon.img7)
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }else{
                                child.material.dispose();
                                child.parent.visible = false

                            }

                        }

                        if (child.name == "ring01"){
                            funcListObj[child.uuid] = () => {
                                child.rotation.y += 0.001

                                if (child.rotation.y > 2 * Math.PI){
                                    child.rotation.y -= 2 * Math.PI
                                }

                            }

                            clearDataList.push({"key": child.uuid, map: funcListObj})
                        }

                        if (child.name == "product_catalog"){
                            if (null != data && myUtil.isNotEmpty(data.addinfo4)){
                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        myUtil.confirmSuccess(i18n.tkey("lang_download_company_pdf_confirm"), () => {
                                            window.open(proxy.$ShopopeeUrl + data.addinfo4)
                                        })
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }

                        }

                        // }
                    }

                });

                loadingPercent.value += 1
            },
            callback: (group) => {

                obj.positionObj.add(group)
                obj.shopObj = group

                if (null != data){
                    // if (-1 == data.threeShopModel.dinumber) {
                    //     interactionObj[group.uuid] = []
                    // }else{
                  // distance: 7,
                       /* interactionObj[group.uuid] = [{
                            distance: 6,
                            icon: "fa-solid fa-store",
                            // name: shopData.companyName,
                            name: i18n.tkey("lang_shop_website_1"),
                            description: data.threeShopModel.companyName,
                            // mesh: shopList[index].children[0],
                            mesh: group.children[0],
                            callback: () => {
                                // goShopConfirm(index)
                                goShopConfirm(regionMap.currPage, data.addinfo2)
                            },
                            triggerCallback: () => {

                                if (null != data.threeShopModel.materialModels && data.threeShopModel.materialModels.length > 0){
                                    productDisplayViewVisible.value = true
                                    showMaterialList.value = data.threeShopModel.materialModels
                                    showMaterialShopdata.value = data.threeShopModel
                                }

                                // saveShopVisits(data.threeShopModel.companyId)
                                // saveShopVisits(data.threeShopModel.companyCode)
                            },
                            leaveCallback: () => {
                                productDisplayViewVisible.value = false
                                showMaterialList.value = []
                                showMaterialShopdata.value = null
                            }
                        }]*/
                    // }

                   /* if (myUtil.isNotEmpty(data.threeShopModel.website)) {
                        interactionObj[group.uuid].push({
                            distance: 7,
                            icon: "fa-solid fa-arrow-up-right-from-square",
                            name: i18n.tkey("lang_company_website"),
                            description: data.threeShopModel.companyName,
                            mesh: group.children[0],
                            callback: () => {
                                if (data.threeShopModel.website.indexOf("http") == -1){
                                    myUtil.goURLNewWindow("http://" + data.threeShopModel.website)
                                }else{
                                    myUtil.goURLNewWindow(data.threeShopModel.website)
                                }
                            }
                        })
                    }*/

                    if (null != userInfoRef.value.country && data.threeShopModel.countrycode != userInfoRef.value.country){
                      //拿報價
                        // interactionObj[group.uuid].push({
                        //     distance: 7,
                        //     icon: "fa-solid fa-file-invoice-dollar",
                        //     // name: shopData.companyName,
                        //     name: i18n.tkey("lang_get_quo_price"),
                        //     description: data.threeShopModel.companyName,
                        //     // mesh: shopList[index].children[0],
                        //     mesh: group.children[0],
                        //     callback: () => {
                        //         // openNewQuotation(data.threeShopModel.login)
                        //         goProductQuotation(data.threeShopModel.login, data.threeShopModel.companyCode)
                        //         bottomInteractionUiVisible.value = false
                        //         upperRightUiVisible.value = false
                        //         nippleViewVisible.value = false
                        //
                        //         controlFlag = false
                        //     },
                        //     triggerCallback: () => {
                        //
                        //     },
                        //     leaveCallback: () => {
                        //
                        //     }
                        // })
                    }

                    clearDataList.push({"key": group.uuid, map: interactionObj})
                }

                clearMeshList.push(group)
            }
        })

    }

    function createShopMesh2(obj, data){
        let settingJSon = data
         console.log(obj.positionObj.name)
        if (null != settingJSon){
            settingJSon = settingJSon.addinfo12
        }

        // const doorNum = Number(obj.positionObj.name.replaceAll("shop_", ""))
        let doorNum = ""

        if (regionMap.currPage == 1){
            doorNum = Number(obj.positionObj.name.replaceAll("shop_1_", ""))
        }else{
            doorNum = Number(obj.positionObj.name.replaceAll("shop_2_", ""))
        }

        let logoname = obj.positionObj.name.replaceAll("shop_", "shoplogo_")
        let logoBox = logoDataList[logoname]

        loadGlbModel("island/pav/shop02.gltf",{
            // loadFbxModel("island/pav/shop.fbx", {
            // positionX: -12,
            positionY: 0.1,
            // positionZ: -30,
            // scaleY: 7,
            loadCallback: (gltf,model) => {
                model.traverse( function ( child ) {

                    if (child instanceof THREE.Mesh) {

                        child.material.emissiveIntensity = 0;

                        if (child.name == "shopnom"){

                            child.rotation.x = Math.PI
                            createShopNumMaterial(child, doorNum)

                        }

                        if (child.name == "shopname" || child.name == "shopnom"){
                            if (null != data){
                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                      var mdata =regionMap.shopMap[regionMap.currPage][doorNum].data
                                      var url = ""
                                      if(myUtil.isNotEmpty(mdata) ){
                                       url =`${proxy.$ThreeDShopopeePath}hallShop/${mdata.id}`
                                      }else{
                                       url = `${proxy.$ThreeDShopopeePath}hall/${userInfoRef.value.hid}/${regionMap.currPage}/${doorNum}`
                                      }
                                        shareType.value = hallObjInfo.addinfo17
                                        shareCompanycode.value = data.companycode
                                        shareUrl.value = url
                                        shareUrlVisible.value = true
                                        // copy(url)
                                        // myUtil.alertSuccess(i18n.tkey("lang_copy_shop_url_alert"))
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }
                        }

                        if(child.name == "shoptai_map"){
                            child.material.emissiveMap = null;
                            child.material.emissiveIntensity = 0.1;
                        }

                        if (child.name == "shopname"){

                            if (null != data && null != data.threeShopModel && null != data.threeShopModel.companyName){
                                let companyName = ""

                                if (userInfoRef.value.lang == "zh" || userInfoRef.value.lang == "szh"){
                                    companyName = data.threeShopModel.companyName
                                }else{
                                    if (myUtil.isNotEmpty(data.threeShopModel.companyName2)){
                                        companyName = data.threeShopModel.companyName2
                                    }else{
                                        companyName = data.threeShopModel.companyName
                                    }

                                }
                                child.rotation.x = Math.PI
                                createShopnameMaterial2(child, companyName)

                            }
                        }

                        if (child.name == "product_catalog"){
                            if (null != data && myUtil.isNotEmpty(data.addinfo4)){
                                interactionList.push(child)
                                interactionObj[child.uuid] = [{
                                    callback: () => {
                                        myUtil.confirmSuccess(i18n.tkey("lang_download_company_pdf_confirm"), () => {
                                            window.open(proxy.$ShopopeeUrl + data.addinfo4)
                                        })
                                    }
                                }]

                                clearDataList.push({"key": child.uuid, map: interactionObj})
                            }

                        }

                    }

                });

                loadingPercent.value += 1
            },
            callback: (group) => {

                obj.positionObj.add(group)
                obj.shopObj = group

                if (null != data){
                    // if (-1 == data.threeShopModel.dinumber) {
                    //     interactionObj[group.uuid] = []
                    // }else{
                   // distance: 7,
                       /* interactionObj[group.uuid] = [{
                          distance: 6,
                            icon: "fa-solid fa-store",
                            // name: shopData.companyName,
                            name: i18n.tkey("lang_shop_website_1"),
                            description: data.threeShopModel.companyName,
                            // mesh: shopList[index].children[0],
                            mesh: group.children[0],
                            callback: () => {
                                // goShopConfirm(index)
                                goShopConfirm(regionMap.currPage, data.addinfo2)
                            },
                            triggerCallback: () => {

                                if (null != data.threeShopModel.materialModels && data.threeShopModel.materialModels.length > 0){
                                    productDisplayViewVisible.value = true
                                    showMaterialList.value = data.threeShopModel.materialModels
                                    showMaterialShopdata.value = data.threeShopModel
                                }

                                // saveShopVisits(data.threeShopModel.companyId)
                                // saveShopVisits(data.threeShopModel.companyCode)
                            },
                            leaveCallback: () => {
                                productDisplayViewVisible.value = false
                                showMaterialList.value = []
                                showMaterialShopdata.value = null
                            }
                        }]*/
                    // }

                   /* if (myUtil.isNotEmpty(data.threeShopModel.website)) {
                        interactionObj[group.uuid].push({
                            distance: 7,
                            icon: "fa-solid fa-arrow-up-right-from-square",
                            name: i18n.tkey("lang_company_website"),
                            description: data.threeShopModel.companyName,
                            mesh: group.children[0],
                            callback: () => {
                                if (data.threeShopModel.website.indexOf("http") == -1){
                                    myUtil.goURLNewWindow("http://" + data.threeShopModel.website)
                                }else{
                                    myUtil.goURLNewWindow(data.threeShopModel.website)
                                }
                            }
                        })
                    }*/

                    clearDataList.push({"key": group.uuid, map: interactionObj})

                    const doorObj = group.getObjectByName("door")
                    const vec3 = new THREE.Vector3()
                    doorObj.getWorldPosition(vec3)

                    // let boxGeometry = new THREE.BoxGeometry(1, 1, 6)
                    // let lambertMaterial = new THREE.MeshBasicMaterial({
                    //     color: 0xff0000
                    // })
                    //
                    // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
                    // scene.add(mesh)
                    // mesh.position.x = vec3.x
                    // mesh.position.z = vec3.z


                    let xRange = 0.5
                    let zRange = 3

                    if (doorNum > 16 && doorNum < 21){
                        xRange = 3
                        zRange = 0.5
                    }

                    triggerAreaMap[doorObj.uuid] = {
                        scope: {
                            MAX_POSITION_X: vec3.x + xRange,
                            MIN_POSITION_X: vec3.x - xRange,
                            MAX_POSITION_Z: vec3.z + zRange,
                            MIN_POSITION_Z: vec3.z - zRange,
                        },
                        alive: false,
                        timer: 0.5,
                        timeLimit: 0.5,
                        func: () => {
                            meshGroup.translateOnAxis(moveVector3, (speed * -60 * mixerUpdateDelta) - 0.2);
                            goShopConfirm(regionMap.currPage, doorNum)
                        }
                    }
                    clearDataList.push({"key": doorObj.uuid, map: triggerAreaMap})
                }

                clearMeshList.push(group)
            }
        })

    }

    function createShopmanMesh(obj, data){
        if (null == data){
            return
        }

        const withAIObj = getEmptyWithAIObj()

        withAIObj.login = data.threeShopModel.eshopopeeLogin
        withAIObj.name = ""
        withAIObj.memMale = ""
        withAIObj.whatsshopsbcataList = ""
        withAIObj.companyName = ""

        let scaleY = 0.17

        if (hallObjInfo.addinfo17 === "1"||hallObjInfo.addinfo24 ==="2"){
            scaleY = null
        }

        // loadFbxModel("town2/woman.fbx", {
        loadGlbModel("town2/agirl.gltf",{
            // positionX: -12,
            // positionY: 0,
            // positionZ: -30,
            // scaleY: scaleY,
            loadCallback: (gltf,model) => {

                withAIObj.model = model

                const mixer = new THREE.AnimationMixer( model );
                mixerObj[model.uuid] = mixer

                clearDataList.push({"key": model.uuid, map: mixerObj})

                withAIObj.allActions = {};

                let animations = gltf.animations;

                for ( let i = 0; i !== animations.length; ++ i ) {
                    //動作
                    const clip = animations[ i ];
                    const action = mixer.clipAction( clip );
                    withAIObj.allActions[clip.name ] = action;

                }

                withAIObj.activeAction = withAIObj.allActions['idle'];
                withAIObj.activeAction.play();

                withAIObj.action = 'idle'

                model.traverse( function ( object ) {
                    if ( object.isMesh ) {
                        object.material.emissive = null;
                        object.material.emissiveIntensity = 0;
                        object.material.emissiveMap = null;
                    }
                });

                interactionObj[model.children[0].uuid] = [
                  {
                    distance: 6,
                    icon: "fa-solid fa-store",
                    // name: shopData.companyName,
                    name: i18n.tkey("lang_shop_website_1"),
                    description: data.threeShopModel.companyName,
                    // mesh: shopList[index].children[0],
                    mesh: model.children[0],
                    callback: () => {
                      // goShopConfirm(index)
                      goShopConfirm(regionMap.currPage, data.addinfo2)
                    },
                    triggerCallback: () => {

                      if (null != data.threeShopModel.materialModels && data.threeShopModel.materialModels.length > 0){
                        productDisplayViewVisible.value = true
                        showMaterialList.value = data.threeShopModel.materialModels
                        showMaterialShopdata.value = data.threeShopModel
                      }

                      // saveShopVisits(data.threeShopModel.companyId)
                      // saveShopVisits(data.threeShopModel.companyCode)
                    },
                    leaveCallback: () => {
                      productDisplayViewVisible.value = false
                      showMaterialList.value = []
                      showMaterialShopdata.value = null
                    }
                  },
                    {
                        distance: 6,
                        icon: "fa-solid fa-address-card",
                        // name: withAIObj.name,
                        name: i18n.tkey("lang_memberwork"),
                        description: withAIObj.name,
                        mesh: model.children[0],
                        callback: () => {
                            let src = proxy.$ShopopeeUrl + data.threeShopModel.cardInfo
                            let href = proxy.$ShopopeeUrl + "/receive?id=" + data.threeShopModel.memberworkId
                            showCardBox(src, href, data.threeShopModel.memberworkId)
                            /*goPersonChat(model, withAIObj.name, [i18n.tkey("lang_receive_card_pls")], () => {
                                // setTimeout(() => {
                                // closePersonChat()
                                // }, 1000)
                            })*/
                        }
                    },
                    {
                        distance: 6,
                        icon: "fa-solid fa-comments",
                        // name: withAIObj.name,
                        name: i18n.tkey("lang_open_personal_chat"),
                        description: withAIObj.name,
                        mesh: model.children[0],
                        callback: () => {
                            // openNewChat(withAIObj.login)
                            // bottomInteractionUiVisible.value = false
                            // upperRightUiVisible.value = false
                            // nippleViewVisible.value = false
                            //
                            // controlFlag = false

                            chatCardId.value = data.threeShopModel.memberworkId
                            chatSelectorVisible.value = true
                        }
                    }]

                clearDataList.push({"key": model.children[0].uuid, map: interactionObj})
            },
            callback: (group) => {
                WithAIObjSet[group.uuid] = withAIObj
                withAIObj.group = group

                clearDataList.push({"key": group.uuid, map: WithAIObjSet})

                //加载店员的ai
                withAIObj.AI = ShopmanAI

                obj.shopmanPositionObj.add(group)
                obj.shopman = group

                clearMeshList.push(group)
                clearDataList.push({"key": group.uuid, map: WithAIObjSet})

            }
        })
    }

    //店员的ai
    function ShopmanAI(withAIObj) {
        const vec3 = new THREE.Vector3()

        withAIObj.group.getWorldPosition(vec3)

        // const distance = meshGroup.position.distanceTo(withAIObj.group.position)
        const distance = meshGroup.position.distanceTo(vec3)

        withAIObj.timer_1 += mixerUpdateDelta

        if (distance < 6 ){

            if (null != animationObjGroup[withAIObj.group.uuid]){
                animationObjGroup[withAIObj.group.uuid].pause()
            }

            if (withAIObj.action === 'idle' || withAIObj.action === 'walk_normal'){
                if (withAIObj.action !== 'waving'){
                    withAIObj.action = 'waving'
                    withAIObj.timer_1 = 0
                    toggleActiveMotionObj(withAIObj, "waving")
                }
            }else if(withAIObj.action === 'waving'){
                if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                    withAIObj.action = 'idle_wait'
                    withAIObj.timer_1 = 0
                    toggleActiveMotionObj(withAIObj, "idle")
                }
            }else if (withAIObj.action === 'idle_wait'){
                if (withAIObj.timer_1 > 6){
                    withAIObj.action = 'waving'
                    withAIObj.timer_1 = 0
                    toggleActiveMotionObj(withAIObj, "waving")
                }
            }else if(withAIObj.action === 'deliver_card_wait'){
                withAIObj.action = 'deliver_card'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "talk2")
            }else if(withAIObj.action === 'deliver_card'){
                if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                    withAIObj.action = 'chat_wait'
                    withAIObj.timer_1 = 0
                    toggleActiveMotionObj(withAIObj, "idle")
                }
            }else if(withAIObj.action === 'chat_wait'){
                if (withAIObj.timer_1 > 4){
                    withAIObj.action = 'chatting'
                    withAIObj.timer_1 = 0

                    const randomNum = Math.random()

                    if (randomNum < 0.5){
                        toggleActiveMotionObj(withAIObj, "talk")
                    }else{
                        toggleActiveMotionObj(withAIObj, "clapping")
                    }

                }
            }else if(withAIObj.action === 'chatting'){
                if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                    withAIObj.action = 'chat_wait'
                    withAIObj.timer_1 = 0
                    toggleActiveMotionObj(withAIObj, "idle")
                }
            }else if(withAIObj.action === 'chat_complete'){
                if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                    withAIObj.action = 'idle_wait'
                    withAIObj.timer_1 = 0
                    toggleActiveMotionObj(withAIObj, "idle")
                }
            }


            withAIObj.model.lookAt(meshGroup.position)
        }else{
            if (withAIObj.action === 'waving'){
                if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                    withAIObj.action = 'idle_wait'
                    withAIObj.timer_1 = 0
                    toggleActiveMotionObj(withAIObj, "idle")
                }
            }

            // if (withAIObj.action === 'idle_wait'){
            //     if (withAIObj.timer_1 > 1.5){
            //
            //         withAIObj.action = 'walk_normal'
            //         withAIObj.timer_1 = 0
            //         toggleActiveMotionObj(withAIObj, "walk")
            //
            //         if (null != animationObjGroup[withAIObj.group.uuid]){
            //
            //             if (animationObjGroup[withAIObj.group.uuid]._isPaused){
            //                 animationObjGroup[withAIObj.group.uuid].resume()
            //
            //                 withAIObj.model.lookAt(withAIObj.nextTargetPosition)
            //             }
            //
            //         }
            //     }
            // }
        }

    }

    function toggleActiveMotionObj(obj, name) {
        obj.activeAction.paused = true
        obj.previousAction = obj.activeAction
        obj.activeAction = obj.allActions[name];
        obj.activeAction.reset().play();

        obj.previousAction.crossFadeTo( obj.activeAction, 0.25 )
    }

    function updateAIObj() {
        for( let i in WithAIObjSet){
            if (typeof WithAIObjSet[i].AI === "function"){
                WithAIObjSet[i].AI(WithAIObjSet[i])
            }
        }
    }

    function checkInteractionObj() {
        for (let key in interactionObj){
            const objList = interactionObj[key]

            objList.forEach((obj, i) => {
                if (null != obj.mesh && null != obj.name){
                    if (null != obj.distance){
                        const objuuid = obj.mesh.uuid + i
                        const vec3 = new THREE.Vector3()
                        obj.mesh.getWorldPosition(vec3)
                        const distance = meshGroup.position.distanceTo(vec3)

                        if (distance <= obj.distance && !(objuuid in bottomUIObj.value)){
                            if (null !== obj.trigger){
                                obj.trigger = true

                                if (null != obj.triggerCallback && typeof obj.triggerCallback === "function"){
                                    obj.triggerCallback()
                                }
                            }

                            if (null == obj.UIFlag || true === obj.UIFlag){
                                let flag = true

                                if (null != obj.displayFlag){
                                    if (typeof obj.displayFlag === "function"){
                                        flag = obj.displayFlag()
                                    }else{
                                        flag = obj.displayFlag
                                    }
                                }

                                if (flag){
                                    bottomUIObj.value[objuuid] = {
                                        icon: obj.icon,
                                        text: obj.name,
                                        description: obj.description,
                                        callback: () => {
                                            obj.callback()
                                        }
                                    }
                                }

                            }

                        }

                        if(distance > obj.distance && (objuuid in bottomUIObj.value)){
                            if (objuuid in bottomUIObj.value){
                                delete bottomUIObj.value[objuuid]
                            }

                            if (null !== obj.trigger && true === obj.trigger){
                                obj.trigger = false

                                if (null != obj.leaveCallback && typeof obj.leaveCallback === "function"){
                                    obj.leaveCallback()
                                }
                            }
                        }
                    }

                }
            })

        }
    }

    function getEmptyWithAIObj() {
        const withAIObj = {
            group: null,
            model: null,
            allActions: null,
            activeAction: null,
            previousAction: null,
            nextTargetPosition: null,    //Vector3
            previousTargetPosition: null,
            targetPositionList: [],
            AI: null,
            action: null,
            name: "",
            memMale: 0,
            targetIndex: 0,
            timer_1: 0,
            timer_2: 0
        }

        return withAIObj
    }

    function goPersonChat(targetObj, name, msgList, callback){
        controlFlag = false
        bottomInteractionUiVisible.value = false
        upperRightUiVisible.value = false
        nippleViewVisible.value = false
        testBox.visible = false

        camera.far = 70000
        camera.updateProjectionMatrix()

        chatPersonName.value = name
        chatMsgText.value = msgList[0]
        chatVisible.value = true
        chatMsgIndex = 0
        chatMsgList = msgList
        chatClickFunc = callback

        chatTargetObject = targetObj
        saveCameraPosition()

        const vec3 = new THREE.Vector3()
        camera.getWorldPosition(vec3)
        chatTargetObject.worldToLocal(vec3)

        meshGroup.remove(camera)
        chatTargetObject.add(camera)
        // camera.position.set(0, 2, 5.5)
        // camera.position.set(0, 160, 300)
        camera.position.copy(vec3)

        camera.lookAt(new THREE.Vector3(0,1,0))
        camera.rotation.x = 0
        camera.rotation.y = 0
        camera.rotation.z = 0

        const tween_2 = new TWEEN.Tween(camera.position)
            .to({x: 0, y: 160, z: 300}, 1000)
            .start()
            .easing(TWEEN.Easing.Sinusoidal.Out)
            .onComplete(() => {
                delete animationObjGroup["camera_position_1"]
            })

        animationObjGroup["camera_position_1"] = tween_2

        if (null != WithAIObjSet[targetObj.parent.uuid]){
            WithAIObjSet[targetObj.parent.uuid].action = "deliver_card_wait"
        }

        // if (typeof callback === "function"){
        //     callback()
        // }else{
        //     closePersonChat()
        // }

    }

    function closePersonChat(){
        camera.far = 700
        camera.updateProjectionMatrix()

        testBox.visible = true

        chatPersonName.value = ""
        chatMsgText.value = ""
        chatMsgIndex = 0
        chatMsgList = []
        chatClickFunc = null

        if (null != chatTargetObject){
            chatTargetObject.remove(camera)
            meshGroup.add(camera)
            loadCameraPosition()

            if (null != WithAIObjSet[chatTargetObject.parent.uuid]){
                WithAIObjSet[chatTargetObject.parent.uuid].action = "chat_complete"
            }

            chatTargetObject = null
            // beforeCameraPosition = null
            // beforeCameraUp = null
            // beforeCameraRotation = null

            setTimeout(() => {
                chatVisible.value = false
            }, 25)


            controlFlag = true

            setTimeout(() => {
                bottomInteractionUiVisible.value = true
                upperRightUiVisible.value = true
                nippleViewVisible.value = true
            }, 250)
        }

    }

    function clickPersonChat(){
        chatMsgIndex += 1

        if (chatMsgIndex < chatMsgList.length){
            chatMsgText.value = chatMsgList[chatMsgIndex]
        }else{
            if (typeof chatClickFunc === "function"){
                chatClickFunc()
                chatClickFunc = null
            }

            chatMsgText.value = ""
            chatPersonName.value = ""
            chatClickFunc = null
            chatMsgList = []
            chatMsgIndex = 0


            closePersonChat()
        }
    }

    function clickCardHref(tag = true) {
        proxy.$refs.shopopeePhone.goCardView(cardId, tag)
        setTimeout(() => {
            closePersonChat()
        }, 250)

        closeCardBox()

        setTimeout(() => {
            controlFlag = false
        }, 500)
    }

    function goCardHref() {
        clickCardHref(false)
    }

    function goCardRequest() {
        clickCardHref(true)
    }

    function showCardBox(src, href, id) {
        cardHref = href
        currCardSrc.value = src
        cardId = id

        setTimeout(() => {
            cardVisible.value = true
        }, 250)
    }

    function closeCardBox() {
        // controlFlag = true

        setTimeout(() => {
            cardVisible.value = false
            cardHref = null
            currCardSrc.value = null
            closePersonChat()
        }, 250)
    }

    function hintNotOpenStore(){
      openConfirm(`${i18n.tkey("land_store_not_opent")} `, () => {

      })
    }

    function goShopConfirm(regionIndex, doorIndex) {
        const obj = regionMap.shopMap[regionIndex][doorIndex].data.threeShopModel
      if (-1 == obj.productVerify) {
        hintNotOpenStore()
      }else{

        seleteStor.value = obj
        companySelectorVisible.value = true
       /* if (null == obj.companyHallId){

            openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.companyName} ${i18n.tkey("lang_go_eshopopee_shop_confrim_2")}`, () => {
                userInfoRef.value.fromEshopopee = true

                const window2 = window.open("", "eshopopee")

                setTimeout(() => {
                    window2.location.href = myUtil.generateEShopopeeShopUrl(obj.accCompanyCode, obj.addinfo7)
                }, 1000)

                // location.href = myUtil.generateEShopopeeShopUrl(obj.accCompanyCode, obj.addinfo7)
            })
        }else{
            openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.companyName} ${i18n.tkey("lang_go_shop_confirm_3")}`, () => {
                // savePersonPosition()
                pageInfoRef.value.hid = props.hid
                pageInfoRef.value.fid = regionMap.currPage
                pageInfoRef.value.did = doorIndex
                proxy.$router.push({path: `/pe/${obj.companyHallId}`})
            })
        }*/
      }

    }

    function saveCameraPosition() {
        beforeCameraPosition = camera.position.clone()
        beforeCameraUp = camera.up.clone()
        beforeCameraRotation = camera.rotation.clone()
    }

    function loadCameraPosition() {
        camera.position.set(beforeCameraPosition.x, beforeCameraPosition.y, beforeCameraPosition.z)
        camera.lookAt(beforeCameraUp)
        camera.rotation.set(beforeCameraRotation.x, beforeCameraRotation.y, beforeCameraRotation.z)

        beforeCameraPosition = null
        beforeCameraUp = null
        beforeCameraRotation = null
    }

    function openNewChat(login, flag) {
        if (userInfoRef.value.login === login){
            openConfirm(i18n.tkey("lang_not_chat_self"))
        }else {
            proxy.$refs.shopopeePhone.openPersonChat(login, flag)

            setTimeout(() => {
                controlFlag = false
            }, 500)
        }
    }

    function openNewQuotation(login) {
        if (userInfoRef.value.login === login){
            openConfirm(i18n.tkey("lang_not_quote_self"))
        }else {
            proxy.$refs.shopopeePhone.openPersonChat(login, true)

            setTimeout(() => {
                controlFlag = false
            }, 500)
        }
    }

    function goProductQuotation(login, companycode) {
        if (userInfoRef.value.login === login){
            openConfirm(i18n.tkey("lang_not_quote_self"))
        }else {
            proxy.$refs.shopopeePhone.goProductQuotation(companycode)

            setTimeout(() => {
                controlFlag = false
            }, 500)
        }
    }

    function phoneCommandCallback(functionName, status, data){
        // if (functionName === "openPersonChat" || functionName === "goCardView"){
        shopopeeChatVisible.value = true
        bottomInteractionUiVisible.value = false
        upperRightUiVisible.value = false
        nippleViewVisible.value = false
        controlFlag = false
        setTimeout(() => {
            shopopeeChatStatus.value = "show"
        }, 25)
        // }
    }

    function loginCallback(){
        // if (loadingPercent.value < 100){
        //
        //     loadingPercent.value = 10
        //
        //     getShopList()
        // }
    }

    function goShopPosition(wa, siojournal) {
        // regionMap.selectShopIndex = siojournal
        // regionMap.currPage = Number(wa) - 1
        // goNextRegion(false)
    }

    function goThreeGuide() {
        hideShopopeeChatBox()

        setTimeout(() => {
            guideViewVisible.value = true
            controlFlag = false
        }, 250)

    }

    function clickAudio() {

    }

    function clickReturnShopopee() {
        hideShopopeeChatBox()

        setTimeout(() => {
            confirmReturnShopopee()
        }, 250)
    }

    function confirmReturnShopopee() {
        openConfirm(i18n.tkey("lang_return_shopopee_confirm"), () => {
            window.location.href = `${proxy.$ShopopeeUrl}my_memberwork`
        })
    }

    function hideShopopeeChatBox() {
        if (shopopeeChatStatus.value === "hide"){
            return
        }

        shopopeeChatStatus.value = "hide"

        // setTimeout(() => {
        shopopeeChatVisible.value = false
        bottomInteractionUiVisible.value = true
        upperRightUiVisible.value = true
        nippleViewVisible.value = true
        controlFlag = true
        // }, 1450)
    }

    function clickHallSearch() {
      //hallSearchVisible.value = true
      proxy.$router.push({
        path: `/hallSearch/${props.hid}`
      })
    }
    function clickSearchInput() {
        proxy.$refs.shopopeePhone.goSearchView()
    }

    function goChatView() {
        proxy.$refs.shopopeePhone.goChatView()
    }

    function goLogin() {
        proxy.$refs.shopopeePhone.goLoginView()
    }

    function goAccountView() {
        // proxy.$refs.shopopeePhone.goMyCardView()
        proxy.$refs.shopopeePhone.goDisplayIndexView()
    }

    function goShopMaterialList(obj) {

      var whereStr=""
      if(hallObjInfo.value.addinfo23 !=='1'){
        whereStr =`hall=${hallObjInfo.value.id}&`
      }

      if (myUtil.isNotEmpty(userInfoRef.value.login)){//
        whereStr+=`fromShopopeeMall=-1&shopopeeLogin=${userInfoRef.value.login}&`
      }
        const url = `${proxy.$SSL}://${obj.procedurename}/Web/W006/single_product.asp?${whereStr}productID=${obj.productid}&ProductCompanyCode=${obj.acccode}&CompanyCode=${obj.acccode}&formUrl=exhibition`

        openConfirm(i18n.tkey("lang_go_eshopopee_confirm_1"), () => {
            // location.href = url
            myUtil.goURLNewWindow(url, "web")
        })

    }

    //記錄訪問量
    async function saveShopVisits() {

        const request = record12Api.insertHallViewRecord
        const params = request.getParams()

        params.companycode = null
        params.login = userInfoRef.value.login
        params.addinfo1 = userInfoRef.value.hid
        params.addinfo2 = userInfoRef.value.id
        params.addinfo3 = userInfoRef.value.country

        request.send(params, () => {})

    }

    //店鋪名
    function createHallNamePad(object){
        var textName = hallObjInfo.recordname

        if (userInfoRef.value.lang != 'zh' && userInfoRef.value.lang != 'szh'){
          textName = hallObjInfo.addinfo6
        }

      var iszh =  /[\u4e00-\u9fa5]/.test(textName);
      var text = textName.replace("有限公司","")
      text = text.replace("公司","")
      text = text.replace("company limited","")
      text = text.replace(" limited","")
      text = text.replace(" Limited","")
      text = text.replace(" Limit","")

        let fontsize = 1160 / text.length
        let xLeft

        // if (fontsize > 130){
        //     fontsize = 130
        // }

      if (fontsize > 72){
        fontsize = 72
      }
      if(!iszh){
        if(fontsize<14){
          fontsize = fontsize*2.5
        }else if(fontsize<48){
          fontsize = fontsize*2
        }
      }else{
        if(fontsize<14){
          fontsize = fontsize*2
        }else if(fontsize<48){
          fontsize = fontsize*1.5
        }
      }

        // xLeft = 20 + (1160 - fontsize * text.length) / 2

        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d')
        canvas.width = 1200
        canvas.height = 240
        //制作矩形
        ctx.fillStyle = "transparent";
        // ctx.fillStyle = "#0000ff";
        // ctx.drawImage(shopSignTexture, 0, 0, 1200, 200)
        ctx.fillRect(0, 0, 1200, 240)
        //设置文字
        ctx.fillStyle = "#333333";
        // ctx.fillStyle = "#000000";
        ctx.font = `normal ${fontsize}px "楷体"`
        var textWidth = ctx.measureText(text).width;
        xLeft = 20 + (1160 - textWidth) / 2
        // ctx.fillText(text, xLeft, (170 + fontsize) / 2)
        // ctx.fillText(text, xLeft, (140 + fontsize) / 2)
        // ctx.fillText(text, xLeft, 80 + fontsize / 2)
        ctx.fillText(text, xLeft, 120 + fontsize / 2)

        //生成图片
        let url = canvas.toDataURL('image/png');

        let map = texLoader.load(url)

        map.flipY = false

        // if (rotation != 0){
        //     // 设置旋转中心点
        //     map.center.set(0.5, 0.5)
        //     map.rotation = rotation * Math.PI / 180
        // }

        const material = new THREE.MeshBasicMaterial({
            map: map,
            side: THREE.DoubleSide,
            opacity: 1,
            transparent: true
        })

        object.material = material
    }

    function createFloorNamePad(){
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d')
        canvas.width = 150
        canvas.height = 100
        //制作矩形
        ctx.fillStyle = "transparent";
        ctx.fillRect(0, 0, 150, 100)
        //设置文字
        ctx.fillStyle = "#ff0000";
        ctx.font = 'normal 100px "楷体"'
        ctx.fillText(regionMap.currPage + "F", 10, 80)

        //生成图片
        let url = canvas.toDataURL('image/png');
        //删除dom
        canvas.remove()
        //将图片构建到纹理中
        const orgMaterial = hallFloorPadMesh.material
        const map = texLoader.load(url)

        map.flipY = false

        hallFloorPadMesh.material = new THREE.MeshBasicMaterial({
            map: map,
            side: THREE.DoubleSide,
            opacity: 1,
            transparent: true
        })

        try {
            orgMaterial.dispose()
        }catch (e) {

        }
    }

    function goSelectFloor(num, dnum){
        if (null != num){
            selectFloorNum.value = num
        }

        if (num == regionMap.currPage && myUtil.isEmpty(dnum)){
            closeSelectFloor()
            return
        }

        regionMap.currPage = selectFloorNum.value
        regionMap.selectShopIndex = dnum
        toggleSelectFloorBox(false)
        goNextRegion()
        regionMap.selectShopIndex = null
    }

    function closeSelectFloor(){
        toggleSelectFloorBox(false)
    }

    //顯示或者關閉樓層選擇窗口
    function toggleSelectFloorBox(flag = true) {
        if (flag === true){
            moveFlag = false
            speed = 0
            selectFloorNum.value = regionMap.currPage
            selectFloorVisible.value = true
            controlFlag = false
        }else{
            selectFloorNum.value = regionMap.currPage
            selectFloorVisible.value = false
            controlFlag = true
        }

    }

    function goHallShopList(){
        hallShopListVisible.value = true
    }

    function goJoinMall(){
        pageInfoRef.value.inviteHallId = userInfoRef.value.hid
    }

    function savePersonPosition() {
        userInfoRef.value.fid = regionMap.currPage
        userInfoRef.value.hallPositionX = meshGroup.position.x
        userInfoRef.value.hallPositionZ = meshGroup.position.z
    }

    function goNextRegion() {
        //显示过渡页面
        loadingCarViewVisible.value = true
        //關閉下方的操作欄
        bottomInteractionUiVisible.value = false
        //關閉右上角的操作欄
        upperRightUiVisible.value = false
        //隱藏搖桿
        nippleViewVisible.value = false
        //关闭手机
        shopopeeChatVisible.value = false
        //是否使用店铺传送点
        let transferTag = null != regionMap.selectShopIndex
        //不允许操作
        controlFlag = false
        //清除当前区域信息
        clearSenceData()
        //清除下方操作栏内容
        clearBottomUI()

        //清除区牌材质
        createFloorNamePad()

        userInfoRef.value.fid = regionMap.currPage

        //将人物移动到初始坐标
        if (null != regionMap.selectShopIndex){
            movePersonToShopPosition(regionMap.selectShopIndex)
            regionMap.selectShopIndex = null
        }

        toggleActiveMotion("idle")

        //刪除店鋪數據
        for (const key in regionMap.shopMap){
            const obj = regionMap.shopMap[key]
            obj.shopObj = null
            obj.shopman = null
        }

        for (const key in shopPointMap){
            const obj = shopPointMap[key]
            obj.shopObj = null
            obj.shopman = null
        }

        const notDelList = []

        interactionList.forEach((v, i) => {
            if (false == v.__deleteTag__){
                notDelList.push(v)
            }
        })

        interactionList = notDelList

        if (hallObjInfo.addinfo17 === "1"||hallObjInfo.addinfo24 ==="2"){
            if (regionMap.currPage > 1){
                if (!transferTag){
                    meshGroup.position.x = moveFloorPosition.x
                    meshGroup.position.y = moveFloorPosition.y
                    meshGroup.position.z = moveFloorPosition.z
                }else{
                    meshGroup.position.y = moveFloorPosition.y
                }

                if (cameraOptionObj.defaultLookAtPosition < 5){
                    cameraOptionObj.defaultLookAtPosition += 5
                    cameraOptionObj.currLookAtPosition += 5
                }

                airWallList["second_floor_air_wall"] = {
                    MAX_POSITION_X: 15.5,
                    MIN_POSITION_X: -15.5,
                    MAX_POSITION_Z: 30.8,
                    MIN_POSITION_Z: -31.75
                }

            }else{
                meshGroup.position.y = 0

                if (cameraOptionObj.defaultLookAtPosition > 5){
                    cameraOptionObj.defaultLookAtPosition -= 5
                    cameraOptionObj.currLookAtPosition -= 5
                }

                delete airWallList["second_floor_air_wall"]
            }

            calcCameraPosition()
        }

        setTimeout(() => {
            //加载下一区的数据
            if (hallObjInfo.addinfo17 === "1"||hallObjInfo.addinfo24 ==="2"){
                createShopAndMan2()
            }else{
                createShopAndMan()
            }

        }, 1000)

        setTimeout(() => {
            nippleViewVisible.value = false
        }, 251)

        setTimeout(() => {
            //关闭过渡页面
            loadingCarViewVisible.value = false
            //重新顯示下方的操作欄
            bottomInteractionUiVisible.value = true
            //重新顯示右上角的操作欄
            upperRightUiVisible.value = true
            //重新顯示搖桿
            nippleViewVisible.value = true
            //允许操作
            controlFlag = true
            //保存主角位置
            savePersonPosition()
        }, 5500)
    }

    function clearSenceData() {
        clearDataList.forEach((v, i) => {
            disposeData(v)
        })

        clearMeshList.forEach((v, i) => {
            disposeMesh(v)
        })

        clearAIList.forEach((v, i) => {
            disabledAIObj(v)
        })

        clearDataList = []
        clearMeshList = []
        clearAIList = []
    }

    //清除下方操作栏
    function clearBottomUI() {
        for (const key in bottomUIObj.value){
            if (key in bottomUIObj.value){
                delete bottomUIObj.value[key]
            }
        }
    }

    function disposeMesh(mesh) {
        try {
            mesh.parent.remove(mesh)

            mesh.traverse((child) => {
                if (child.material) {
                    child.material.dispose();
                }
                if (child.geometry) {
                    child.geometry.dispose();
                }
                child = null;
            })
        }catch (e) {
            // console.log(e)
        }
    }

    function disposeData(data) {
        try {
            data.map[data.key] = null
            delete data.map[data.key]
        }catch (e) {
            console.log(e)
        }
    }

    //將主角傳送到某個店鋪門口
    function movePersonToShopPosition(doorNum) {
        let index = Number(doorNum) > 9 ? doorNum : "0" + doorNum

        if ((hallObjInfo.addinfo17 == "1" ||hallObjInfo.addinfo24 ==="2") && regionMap.currPage > 1){
            index = "shop_2_" + index
        }

        const obj = shopPointMap[index].positionObj

        const shopPosition = new THREE.Vector3()

        obj.getWorldPosition(shopPosition)
        shopPosition.x = myUtil.toDecimal2(shopPosition.x)
        shopPosition.z = myUtil.toDecimal2(shopPosition.z)

        obj.traverse((child) => {
            // if (child.name === `billboard_${index}`){
            //     child.parent.getWorldPosition(shopPosition)
            // }
            let transferName = `shoptransfer_${index}`

            if (hallObjInfo.addinfo17 == "1"||hallObjInfo.addinfo24 ==="2"){
                transferName = "shoptransfer_1_" + index

                if (regionMap.currPage > 1){
                    transferName = "shoptransfer_2_" + index.replaceAll("shop_2_", "")
                }
            }

            if (child.name === transferName){
                const worldPosition = new THREE.Vector3()
                child.getWorldPosition(worldPosition)
                worldPosition.x = myUtil.toDecimal2(worldPosition.x)
                worldPosition.z = myUtil.toDecimal2(worldPosition.z)
                meshGroup.position.copy(worldPosition)

                const cameraDirect = new THREE.Vector3()
                cameraDirect.x = worldPosition.x - shopPosition.x
                cameraDirect.z = worldPosition.z - shopPosition.z
                cameraDirect.normalize()

                if (Math.abs(cameraDirect.x) > Math.abs(cameraDirect.z)){
                    camera.position.z = 0

                    if (cameraDirect.x > 0){
                        camera.position.x = cameraOptionObj.currCameraDistance
                    }else{
                        camera.position.x = cameraOptionObj.currCameraDistance * -1
                    }
                }else{
                    camera.position.x = 0

                    if (cameraDirect.z > 0){
                        camera.position.z = cameraOptionObj.currCameraDistance
                    }else{
                        camera.position.z = cameraOptionObj.currCameraDistance * -1
                    }
                }

                camera.position.y = cameraOptionObj.currCameraPositionY
                camera.lookAt(new THREE.Vector3(meshGroup.position.x,1.6,meshGroup.position.z));
                testBox.lookAt(shopPosition)

                if (cameraDirect.x > 0 && cameraDirect.z == 0){
                    rotationNum = 0
                }else{
                    rotationNum = cameraDirect.x * Math.PI + cameraDirect.z * Math.PI / 2
                }

            }
        })

        savePersonPosition()
    }

    function disabledAIObj(obj){
        obj.AI = null
    }

    function goViewImg(url, name, btnText, previewDoorNum){
        controlFlag = false
        moveFlag = false
        speed = 0
        nippleViewVisible.value = false
        previewImgTitle.value = name
        previewImgUrl.value = url
        previewBtnText.value = btnText
        previewImgDoor = previewDoorNum
    }

    function closeViewImg(){
        previewImgDoor = null

        setTimeout(() => {
            controlFlag = true
            nippleViewVisible.value = true
            previewImgUrl.value = null
            previewImgTitle.value = null
            previewBtnText.value = null
        }, 250)
    }

    function clickImgBtn() {
        const doorNum = previewImgDoor
        closeViewImg()

        if (null != doorNum){
            loadingCarViewVisible.value = true
            setTimeout(() => {
                movePersonToShopPosition(doorNum)
            }, 251)

            setTimeout(() => {
                loadingCarViewVisible.value = false
            }, 500)
        }
    }

    //生成门牌号材质
    function createShopNumMaterial(object, num) {
        Promise.all([
            loadImage(process.env.BASE_URL + "mytextures/shop_num_pad.png")
        ]).then((images) => {
            //用canvas生成图片
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext('2d')

            canvas.width = 60
            canvas.height = 40
            //制作矩形
            ctx.drawImage(images[0], 0, 0, 60, 40)
            //设置文字
            ctx.fillStyle = "red";
            ctx.font = 'normal 23px "楷体"'
            ctx.fillText(`${regionMap.currPage}-${num}`, 1, 30)
            // ctx.fillText(num, 20, 30)

            //生成图片
            let url = canvas.toDataURL('image/png');

            const map = texLoader.load(url)
            // map.center.set(0.5, 0.5)
            // map.rotation = -90 * Math.PI / 180

            map.flipY = false

            canvas.remove()

            //将图片构建到纹理中
            let material1 = new THREE.MeshBasicMaterial({
                map: map,
                side: THREE.DoubleSide,
                opacity: 1,
                transparent: true
            })

            object.material = material1

        })
    }

    //生成店鋪名字材质
    function createShopnameMaterial(object, name) {
        let fontsize = Math.floor(530 / name.length)

        if (fontsize > 45){
            fontsize = 44
        }

        //用canvas生成图片
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d')

        canvas.width = 550
        canvas.height = 50

        //制作矩形
        ctx.fillStyle = "#337ecc";
        ctx.fillRect(0, 0, 550, 50)


        //设置文字
        ctx.fillStyle = "#FFFFFF";
        ctx.font = `normal ${fontsize}px "楷体"`
        ctx.fillText(name, 5, 22 + fontsize / 2)

        //生成图片
        let url = canvas.toDataURL('image/png');

        const map = texLoader.load(url)
        // map.center.set(0.5, 0.5)
        // map.rotation = -90 * Math.PI / 180

        map.flipY = false

        canvas.remove()

        //将图片构建到纹理中
        let material1 = new THREE.MeshBasicMaterial({
            map: map,
            side: THREE.DoubleSide,
            opacity: 1,
            transparent: true
        })

        object.material = material1
    }
    var selein = 0
    //生成店鋪名字材质
    function createShopnameMaterial3(object, name) {
      let fontsize = Math.floor(530 / name.length)

      if (fontsize > 32){
        fontsize = 32
      }

      //用canvas生成图片
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext('2d')

      canvas.width = 550
      canvas.height = 50
      const backgroundColors = [
        // 彩色背景
        "#006400",
        "#228B22",
        "#800080",
        "#9400D3",
        "#FF4500",
        "#FF6347",
        // 深色背景
        "#000000",
        "#00008B",
        "#1E90FF",
        "#333333",
        "#444444",
        // 柔和浅色背景
        "#87CEEB",
        "#B0C4DE"
      ];
      if(selein>=backgroundColors.length){
        selein = 0
      }
      //制作矩形
      ctx.fillStyle = backgroundColors[selein];
      selein+=1;
      ctx.fillRect(0, 0, 550, 50)


      //设置文字
      let xLeft = 5
      ctx.fillStyle = "#FFFFFF";
      ctx.font = `normal ${fontsize}px "楷体"`
      const textWidth = ctx.measureText(name).width;
      xLeft = 5 + (540 - textWidth) / 2
      ctx.fillText(name, xLeft, 21 + fontsize / 2)

      //生成图片
      let url = canvas.toDataURL('image/png');

      const map = texLoader.load(url)
      // map.center.set(0.5, 0.5)
      // map.rotation = -90 * Math.PI / 180

      map.flipY = false

      canvas.remove()

      //将图片构建到纹理中
      let material1 = new THREE.MeshBasicMaterial({
        map: map,
        side: THREE.DoubleSide,
        opacity: 1,
        transparent: true
      })

      object.material = material1
      return material1;
    }
    //生成店鋪名字材质
    function createShopnameMaterial2(object, name) {
        let fontsize = Math.floor(530 / name.length)

        if (fontsize > 32){
            fontsize = 32
        }

        //用canvas生成图片
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext('2d')

        canvas.width = 550
        canvas.height = 50

        //制作矩形
        // ctx.fillStyle = "#337ecc";
        // ctx.fillRect(0, 0, 550, 50)


        //设置文字
        let xLeft = 5
        ctx.fillStyle = "#FFFFFF";
        ctx.font = `normal ${fontsize}px "楷体"`
        const textWidth = ctx.measureText(name).width;
        xLeft = 5 + (540 - textWidth) / 2
        ctx.fillText(name, xLeft, 21 + fontsize / 2)

        //生成图片
        let url = canvas.toDataURL('image/png');

        const map = texLoader.load(url)
        // map.center.set(0.5, 0.5)
        // map.rotation = -90 * Math.PI / 180

        map.flipY = false

        canvas.remove()

        //将图片构建到纹理中
        let material1 = new THREE.MeshBasicMaterial({
            map: map,
            side: THREE.DoubleSide,
            opacity: 1,
            transparent: true
        })

        object.material = material1
    }

    //創建迎賓人員
    function createUsher(positionGroup) {
        const withAIObj = getEmptyWithAIObj()

        withAIObj.login = ""
        withAIObj.name = ""
        withAIObj.memMale = ""
        withAIObj.whatsshopsbcataList = ""
        withAIObj.companyName = ""

        let scaleY = 0.2

        if (hallObjInfo.addinfo17 === "1"||hallObjInfo.addinfo24 ==="2"){
            scaleY = null
        }

        // loadFbxModel("town2/boy21.fbx", {
        loadGlbModel("town2/aman.gltf",{
            // positionX: -12,
            // positionY: 0,
            // positionZ: -30,
            // scaleY: scaleY,
            loadCallback: (gltf,model) => {
                withAIObj.model = model

                const mixer = new THREE.AnimationMixer( model );
                mixerObj[model.uuid] = mixer

                withAIObj.allActions = {};

                let animations = gltf.animations;

                for ( let i = 0; i !== animations.length; ++ i ) {
                    //動作
                    const clip = animations[ i ];
                    const action = mixer.clipAction( clip );
                    withAIObj.allActions[clip.name ] = action;

                }

                withAIObj.activeAction = withAIObj.allActions['waving'];
                withAIObj.activeAction.play();

                withAIObj.action = 'waving'

                model.traverse( function ( object ) {
                    if ( object.isMesh ) {
                        object.material.emissive = null;
                        object.material.emissiveIntensity = 0;
                        object.material.emissiveMap = null;
                    }
                });

            },
            callback: (group) => {

                if (hallObjInfo.addinfo17 == "1"||hallObjInfo.addinfo24 ==="2"){
                    WithAIObjSet[group.uuid] = withAIObj
                    withAIObj.group = group

                    // 加载店员的ai
                    withAIObj.AI = ShopmanAI
                }

                positionGroup.add(group)

            }
        })
    }

    //创建观众
    function createWatcher(positionGroup) {
        return
        const withAIObj = getEmptyWithAIObj()

        withAIObj.login = ""
        withAIObj.name = ""
        withAIObj.memMale = ""
        withAIObj.whatsshopsbcataList = ""
        withAIObj.companyName = ""

        loadGlbModel("town2/aman.gltf",{
            loadCallback: (gltf,model) => {
                withAIObj.model = model

                const mixer = new THREE.AnimationMixer( model );
                mixerObj[model.uuid] = mixer

                withAIObj.allActions = {};

                let animations = gltf.animations;

                for ( let i = 0; i !== animations.length; ++ i ) {
                    //動作
                    const clip = animations[ i ];
                    const action = mixer.clipAction( clip );
                    withAIObj.allActions[clip.name ] = action;

                }

                withAIObj.activeAction = withAIObj.allActions['idle'];
                withAIObj.activeAction.play();

                withAIObj.action = 'idle'

                model.traverse( function ( object ) {
                    if ( object.isMesh ) {
                        object.material.emissive = null;
                        object.material.emissiveIntensity = 0;
                        object.material.emissiveMap = null;
                    }
                });

            },
            callback: (group) => {

                positionGroup.add(group)

            }
        })
    }

    //创建主持人
    function createHostMan(positionGroup) {
        const withAIObj = getEmptyWithAIObj()

        withAIObj.login = ""
        withAIObj.name = ""
        withAIObj.memMale = ""
        withAIObj.whatsshopsbcataList = ""
        withAIObj.companyName = ""

        loadGlbModel("town2/aman.gltf",{
            loadCallback: (gltf,model) => {
                withAIObj.model = model

                const mixer = new THREE.AnimationMixer( model );
                mixerObj[model.uuid] = mixer

                withAIObj.allActions = {};

                let animations = gltf.animations;

                for ( let i = 0; i !== animations.length; ++ i ) {
                    //動作
                    const clip = animations[ i ];
                    const action = mixer.clipAction( clip );
                    withAIObj.allActions[clip.name ] = action;

                }

                withAIObj.activeAction = withAIObj.allActions['idle'];
                withAIObj.activeAction.play();

                withAIObj.action = 'idle'

                model.traverse( function ( object ) {
                    if ( object.isMesh ) {
                        object.material.emissive = null;
                        object.material.emissiveIntensity = 0;
                        object.material.emissiveMap = null;
                    }
                });

            },
            callback: (group) => {

                WithAIObjSet[group.uuid] = withAIObj
                withAIObj.group = group

                // 加载店员的ai
                withAIObj.AI = hostManAI

                positionGroup.add(group)

            }
        })
    }

    //创建模特
    function createModelMan(positionGroup) {
        const withAIObj = getEmptyWithAIObj()
        const vec3 = positionGroup.position

        withAIObj.login = ""
        withAIObj.name = ""
        withAIObj.memMale = ""
        withAIObj.whatsshopsbcataList = ""
        withAIObj.companyName = ""
        withAIObj.targetPositionList = [
            new THREE.Vector3(vec3.x, vec3.y - 0.07, vec3.z + 5),
            new THREE.Vector3(vec3.x, vec3.y - 0.07, vec3.z - 12),
            new THREE.Vector3(vec3.x, vec3.y - 0.07, vec3.z + 5),
        ]

        // let boxGeometry = new THREE.BoxGeometry(1, 6, 1)
        // let lambertMaterial = new THREE.MeshBasicMaterial({
        //     color: 0xff0000
        // })
        //
        // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
        // scene.add(mesh)
        //
        // mesh.position.x = vec3.x
        // mesh.position.z = vec3.z - 12

        loadGlbModel("town2/aman.gltf",{
            loadCallback: (gltf,model) => {
                withAIObj.model = model

                const mixer = new THREE.AnimationMixer( model );
                mixerObj[model.uuid] = mixer

                withAIObj.allActions = {};

                let animations = gltf.animations;

                for ( let i = 0; i !== animations.length; ++ i ) {
                    //動作
                    const clip = animations[ i ];
                    const action = mixer.clipAction( clip );
                    withAIObj.allActions[clip.name ] = action;

                }

                withAIObj.activeAction = withAIObj.allActions['idle'];
                withAIObj.activeAction.play();

                withAIObj.action = 'init'

                model.traverse( function ( object ) {
                    if ( object.isMesh ) {
                        object.material.emissive = null;
                        object.material.emissiveIntensity = 0;
                        object.material.emissiveMap = null;
                    }
                });

            },
            callback: (group) => {

                WithAIObjSet[group.uuid] = withAIObj
                withAIObj.group = group

                // 加载店员的ai
                withAIObj.AI = modelManAI

                positionGroup.add(group)

            }
        })
    }

    function loadImage(url) {
        return new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.src = url;
            img.remove()
        })
    }
    function clickgoMall(){
      proxy.$router.push({
        path: `/Personal/`+userInfoRef.value.hid
      })
    }

    function clickReturn3DCityBtn(){
        toggleSelectFloorBox(false)
        // selectFloorVisible.value = false

        openConfirm(i18n.tkey("lang_return_3dShop_confirm_1"), () => {
            pageInfoRef.value.userFrom = 0
            pageInfoRef.value.rotationNum = Math.PI / 2

            if (null == userInfoRef.value.islandID){
                proxy.$router.push({
                    name: "demoIndex2"
                })
            }else{
                proxy.$router.push({
                    path: `/${userInfoRef.value.islandID}/index`
                })
            }



        })
    }

    function goShopHallPosition(fid, did){
        regionMap.currPage = fid
        regionMap.selectShopIndex = did

        goNextRegion()
    }

    function createShopAdMaterial(){
        let filename = hallObjInfo.addinfo15

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
            filename = hallObjInfo.addinfo16
        }

        if (myUtil.isEmpty(filename)){
            filename = `${publicPath}mymodels/fbx/island/pav/hall_banner_1.jpg`
        }

        const texture = texLoader.load(filename);

        texture.flipY = false

        const material = new THREE.MeshBasicMaterial({ //普通材质
            map: texture,
            lightMap: texture
        });

        shopAdMeshList.forEach((v, i) => {
            v.material = material
        })

    }

    function screenShotCallback(obj, base64){
        if (null == obj){
            return
        }

        delete imgGenerateMap.value[obj.uuid]

        const verticalAdsText1 = texLoader.load(base64);

        verticalAdsText1.flipY = false

        const verticalAdsMaterial1 = new THREE.MeshBasicMaterial({ //普通材质
            // color: 0xffffff,
            map: verticalAdsText1,
        });
        obj.mesh.material = verticalAdsMaterial1
        obj.mesh.material.lightMap = verticalAdsText1

        interactionList.push(obj.mesh)
        interactionObj[obj.mesh.uuid] = [{
            callback: () => {
                goViewImg(base64)
            }
        }]

        clearDataList.push({"key": obj.mesh.uuid, map: interactionObj})
    }

    function loadHallDoorAdvImg(){
        hallDoorAdvList.forEach((item, index) => {
            const imgIndex = item.name.replaceAll("Billboard_ad_0", "")

            const imgUrl = `${process.env.BASE_URL}mytextures/hallAdv/hall_adv_${imgIndex}.jpg?r=${proxy.$versionNum}`
            const map = texLoader.load(imgUrl)

            map.flipY = false

            const material = new THREE.MeshBasicMaterial({
                map: map,
                lightMap: map,
                // side: THREE.DoubleSide,
                // opacity: 1,
                // transparent: true
            })

            map.flipY = false

            item.material = material

            interactionList.push(item)
            interactionObj[item.uuid] = [{
                callback: () => {
                    goViewImg(imgUrl)
                }
            }]
        })
    }

    function getHallOperateMode(){
        return operateMode
    }

    function setHallOperateMode(name){
        rotationNumY = 0
        operateMode = name
        calcCameraPosition()
    }

    function clickReturnIcon(){
        moveFloorPosition.x = 16.5
        moveFloorPosition.y = 5
        moveFloorPosition.z = 0

        toggleSelectFloorBox(true)
    }

    function toggleScene(){
        let text = i18n.tkey("lang_toggle_shop_confirm_1")
        let value = "1"

        if (userInfoRef.value.demo_stage == "1"){
            text = i18n.tkey("lang_toggle_hall_confirm_1")
            value = "0"
        }

        myUtil.confirmWarning(text, () => {
            userInfoRef.value.demo_stage = value
            reload()
        })
    }

    function loadServeDesk(parent) {
        // let boxGeometry = new THREE.BoxGeometry(5.5, 2, 5.5)
        // let lambertMaterial = new THREE.MeshBasicMaterial({
        //     color: 0xff0000
        // })
        //
        // const mesh = new THREE.Mesh(boxGeometry, lambertMaterial)
        // parent.add(mesh)

        const vec3 = new THREE.Vector3()
        parent.getWorldPosition(vec3)

        vec3.y = 0

        interactionObj[parent.uuid] = [{
            distance: 6,
            icon: "fa-solid fa-comments",
            // name: shopData.companyName,
            name: i18n.tkey("lang_ask_text"),
            // mesh: shopList[index].children[0],
            mesh: parent,
            callback: () => {
                clickSearchInput(true)
            }
        }]

        airWallList[parent.uuid] = {
            MAX_POSITION_X: vec3.x + 3,
            MIN_POSITION_X: vec3.x - 3,
            MAX_POSITION_Z: vec3.z + 3,
            MIN_POSITION_Z: vec3.z - 3,
        }

        loadGlbModel("island/pav/servertable.gltf", {
            positionY: 0,
            loadCallback: (gltf,model) => {

            },
            callback: (group) => {
                parent.add(group)

            }
        })
    }

    function clickInteractionCallback(value){
        if(null != value && null != value.callback && typeof value.callback === "function"){
            value.callback()
        }
    }

    function createStageContent(object) {
        if (hallObjInfo.addinfo19.mode == 1){
            const positionGroup = new THREE.Group()
            const vec3 = new THREE.Vector3()

            object.getWorldPosition(vec3)
            vec3.y = 0.5

            scene.add(positionGroup)
            positionGroup.position.copy(vec3)
            positionGroup.rotation.y = Math.PI

            //创建主持人
            createHostMan(positionGroup)

            //创建观众
            for (let i = 0; i < 5; i++){
                const randomNumX = Math.random()
                const randomNumZ = Math.random()
                const watcherGroup = new THREE.Group()
                const position = new THREE.Vector3(vec3.x + 4.5 - 2 * i - randomNumX, 0, vec3.z - 8 + randomNumZ)

                scene.add(watcherGroup)
                watcherGroup.position.copy(position)

                createWatcher(watcherGroup)
            }

            for (let i = 0; i < 7; i++){
                const randomNumX = Math.random()
                const randomNumZ = Math.random()
                const watcherGroup = new THREE.Group()
                const position = new THREE.Vector3(vec3.x + 7 - 2 * i - randomNumX, 0, vec3.z - 10 + randomNumZ)

                scene.add(watcherGroup)
                watcherGroup.position.copy(position)

                createWatcher(watcherGroup)
            }


        }else if(hallObjInfo.addinfo19.mode == 2){
            const positionGroup = new THREE.Group()
            const vec3 = new THREE.Vector3()

            object.getWorldPosition(vec3)
            // vec3.y = 0.5
            // vec3.z -= 12
            // vec3.z += 5

            scene.add(positionGroup)
            positionGroup.position.copy(vec3)

            //创建模特
            createModelMan(positionGroup)

            //创建观众
            for (let i = 0; i < 5; i++){
                const randomNumX = Math.random()
                const randomNumZ = Math.random()
                const watcherGroup = new THREE.Group()
                const position = new THREE.Vector3(vec3.x + 4.5 - 2 * i - randomNumX, 0, vec3.z - 18 + randomNumZ)

                scene.add(watcherGroup)
                watcherGroup.position.copy(position)

                createWatcher(watcherGroup)
            }

            for (let i = 0; i < 7; i++){
                const randomNumX = Math.random()
                const randomNumZ = Math.random()
                const watcherGroup = new THREE.Group()
                const position = new THREE.Vector3(vec3.x + 7 - 2 * i - randomNumX, 0, vec3.z - 20 + randomNumZ)

                scene.add(watcherGroup)
                watcherGroup.position.copy(position)

                createWatcher(watcherGroup)
            }
        }
    }

    function hostManAI(withAIObj){
        withAIObj.timer_1 += mixerUpdateDelta

        if (withAIObj.action === 'idle'){
            if (withAIObj.timer_1 > 4.5){
                withAIObj.action = 'waving'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "waving")
            }
        }else if(withAIObj.action === 'waving'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                toggleActiveMotionObj(withAIObj, "idle")
            }
        }else if(withAIObj.action === 'idle_wait'){
            if (withAIObj.timer_1 > 4.5){
                withAIObj.action = 'chating'
                withAIObj.timer_1 = 0

                const randomNum = Math.random()

                if (randomNum >= 0.2){
                    toggleActiveMotionObj(withAIObj, "talk")
                }else if(randomNum < 0.2){
                    toggleActiveMotionObj(withAIObj, "clapping")
                }

            }
        }else if(withAIObj.action === 'chating'){
            if (withAIObj.timer_1 > withAIObj.activeAction._clip.duration){
                withAIObj.action = 'idle_wait'
                withAIObj.timer_1 = 0
                withAIObj.timer_1 += Math.random() - 0.5

                toggleActiveMotionObj(withAIObj, "idle")
            }
        }
    }

    function modelManAI(withAIObj) {
        withAIObj.timer_1 += mixerUpdateDelta

        if (withAIObj.action === 'init'){
            let duration = 2000
            withAIObj.action = 'walk'
            withAIObj.timer_1 = 0

            if (withAIObj.targetIndex == null || withAIObj.targetIndex == 0){
                withAIObj.nextTargetPosition = withAIObj.targetPositionList[1]
                withAIObj.targetIndex = 0
            }else{
                withAIObj.nextTargetPosition = withAIObj.targetPositionList[withAIObj.targetIndex + 1]
            }


            withAIObj.group.position.copy(withAIObj.targetPositionList[withAIObj.targetIndex])
            duration = withAIObj.group.position.distanceTo(withAIObj.nextTargetPosition)
            duration = duration / 1.5 * 1000
            const tween = new TWEEN.Tween(withAIObj.group.position)
                .to({x: withAIObj.nextTargetPosition.x, z: withAIObj.nextTargetPosition.z}, duration)
                .start()
                .onStart(() => {
                    withAIObj.model.lookAt(withAIObj.nextTargetPosition)
                    toggleActiveMotionObj(withAIObj, "walk")
                })
                // .easing(TWEEN.Easing.Sinusoidal.In)
                .onComplete(() => {
                    delete animationObjGroup[withAIObj.group.uuid]
                    withAIObj.action = 'walk_complete'
                })

            animationObjGroup[withAIObj.group.uuid] = tween

        }else if (withAIObj.action === 'walk'){

        }else if(withAIObj.action === 'walk_complete'){
            toggleActiveMotionObj(withAIObj, "idle")
            withAIObj.timer_1 = 0
            withAIObj.action = "idle"

            withAIObj.targetIndex += 1

            if (withAIObj.targetIndex + 1 >= withAIObj.targetPositionList.length){
                withAIObj.action = 'rest'
            }
        }else if(withAIObj.action === 'idle'){
            if (withAIObj.timer_1 > 3){
                withAIObj.timer_1 = 0
                // withAIObj.targetIndex += 1
                //
                // if (withAIObj.targetIndex + 1 >= withAIObj.targetPositionList.length){
                //     withAIObj.action = 'rest'
                // }else{
                    withAIObj.action = 'init'
                // }
            }
        }else if(withAIObj.action === 'rest'){
            if (withAIObj.timer_1 < 2){
                withAIObj.model.visible = false
            }else{
                withAIObj.model.visible = true
                withAIObj.targetIndex = 0
                withAIObj.action = 'init'
            }
        }
    }

    function updateTween() {
        for( let i in animationObjGroup){
            animationObjGroup[i].update()
        }
    }

    function createGround(islandMesh) {
        return
        // 添加到程式碼
        var fadingReflectorOptions = {
            mixBlur: 0,
            mixStrength: 1,
            resolution: 512, // 材質圖的解析度
            blur: [0, 0], // 高斯模糊的材質解析度為何
            minDepthThreshold: 0.7,// 從多遠的地方開始淡出
            maxDepthThreshold: 2, // 到多遠的地方會淡出到沒畫面
            depthScale: 2,
            depthToBlurRatioBias: 2,
            mirror: 0,
            distortion: 2,
            mixContrast: 2,
            reflectorOffset: 0, // 鏡面跟物理中間是否要留一段距離才開始反射
            bufferSamples: 8,
        }

        // let fadingReflectorOptions = {
        //     mixBlur: 2,
        //     mixStrength: 1.5,
        //     resolution: 256, // 材質圖的解析度
        //     blur: [0, 0], // 高斯模糊的材質解析度為何
        //     minDepthThreshold: 0.7,// 從多遠的地方開始淡出
        //     maxDepthThreshold: 2, // 到多遠的地方會淡出到沒畫面
        //     depthScale: 2,
        //     depthToBlurRatioBias: 2,
        //     mirror: 0,
        //     distortion: 2,
        //     mixContrast: 2,
        //     reflectorOffset: 0, // 鏡面跟物理中間是否要留一段距離才開始反射
        //     bufferSamples: 8,
        // }

        const geometry = new THREE.PlaneGeometry(100, 100, 1, 1)
        const material = new THREE.MeshBasicMaterial()
        const mesh = new THREE.Mesh(geometry, material)
        // 將材質置換成MeshReflectorMaterial
        // mesh.material = new MeshReflectorMaterial(render, camera, scene, mesh, fadingReflectorOptions);
        mesh.material = new MeshReflectorMaterial(render, camera, islandMesh, mesh, fadingReflectorOptions);
        scene.add(mesh);
        // 旋轉mesh角度以作為地面
        mesh.rotateX(Math.PI * -0.5)
        // mesh.position.y = 0.1

        groundMesh = mesh
    }

    function getHallObj(){
        return hallObjInfo
    }

    function goChatCallback(obj) {
        chatCardId.value = null
        chatSelectorVisible.value = false
      var dlangStr=""
      if (userInfoRef.value.lang === "zh" || userInfoRef.value.lang === "szh"){
        dlangStr="&lang=HK"
      }
   var url = `${baseUrl.SSL}://${baseUrl.eshopopee}/AIPage/AISales.asp?ChatCom=CCA5C1B4_${obj.accCompanyCode}${dlangStr}`
      /*   console.log(`${baseUrl.eshopopee}`)
       console.log(url)
       openConfirm(i18n.tkey("lang_about_jump_to")+" AIChat", () => {
         // location.href = url
         myUtil.goURLNewWindow(url, "AIChat")
       })
       */
       window.open(url, 'AIChat','resizable,height=680,width=370')
      /*
      const window2 = window.open("", 'AIChat','resizable,height=680,width=370')
            setTimeout(() => {
              window2.location.href = url
            }, 1000)

             hallAIChat.value = true
           AIChatSrc.value = `${baseUrl.SSL}://${baseUrl.eshopopee}/AIPage/AISales.asp?ChatCom=CCA5C1B4_${obj.accCompanyCode}`
           // console.log(obj)
              //(obj.login)
              bottomInteractionUiVisible.value = false
              upperRightUiVisible.value = false
              nippleViewVisible.value = false

              controlFlag = false*/
    }
    function gostoreWebsiteCallBack(obj){
      seleteStor.value = null
      companySelectorVisible.value = false

      bottomInteractionUiVisible.value = false
      upperRightUiVisible.value = false
      nippleViewVisible.value = false

      controlFlag = false
      openConfirm(`${i18n.tkey("lang_go_eshopopee_shop_confrim_1")} ${obj.companyName} ${i18n.tkey("lang_go_shop_confirm_3")}`, () => {

        savePersonPosition()

        const url = myUtil.generateEshopopeeLoginAndJumpUrl(
            "/three",
            myUtil.isEmpty(userInfoRef.value.login) ? "" : userInfoRef.value.login,
            myUtil.isEmpty(userInfoRef.value.password) ? "" : userInfoRef.value.password,
            [obj.accCompanyCode]
        )

        myUtil.goURLNewWindow(url, "eshopopee")
        // proxy.$router.push({path: `/pe/${obj.companyHallId}`})
      })
    }
    function generateWalker(){
        const texture = texLoader.load(process.env.BASE_URL + 'mytextures/dummy.png', (texture) => {
            texture.colorSpace = THREE.SRGBColorSpace
            // texture.flipY = false
            // texture.generateMipmaps = false
            // texture.center.set(0.5, 0.5)
            // texture.rotation = Math.PI
        })
        const texture2 = texLoader.load(process.env.BASE_URL + 'mytextures/dummy2.png', (texture) => {
            texture.colorSpace = THREE.SRGBColorSpace
            // texture.flipY = false
            // texture.generateMipmaps = false
            // texture.center.set(0.5, 0.5)
            // texture.rotation = Math.PI
        })
        const padGeometry = new THREE.PlaneGeometry(0.3, 0.9)
        const material = new THREE.MeshBasicMaterial({
            map: texture,
            // color: 0xff0000,
            side: THREE.DoubleSide,
            opacity: 1,
            transparent: true
        })

        const material2 = new THREE.MeshBasicMaterial({
            map: texture2,
            // color: 0xff0000,
            side: THREE.DoubleSide,
            opacity: 1,
            transparent: true
        })

        generateInitPositionLine_1(padGeometry, material, material2, 0)
        generateInitPositionLine_2(padGeometry, material, material2, 25)
        generateInitPositionLine_3(padGeometry, material, material2, 37)
        generateInitPositionLine_4(padGeometry, material, material2, 49)
        generateInitPositionLine_5(padGeometry, material, material2, 61)
        generateInitPositionLine_6(padGeometry, material, material2, 73)

    }

    function getCardListFunc() {
        const request = cardApi.queryMemberworkAll
        const params = request.getParams()

        request.send(params, (res) => {
            if (res.code == 200){
                allCardList = res.detail
                generateWalker()
            }
        })

    }

    function createWalkerNamePad(mesh, index){
        const data = allCardList[index]

        if(null == data.name || "" === data.name){
            return
        }

        Promise.all([
            loadImage(process.env.BASE_URL + "mytextures/name_pad.png")
        ]).then((images) => {
            const regex = /[A-Za-z0-9]/g;

            //创建名牌
            let text2 = data.name

            if (myUtil.isNotEmpty(data.country)){
                const obj = getCountryObj(data.country)

                text2 = `${obj[userInfoRef.value.lang]} ${text2}`
            }

            let fontsize = 110 / (text2.length - (text2.match(regex) || []).length * 0.5);
            let xLeft

            if (fontsize > 40){
                fontsize = 40
            }

            // xLeft = 5 + (110 - fontsize * text.length) / 2

            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext('2d')

            canvas.width = 120
            canvas.height = 40
            //制作矩形
            // ctx.fillStyle = "transparent";
            // ctx.fillRect(0, 0, 120, 60)
            ctx.drawImage(images[0], 0, 0, 120, 40)
            //设置文字
            ctx.fillStyle = "white";
            ctx.font = `normal ${fontsize}px "楷体"`
            var textWidth = ctx.measureText(text2).width;
            xLeft = 5 + (110 - textWidth) / 2
            ctx.fillText(text2, xLeft, (34 + fontsize) / 2)

            //生成图片
            let url = canvas.toDataURL('image/png');
            //将图片构建到纹理中
            const material = new THREE.SpriteMaterial({
                map: texLoader.load(url),
                // side: THREE.DoubleSide,
                opacity: 1,
                transparent: true
            })

            const sprite = new THREE.Sprite(material)
            sprite.position.y = 1.1

            sprite.scale.x = 1.5
            sprite.scale.y = 0.5

            sprite.name = "shopman_name_sprite"

            mesh.add(sprite)
            canvas.remove()

            // clickVisibleList.push(sprite)
            interactionList.push(sprite)
            interactionObj[sprite.uuid] = [{
                callback: () => {
                    personCardObj.value = data
                }
            }]
        })
    }

    function closePersonCardCallback(){
        personCardObj.value = null
    }

    function personCardGoLoginCallback() {
        personCardObj.value = null
        goLogin()
    }

    function personCardGoChatCallback(login){
        personCardObj.value = null
        openNewChat(login)
    }

    function personCardGoMaterialChatCallback(login, url){
        personCardObj.value = null
        proxy.$refs.shopopeePhone.goMaterialChat(login, url)
    }

    function generateInitPositionLine_1(padGeometry, material, material2, arrayIndex) {
        const x = 0
        const y = 0.6

        const list = []

        for (let i = 0; i < 3; i++){
            for (let n = 0; n < 8; n++){
                const mesh = new THREE.Mesh(padGeometry, material)

                mesh.position.z = 20 + 5 * i
                mesh.position.y = y

                scene.add(mesh)
                list.push(mesh)

                mesh.position.x = -17.5 + n * 5

                const v3 = new THREE.Vector3(Math.random() * 2 - 1, 0, Math.random() * 2 - 1)
                v3.normalize()

                const maxOffsetX = 2.5
                const minOffsetX = -2.5
                const maxOffsetZ = 2.5
                const minOffsetZ = -2.5

                const offsetZ = minOffsetZ + Math.random() * maxOffsetZ * 2
                mesh.position.z += offsetZ

                const key = `walker_${mesh.uuid}`
                const withAIObj = {
                    model: mesh,
                    positionY: mesh.position.y,
                    offsetX: 0,
                    offsetY: 0.5 * Math.random(),
                    offsetZ: offsetZ,
                    startX: mesh.position.x,
                    startY: mesh.position.y,
                    startZ: mesh.position.z,
                    YDirect: 1,
                    YSet: 0,
                    v3: v3,
                    maxOffsetX: maxOffsetX,
                    minOffsetX: minOffsetX,
                    maxOffsetZ: maxOffsetZ,
                    minOffsetZ: minOffsetZ,
                    AI: walkerAI
                }

                WithAIObjSet[key] = withAIObj

                if (allCardList.length > 0){
                    const dataIndex = (i * 5 + n + arrayIndex) % allCardList.length
                    createWalkerNamePad(mesh, dataIndex)

                    const data = allCardList[dataIndex]

                    if (data.memmale != 0){
                        mesh.material = material2
                    }

                    // clickVisibleList.push(mesh)
                    interactionList.push(mesh)
                    interactionObj[mesh.uuid] = [{
                        callback: () => {
                            personCardObj.value = data
                        }
                    }]
                }

                // const gui = new GUI()
                // gui.add(mesh.position, "x").step(1)
                // gui.add(mesh.position, "y").step(1)
                // gui.add(mesh.position, "z").step(1)
            }
        }
    }

    function generateInitPositionLine_2(padGeometry, material, material2, arrayIndex) {
        // const x = 0
        const y = 0.6

        const list = []

        if (arrayIndex == null){
            arrayIndex = 0
        }

        for (let i = 0; i < 1; i++){
            for (let n = 0; n < 12; n++){
                const mesh = new THREE.Mesh(padGeometry, material)

                mesh.position.x = -19 + 2 * i
                mesh.position.y = y

                scene.add(mesh)
                list.push(mesh)

                mesh.position.z = -31 + n * 4

                const maxOffsetX = 1
                const minOffsetX = -1
                const maxOffsetZ = 2
                const minOffsetZ = -2

                const offsetZ = minOffsetZ + Math.random() * maxOffsetZ * 2
                mesh.position.z += offsetZ

                const v3 = new THREE.Vector3(Math.random() * 2 - 1, 0, Math.random() * 2 - 1)
                v3.normalize()

                const key = `walker_${mesh.uuid}`
                const withAIObj = {
                    model: mesh,
                    positionY: mesh.position.y,
                    offsetX: 0,
                    offsetY: 0.5 * Math.random(),
                    offsetZ: offsetZ,
                    startX: mesh.position.x,
                    startY: mesh.position.y,
                    startZ: mesh.position.z,
                    YDirect: 1,
                    YSet: 0,
                    v3: v3,
                    maxOffsetX: maxOffsetX,
                    minOffsetX: minOffsetX,
                    maxOffsetZ: maxOffsetZ,
                    minOffsetZ: minOffsetZ,
                    AI: walkerAI
                }

                WithAIObjSet[key] = withAIObj

                if (allCardList.length > 0){
                    const dataIndex = (i * 5 + n + arrayIndex) % allCardList.length
                    createWalkerNamePad(mesh, dataIndex)

                    const data = allCardList[dataIndex]

                    if (data.memmale != 0){
                        mesh.material = material2
                    }

                    // clickVisibleList.push(mesh)
                    interactionList.push(mesh)
                    interactionObj[mesh.uuid] = [{
                        callback: () => {
                            personCardObj.value = data
                        }
                    }]
                }

            }
        }
    }

    function generateInitPositionLine_3(padGeometry, material, material2, arrayIndex) {
        const y = 0.6

        const list = []

        if (arrayIndex == null){
            arrayIndex = 0
        }

        for (let i = 0; i < 1; i++){
            for (let n = 0; n < 12; n++){
                const mesh = new THREE.Mesh(padGeometry, material)

                mesh.position.x = 16 + 2 * i
                mesh.position.y = y

                scene.add(mesh)
                list.push(mesh)

                mesh.position.z = -31 + n * 4

                const maxOffsetX = 1
                const minOffsetX = -1
                const maxOffsetZ = 2.5
                const minOffsetZ = -2.5

                const offsetZ = minOffsetZ + Math.random() * maxOffsetZ * 2
                mesh.position.z += offsetZ

                const v3 = new THREE.Vector3(Math.random() * 2 - 1, 0, Math.random() * 2 - 1)
                v3.normalize()

                const key = `walker_${mesh.uuid}`
                const withAIObj = {
                    model: mesh,
                    positionY: mesh.position.y,
                    offsetX: 0,
                    offsetY: 0.5 * Math.random(),
                    offsetZ: offsetZ,
                    startX: mesh.position.x,
                    startY: mesh.position.y,
                    startZ: mesh.position.z,
                    YDirect: 1,
                    YSet: 0,
                    v3: v3,
                    maxOffsetX: maxOffsetX,
                    minOffsetX: minOffsetX,
                    maxOffsetZ: maxOffsetZ,
                    minOffsetZ: minOffsetZ,
                    AI: walkerAI
                }

                WithAIObjSet[key] = withAIObj

                if (allCardList.length > 0){
                    const dataIndex = (i * 5 + n + arrayIndex) % allCardList.length
                    createWalkerNamePad(mesh, dataIndex)

                    const data = allCardList[dataIndex]

                    if (data.memmale != 0){
                        mesh.material = material2
                    }

                    // clickVisibleList.push(mesh)
                    interactionList.push(mesh)
                    interactionObj[mesh.uuid] = [{
                        callback: () => {
                            personCardObj.value = data
                        }
                    }]
                }

            }
        }
    }

    function generateInitPositionLine_4(padGeometry, material, material2, arrayIndex) {
        const y = 5.6

        const list = []

        if (arrayIndex == null){
            arrayIndex = 0
        }

        for (let i = 0; i < 1; i++){
            for (let n = 0; n < 12; n++){
                const mesh = new THREE.Mesh(padGeometry, material)

                mesh.position.x = 18 + 2 * i
                mesh.position.y = y

                scene.add(mesh)
                list.push(mesh)

                mesh.position.z = -31 + n * 5

                const maxOffsetX = 1
                const minOffsetX = -1
                const maxOffsetZ = 2.5
                const minOffsetZ = -2.5

                const offsetZ = minOffsetZ + Math.random() * maxOffsetZ * 2
                mesh.position.z += offsetZ

                const v3 = new THREE.Vector3(Math.random() * 2 - 1, 0, Math.random() * 2 - 1)
                v3.normalize()

                const key = `walker_${mesh.uuid}`
                const withAIObj = {
                    model: mesh,
                    positionY: mesh.position.y,
                    offsetX: 0,
                    offsetY: 0.5 * Math.random(),
                    offsetZ: offsetZ,
                    startX: mesh.position.x,
                    startY: mesh.position.y,
                    startZ: mesh.position.z,
                    YDirect: 1,
                    YSet: 0,
                    v3: v3,
                    maxOffsetX: maxOffsetX,
                    minOffsetX: minOffsetX,
                    maxOffsetZ: maxOffsetZ,
                    minOffsetZ: minOffsetZ,
                    AI: walkerAI
                }

                WithAIObjSet[key] = withAIObj

                if (allCardList.length > 0){
                    const dataIndex = (i * 5 + n + arrayIndex) % allCardList.length
                    createWalkerNamePad(mesh, dataIndex)

                    const data = allCardList[dataIndex]

                    if (data.memmale != 0){
                        mesh.material = material2
                    }

                    // clickVisibleList.push(mesh)
                    interactionList.push(mesh)
                    interactionObj[mesh.uuid] = [{
                        callback: () => {
                            personCardObj.value = data
                        }
                    }]
                }

            }
        }
    }

    function generateInitPositionLine_5(padGeometry, material, material2, arrayIndex) {
        const y = 5.6

        const list = []

        if (arrayIndex == null){
            arrayIndex = 0
        }

        for (let i = 0; i < 1; i++){
            for (let n = 0; n < 12; n++){
                const mesh = new THREE.Mesh(padGeometry, material)

                mesh.position.x = -17.5 + 2 * i
                mesh.position.y = y

                scene.add(mesh)
                list.push(mesh)

                mesh.position.z = -31 + n * 5

                const maxOffsetX = 1
                const minOffsetX = -1
                const maxOffsetZ = 2.5
                const minOffsetZ = -2.5

                const offsetZ = minOffsetZ + Math.random() * maxOffsetZ * 2
                mesh.position.z += offsetZ

                const v3 = new THREE.Vector3(Math.random() * 2 - 1, 0, Math.random() * 2 - 1)
                v3.normalize()

                const key = `walker_${mesh.uuid}`
                const withAIObj = {
                    model: mesh,
                    positionY: mesh.position.y,
                    offsetX: 0,
                    offsetY: 0.5 * Math.random(),
                    offsetZ: offsetZ,
                    startX: mesh.position.x,
                    startY: mesh.position.y,
                    startZ: mesh.position.z,
                    YDirect: 1,
                    YSet: 0,
                    v3: v3,
                    maxOffsetX: maxOffsetX,
                    minOffsetX: minOffsetX,
                    maxOffsetZ: maxOffsetZ,
                    minOffsetZ: minOffsetZ,
                    AI: walkerAI
                }

                WithAIObjSet[key] = withAIObj

                if (allCardList.length > 0){
                    const dataIndex = (i * 5 + n + arrayIndex) % allCardList.length
                    createWalkerNamePad(mesh, dataIndex)

                    const data = allCardList[dataIndex]

                    if (data.memmale != 0){
                        mesh.material = material2
                    }

                    // clickVisibleList.push(mesh)
                    interactionList.push(mesh)
                    interactionObj[mesh.uuid] = [{
                        callback: () => {
                            personCardObj.value = data
                        }
                    }]
                }

            }
        }
    }

    function generateInitPositionLine_6(padGeometry, material, material2, arrayIndex) {
        const x = 0
        const y = 5.6

        const list = []

        for (let i = 0; i < 1; i++){
            for (let n = 0; n < 8; n++){
                const mesh = new THREE.Mesh(padGeometry, material)

                mesh.position.z = 33 + 5 * i
                mesh.position.y = y

                scene.add(mesh)
                list.push(mesh)

                mesh.position.x = -17.5 + n * 5

                const v3 = new THREE.Vector3(Math.random() * 2 - 1, 0, Math.random() * 2 - 1)
                v3.normalize()

                const maxOffsetX = 2.5
                const minOffsetX = -2.5
                const maxOffsetZ = 1
                const minOffsetZ = -1

                const offsetZ = minOffsetZ + Math.random() * maxOffsetZ * 2
                mesh.position.z += offsetZ

                const key = `walker_${mesh.uuid}`
                const withAIObj = {
                    model: mesh,
                    positionY: mesh.position.y,
                    offsetX: 0,
                    offsetY: 0.5 * Math.random(),
                    offsetZ: offsetZ,
                    startX: mesh.position.x,
                    startY: mesh.position.y,
                    startZ: mesh.position.z,
                    YDirect: 1,
                    YSet: 0,
                    v3: v3,
                    maxOffsetX: maxOffsetX,
                    minOffsetX: minOffsetX,
                    maxOffsetZ: maxOffsetZ,
                    minOffsetZ: minOffsetZ,
                    AI: walkerAI
                }

                WithAIObjSet[key] = withAIObj

                if (allCardList.length > 0){
                    const dataIndex = (i * 5 + n + arrayIndex) % allCardList.length
                    createWalkerNamePad(mesh, dataIndex)

                    const data = allCardList[dataIndex]

                    if (data.memmale != 0){
                        mesh.material = material2
                    }

                    // clickVisibleList.push(mesh)
                    interactionList.push(mesh)
                    interactionObj[mesh.uuid] = [{
                        callback: () => {
                            personCardObj.value = data
                        }
                    }]
                }

                // const gui = new GUI()
                // gui.add(mesh.position, "x").step(1)
                // gui.add(mesh.position, "y").step(1)
                // gui.add(mesh.position, "z").step(1)
            }
        }
    }

    function walkerAI(obj) {
        obj.model.lookAt(meshGroup.position)

        const distance = meshGroup.position.distanceTo(obj.model.position)

        if (distance > 80 || distance < 2.5){
            obj.model.visible = false
        }else{
            obj.model.visible = true
        }

        const moveDistance = mixerUpdateDelta * 1
        const moveDistanceY = mixerUpdateDelta * 0.2

        obj.offsetX += moveDistance * obj.v3.x
        obj.offsetY += moveDistanceY * obj.YDirect
        obj.offsetZ += moveDistance * obj.v3.z

        let flag = false

        if (obj.offsetX >= obj.maxOffsetX){
            obj.offsetX = obj.maxOffsetX
            flag = true
        }else if(obj.offsetX <= obj.minOffsetX){
            obj.offsetX = obj.minOffsetX
            flag = true
        }

        if (obj.offsetY >= 0.15){
            obj.offsetY = 0.15
            obj.YDirect = -1
        }else if(obj.offsetY <= 0){
            obj.offsetY = 0
            obj.YDirect = 1
        }

        if (obj.offsetZ >= obj.maxOffsetZ){
            obj.offsetZ = obj.maxOffsetZ
            flag = true
        }else if(obj.offsetZ <= obj.minOffsetZ){
            obj.offsetZ = obj.minOffsetZ
            flag = true
        }

        obj.model.position.x = obj.startX + obj.offsetX

        if (userInfoRef.value.vp){
            obj.model.position.y = obj.startY + obj.offsetY
        }else{
            obj.model.position.y = -999
        }

        obj.model.position.z = obj.startZ + obj.offsetZ

        if (flag){
            obj.v3 = new THREE.Vector3(Math.random() * 2 - 1, 0, Math.random() * 2 - 1)
            obj.v3.normalize()
        }
    }

    provide('threeHallFunc', {
        goShopHallPosition,
        phoneGoFloorCallback,
        getHallOperateMode,
        setHallOperateMode,
        getHallObj
    })

    onBeforeMount(() => {
        // if (null != props.hid && props.hid != userInfoRef.value.hid){

        if (null != pageInfoRef.value.hid){
            pageInfoRef.value.hid = null
            regionMap.currPage = pageInfoRef.value.fid
            regionMap.selectShopIndex = pageInfoRef.value.did
            pageInfoRef.value.fid = null
            pageInfoRef.value.did = null
            fromPEFlag = true
        }

        if (null != props.hid){
            userInfoRef.value.hid = props.hid
            userInfoRef.value.fid = null
            userInfoRef.value.hallPositionX = null
            userInfoRef.value.hallPositionZ = null
            userInfoRef.value.did = null
        }

        if (null != props.fid && null == userInfoRef.value.fid){
            userInfoRef.value.fid = props.fid
        }

        if (null != props.fid){
            regionMap.currPage = props.fid
        }

        if (null != props.did && null == userInfoRef.value.did){
            userInfoRef.value.did = props.did
            regionMap.selectShopIndex = props.did
        }

        if (null == props.hid){
            hallSelectorVisible.value = true
        }

        if (null == userInfoRef.value.speed){
            userInfoRef.value.speed = 0.24
        }
    })

    onMounted(() => {
        initValue()
    })

    //清除three.js占用的内存
    onBeforeUnmount(() => {
        timeStamp = -65535

        //銷毀搖桿
        if (null != nippleObj){
            nippleObj.destroy()
        }

        console.log("开始清除内存")

        document.getElementById("three").removeEventListener('touchmove', handleDefaultTouchEvt)
        document.removeEventListener('keydown', onKeyDown)
        document.removeEventListener('keyup', onKeyUp)
        document.getElementById("three").removeEventListener('touchmove', mouseMoveEvent)
        document.getElementById("three").removeEventListener('touchstart', mouseDownEvent)
        document.getElementById("three").removeEventListener('touchend', mouseUpEvent)
        document.getElementById("three").removeEventListener('mousemove', mouseMoveEvent)
        document.getElementById("three").removeEventListener('mousedown', mouseDownEvent)
        document.getElementById("three").removeEventListener('mouseup', mouseUpEvent)
        document.getElementById("three").removeEventListener('click', mouseClickEvent)

        // stats.domElement.remove()

        try {
            funcListObj = {}

            cancelAnimationFrame(animationFrameId); // animationFrameId = requestAnimationFrame(this.render);
            render.dispose();
            render.forceContextLoss();
            render.content = null;
            let gl = render.domElement.getContext("webgl");
            if (gl && gl.getExtension("WEBGL_lose_context")) {
                gl.getExtension("WEBGL_lose_context").loseContext();
            }
            render = null;
            camera = null;
            scene.traverse((child) => {
                try {
                    if (child.material && null != child.material) {
                        child.material.dispose();
                    }
                }catch (e) {
                    console.log(e)
                }

                try {
                    if (child.geometry && null != child.geometry) {
                        child.geometry.dispose();
                    }
                }catch (e) {
                    console.log(e)
                }


                child = null;
            });
            scene = null;

            THREE.Cache.clear()
        } catch (e) {
            console.error('Failed to destroy threejs', e);
        }

        //刪除render dom
        document.getElementById("three").innerHTML = ""
    })
</script>

<style scoped>

    ul{
        list-style: none;
        padding-left: 0;
        margin: 0;
    }

    .select-area-box {
        position: absolute;
        z-index: 400;
        width: 100%;
        height: 100%;
        background: #00000091;
        display: flex;
        left: 0;
        top: 0;
        align-items: center;
        justify-content: center;
    }

    @media screen and (min-width: 520px) {
        .select-area-box .select-area-div {
            /*width: 50%;*/
            width: 280px;
            height: 60%;
            padding: 20px;
            border-radius: 15px;
            background: #fefefe;
            font-size: 18px;
            color: #4e486d;
            font-weight: 800;
            user-select: none;

            box-sizing: border-box;
            position: relative;
        }
    }

    @media screen and (max-width: 520px) {
        .select-area-box .select-area-div {
            /*width: 85%;*/
            width: 280px;
            height: 60%;
            padding: 20px;
            border-radius: 15px;
            background: #fefefe;
            font-size: 18px;
            color: #4e486d;
            font-weight: 800;
            user-select: none;

            box-sizing: border-box;
            position: relative;
        }
    }

    .select-area-box .select-area-div .select-ul {
        width: 100%;
        height: 100%
    }

    .select-area-box .select-area-div .select-ul .title-part {
        height: 30px;
    }

    .select-area-box .select-area-div .select-ul .content-part {
        height: calc(100% - 105px);
        /*display: flex;*/
        /*align-items: center;*/

        overflow-y: auto;

    }

    .select-area-box .select-area-div .select-ul .btns-part {
        height: 30%;
        display: flex;
        align-items: flex-end;
    }

    .select-area-box .select-input-part {
        display: flex;
        justify-content: center;
        /*margin-top: 20%;*/
        width: 100%;
    }

    .select-area-box .operation-box{
        display: flex;
        justify-content: space-around;
        align-items: center;
        height: 30px;
        /*margin-top: 20%;*/
        user-select: none;

        width: 100%;
    }

    .select-area-box .operation-box .btn-box{
        padding: 5px 25px;
        border-radius: 5px;
    }

    .select-area-box .operation-box .sure-box{
        border: 1px #d6e9c6 solid;
        background: #d6e9c6;
        color: #3c763d;
    }

    .select-area-box .operation-box .sure-box:hover{
        border: 1px #3c763d solid;
        background: #3c763d;
        color: #d6e9c6;
    }

    .select-area-box .operation-box .refuse-box{
        border: 1px #ebccd1 solid;
        background: #ebccd1;
        color: #a94442;
    }

    .select-area-box .operation-box .refuse-box:hover{
        border: 1px #a94442 solid;
        background: #a94442;
        color: #ebccd1;
    }

    @media screen and (min-width: 520px) {
        .interaction-ui-upperRight {
            position: absolute;
            top: 20px;
            width: 100%;
            /*padding-right: 20px;*/
            display: flex;
            justify-content: flex-end;
            align-items: center;
            text-align: center;
            box-sizing: border-box;
            font-size: 12px;
            user-select: none;

        }
    }

    @media screen and (max-width: 520px) {
        .interaction-ui-upperRight {
            position: absolute;
            top: 20px;
            right: 10px;
            width: 40px;
            /*padding-right: 20px;*/
            display: flex;
            justify-content: flex-end;
            align-items: center;
            text-align: center;
            box-sizing: border-box;
            font-size: 12px;
            user-select: none;
            flex-wrap: wrap;
        }
    }

    @media screen and (min-width: 520px) {
        .interaction-ui-upperLeft {
            width: 30%;
            justify-content: flex-start;
            padding-left: 10px;
        }
    }

    @media screen and (max-width: 520px) {
        .interaction-ui-upperLeft {
            left: 10px;
        }
    }

    @media screen and (min-width: 520px) {
        /*.interaction-ui-upperRight .icon-part {*/
        /*    width: 60px;*/
        /*    height: 60px;*/
        /*    background: #ffffff;*/
        /*    border-radius: 50%;*/
        /*    border: #2c3e50;*/
        /*    margin-right: 20px;*/
        /*}*/

        /*.interaction-ui-upperRight .icon-part .icon-text {*/
        /*    margin-top: 10px;*/
        /*    font-size: 20px;*/
        /*    pointer-events: none;*/
        /*}*/

        /*.interaction-ui-upperRight .icon-part .icon-span {*/
        /*    pointer-events: none;*/
        /*}*/

        .interaction-ui-upperRight .icon-part {
            width: 40px;
            height: 40px;
            background: #ffffff;
            border-radius: 50%;
            border: #2c3e50;
            margin-right: 10px;
            /*margin-bottom: 10px;*/
        }

        .interaction-ui-upperRight .icon-part .icon-text {
            margin-top: 10px;
            font-size: 20px;
            pointer-events: none;
        }

        .interaction-ui-upperRight .icon-part .icon-span {
            display: none;
            pointer-events: none;
        }
    }

    @media screen and (max-width: 520px) {
        .interaction-ui-upperRight .icon-part {
            width: 40px;
            height: 40px;
            background: #ffffff;
            border-radius: 50%;
            border: #2c3e50;
            /*margin-right: 20px;*/
            margin-bottom: 10px;
        }

        .interaction-ui-upperRight .icon-part .icon-text {
            margin-top: 10px;
            font-size: 20px;
            pointer-events: none;
        }

        .interaction-ui-upperRight .icon-part .icon-span {
            display: none;
            pointer-events: none;
        }
    }


    @media screen and (min-width: 520px) {
        .show-material-ui-upper {
            position: absolute;
            top: 20px;
            width: 400px;
            height: 168px;
            z-index: 20;
            left: calc(50% - 200px);
            text-align: center;
            box-sizing: border-box;
            user-select: none;
            animation: show-top-material-animation 1s ease;
        }
    }

    @media screen and (max-width: 520px) {
        .show-material-ui-upper {
            position: absolute;
            top: 20px;
            width: 90%;
            height: 168px;
            z-index: 20;
            left: 5%;
            text-align: center;
            box-sizing: border-box;
            user-select: none;
            animation: show-top-material-animation 1s ease;
        }
    }


    @keyframes show-top-material-animation {

        0% {
            opacity: 0.5;
            top: -80px;
        }

        100% {
            opacity: 1;
            top: 20px;
        }

    }



    .loading_point_small{
        width: 2000px;
        height: 2000px;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border-radius: 50%;
        margin: auto;
        background-color: aliceblue;
        position: absolute;
        /* transition: all 1s ease; */
    }
    .loading_point_big{
        width: 50px;
        height: 50px;
        position: absolute;
        margin: auto;
        border-radius: 50%;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: aliceblue;
        transform: scale(0.05);
        transition: all 2s ease;
        /* animation: point_big_ball 5s ease; */
    }
    @keyframes point_big_ball {
        0% {
            width: 100%;
            height: 100%;
        }
        100% {
            width: 100px;
            height: 100px;
        }
    }

    @media screen and (min-width: 520px) {
        .interaction-searchInput-upperRight {
            position: absolute;
            top: 10px;
            left: calc(50% - 150px);
            width: 300px;
            display: inline-block;
        }

        .top-search-input {
            display: inline-block;
            /*margin-right: 20px;*/
            opacity: 0.7;
        }
    }

    @media screen and (max-width: 520px) {
        .interaction-searchInput-upperRight {
            position: absolute;
            top: 10px;
            left: calc(50% - 100px);
            /*left: 0;*/
            width: calc(100% - 200px);
            text-align: left;
            padding-left: 20px;
            display: inline-block;
        }

        .top-search-input {
            display: inline-block;
            /*width: 50%;*/
            margin-right: 25px;
            margin-top: 5px;
            opacity: 0.7;
        }
    }


    .loading_ring{
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        width:5em;
        height:5em;
        background:transparent;
        border:3px solid #b20bff;
        border-radius:50%;
        text-align:center;
        line-height:5em;
        font-family:sans-serif;
        font-size:20px;
        color:#03a9f4;
        letter-spacing:4px;
        text-transform:uppercase;
        text-shadow:0 0 10px #03a9f4;
        box-shadow:0 0 20px rgba(0,0,0,.5);
    }

    .loading_ring:before{
        content:'';
        position:absolute;
        top:-3px;
        left:-3px;
        width:100%;
        height:100%;
        border:3px solid transparent;
        border-top:3px solid #03a9f4;
        border-right:3px solid #03a9f4;
        border-radius:50%;
        animation:animateC 2s linear infinite;
    }

    @media screen and (max-width: 800px) {
        /*input[type=text],textarea,.ivu-select{*/
        /*  font-size: 18px !important;*/
        /*  text-size-adjust: none;*/
        /*  -webkit-appearance: none;*/
        /*}*/

        input,textarea,.ivu-select{
            font-size: 18px !important;
            text-size-adjust: none;
            -webkit-appearance: none;
        }
    }

    .shop-man-name-div {
        position: relative;
        z-index: 200;
        /*width: 400px;*/
        /*height: 200px;*/
        padding: 15px 30px;
        border: 1px solid #55A3A3;
        /*left: 50px;*/
        /*top: 50px;*/
        background: #00000042;
        text-align: center;
        color: #fff;
        display: inline-block;
        user-select: none;

    }

    .shop-man-name-div span:nth-child(1){
        position: absolute;
        left: -3px;
        top: -3px;
        padding: 8px;
        border-style: solid;
        border-color: #28ffff;
        border-width: 3px 0 0 3px;
    }
    /*.shop-man-name-div span:nth-child(2){*/
    /*    position: absolute;*/
    /*    right: -5px;*/
    /*    top: -5px;*/
    /*    padding: 15px;*/
    /*    border-style: solid;*/
    /*    border-color: #28ffff;*/
    /*    border-width: 5px 5px 0 0;*/
    /*}*/
    .shop-man-name-div span:nth-child(2){
        position: absolute;
        right: -3px;
        bottom: -3px;
        padding: 8px;
        border-style: solid;
        border-color: #28ffff;
        border-width: 0 3px 3px 0;
    }
    /*.shop-man-name-div span:nth-child(4){*/
    /*    position: absolute;*/
    /*    left: -5px;*/
    /*    bottom: -5px;*/
    /*    padding: 15px;*/
    /*    border-style: solid;*/
    /*    border-color: #28ffff;*/
    /*    border-width: 0 0 5px 5px;*/
    /*}*/

    .hide-phone {
        margin-top: 0vh;
    }

    @media screen and (min-width: 520px) {
        .show-phone {
            /*margin-top: -420px;*/
            /*margin-top: -40vmin;*/
            margin-top: 0;
            //top: 10% !important;
        }
    }

    @media screen and (max-width: 520px) {
        .show-phone {
            /*margin-top: calc(-100% + 120px )*/
            margin-top: 0;
            //top: 10% !important;
        }
    }

    .shopopee-chat-view {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: all 1.5s ease;
        overflow: hidden;
        z-index: 301;
    }

    @media screen and (min-width: 520px) {
        .shopopee-chat-view .close-div {
            display: inline-block;
            font-size: 24px;
            line-height: 50px;
            color: white;
            position: absolute;
            /*left: 50%;*/
            top:  -25px;
            right:0;
            /*margin-top: -400px;*/
            /*margin-left: 275px;*/
            border-radius: 50%;
            width: 50px;
            height: 50px;
            text-shadow: 0 1px 0 #484f58;
          border: 1px solid #734e4e;
          background-color: red;
            //border: 1px solid #734e4e;
            //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
            //background: -webkit-linear-gradient(top, #e92323, #551d1d);
            /*transition: all 1.5s ease;*/
            z-index: 100;
        }
    }

    @media screen and (max-width: 520px) {
        .shopopee-chat-view .close-div {
            display: inline-block;
            font-size: 30px;
            line-height: 40px;
            color: white;
            position: absolute;
            right: 3px;
            top: -20px;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            text-shadow: 0 1px 0 #484f58;
          border: 1px solid #734e4e;
          background-color: red;
            //border: 1px solid #734e4e;
            //box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
            //background: -webkit-linear-gradient(top, #e92323, #551d1d);
            /*transition: all 1.5s ease;*/
            z-index: 100;
        }
    }

    .shopopee-chat-view .close-div-hide {
        opacity: 0;
        transform: scale(0.5);
        animation: hide-shopopee-chat-close-div 0.5s ease;
    }

    @keyframes hide-shopopee-chat-close-div {

        0% {
            opacity: 1;
            transform: scale(1);
        }

        100% {
            opacity: 0;
            transform: scale(0.5);
        }

    }

    .shopopee-chat-view .close-div-show {
        opacity: 1;
        transform: scale(1);
        animation: show-shopopee-chat-close-div 0.5s ease;
    }

    @keyframes show-shopopee-chat-close-div {

        0% {
            opacity: 0;
            transform: scale(0.5);
        }

        75% {
            opacity: 0;
            transform: scale(0.5);
        }

        100% {
            opacity: 1;
            transform: scale(1);
        }

    }

    .shopopee-chat-view-extend {
        background: #00000050;
    }

    .shopopee-chat-view-retract {
        background: #ffffff00;
    }

    .close-material-box-btn {
        display: inline-block;
        position: absolute;
        top: -20px;
        right: -20px;
        font-size: 20px;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        text-shadow: 0 1px 0 #484f58;
        border: 1px solid #734e4e;
        box-shadow: 0 1px 0 #616a74 inset, 0 1px 5px #212528;
        background: -webkit-linear-gradient(top, #e92323, #551d1d);
        color: #ffffff;
        line-height: 30px;
    }

    .select-floor-btn-group-box {
        display: flex;
        justify-content: center;
        width: 100%;
    }

    .select-floor-btn-group-box .select-floor-btn-group {
        width: 110px;
    }

    .select-floor-btn-group-box .select-floor-btn-group .select-floor-btn {
        margin-bottom: 15px;
        margin-top: 15px;
    }

    .select-floor-btn {
        margin-bottom: 20px;
        margin-top: 20px;
    }

    @media screen and (min-width: 768px) {
        .person-editor-box {
            position: absolute;
            width: 100%;
            height: 100%;
            //padding: 5%;
            border-radius: 5px;
            box-sizing: border-box;
            top: 0;
            left: 0;
            background: #0000003d;
            z-index: 2000;
        }
    }

    @media screen and (max-width: 768px) {
        .person-editor-box {
            position: absolute;
            width: 100%;
            height: 100%;
            //padding: 5%;
            //padding-top: 25%;
            //padding-bottom: 25%;
            //border-radius: 5px;
            box-sizing: border-box;
            top: 0;
            left: 0;
            background: #0000003d;
            z-index: 2000;
        }
    }
</style>

<style>
    body {
        margin: 0;
    }

    * {
        -webkit-touch-callout:none;
        -moz-touch-callout:none;
        -ms-touch-callout:none;
        touch-callout:none;

        -webkit-touch-callout: none;
        /*pointer-events: none;*/

        -webkit-user-select: none;

    }

    @media screen and (min-width: 520px) {
        .small-scrollbar::-webkit-scrollbar {
            width: 6px;
        }


        /*定义滚动条的轨道颜色、内阴影及圆角*/
        .small-scrollbar::-webkit-scrollbar-track {
            border-radius: 4px;
            /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
            /* background-color: rosybrown; */
        }

        /*定义滑块颜色、内阴影及圆角*/
        .small-scrollbar::-webkit-scrollbar-thumb {
            border-radius: 8px;
            background-color: #dddee0;
            /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3); */
        }

        /*定义滑块悬停变化颜色、内阴影及圆角*/
        .small-scrollbar::-webkit-scrollbar-thumb:hover {
            background-color: #c7c9cc;
        }

        /*定义两端按钮的样式*/
        .small-scrollbar::-webkit-scrollbar-button {
            /* background-color: cyan; */
            display: none;
        }

        /*定义右下角汇合处的样式*/
        .small-scrollbar::-webkit-scrollbar-corner {
            /* background: khaki; */
        }
    }

</style>